// #SPLIT_OPS_V1 — moved out of App.js unchanged (Bill 10/21: get the big files under 10,000 lines).
import { SUPA_URL, sg, ss, todayStr, C, Btn, fmtD, useIsDesktop, PMS, PM_NAMES, isoWeekNum, StatusBadge, ProgressBar } from "./appShared";
import { openPrintView } from './printView';   // #PRINT_VIEW_V1 — view first, then choose Print
import { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { Plus, Trash2, Save } from "lucide-react";
import { LOGO_COLOR_B64, getPipeSize, DAILY_RIGS, uploadLogFile, signLogUrl, LOG_BUCKET, _lfHdr } from "./opsShared";

const fLF = n => { const x = Number(n); return (n != null && n !== '' && !isNaN(x)) ? `${Math.round(x).toLocaleString()}` : '—'; };

const PERRY_SEED_LOGS = {
  "W4516806": {duc:"W4516806",customer:"Austin Engineering",city:"Bee Cave Tx",pm:"Perry Graff",planLF:590,planDays:17,planRev:0,pipeSize:"30\"",reaperSize:"18-36\"",rig:"220X300",startDate:"2026-03-20",tbc:"2026-04-06",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-03-20",day:"Fri",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"MOB",comment:"Moving equipment to job",billed:false},{id:2,date:"2026-03-23",day:"Mon",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"SETUP",soil:"ROCK",comment:"Finished mob setting up",billed:false},{id:3,date:"2026-03-24",day:"Tue",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Pilot",soil:"ROCK",drilledLF:50,stageTotal:50,comment:"Finished setup then drilled to the pit and 40' into the bore",billed:false},{id:4,date:"2026-03-25",day:"Wed",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Pilot",soil:"ROCK",drilledLF:420,stageTotal:470,comment:"Continued pilot 420' for the day",billed:false},{id:5,date:"2026-03-26",day:"Thu",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:200,stageTotal:200,pipeSize:"18",comment:"Finished pilot then reamed 200' on 18\"",billed:false},{id:6,date:"2026-03-27",day:"Fri",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:380,stageTotal:380,pipeSize:"24",comment:"Finished 18\" reamer then reamed 380' on 24\"",billed:false},{id:7,date:"2026-03-28",day:"Sat",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:210,stageTotal:380,pipeSize:"24",comment:"Finished 24\" reamer",billed:false},{id:8,date:"2026-03-30",day:"Mon",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:100,stageTotal:100,pipeSize:"30",comment:"Put 30\" reamer in then reamed 100'",billed:false},{id:9,date:"2026-03-31",day:"Tue",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:200,stageTotal:300,pipeSize:"30",comment:"Worked on rig then reamed 200' for the day",billed:false},{id:10,date:"2026-04-01",day:"Wed",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:290,stageTotal:590,pipeSize:"30",comment:"finished 30\" moving to 36\"",billed:false},{id:11,date:"2026-04-02",day:"Thu",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:240,stageTotal:240,pipeSize:"36",comment:"Started reaming 36\" 240' for the day",billed:false},{id:12,date:"2026-04-03",day:"Fri",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:180,stageTotal:460,pipeSize:"36",comment:"Continued reaming shut down at noon",billed:false},{id:13,date:"2026-04-06",day:"Mon",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:100,stageTotal:560,pipeSize:"36",comment:"Continued reaming 100' for the day",billed:false},{id:14,date:"2026-04-07",day:"Tue",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:30,stageTotal:590,pipeSize:"36",comment:"Finished 36\" reamer hauled off all the mud and put 42\" reamer on",billed:false},{id:15,date:"2026-04-08",day:"Wed",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:160,stageTotal:160,pipeSize:"42",comment:"Reamed 160' for the day",billed:false},{id:16,date:"2026-04-09",day:"Thu",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:20,stageTotal:180,pipeSize:"42",comment:"Had a tool failure solved the problem resume reaming in morning",billed:false},{id:17,date:"2026-04-10",day:"Fri",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:80,stageTotal:260,pipeSize:"42",comment:"Changed reamers pulled to bottom then reamed 80' rain out 3:00",billed:false},{id:18,date:"2026-04-11",day:"Sat",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,comment:"Rain out",billed:false},{id:19,date:"2026-04-13",day:"Mon",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,comment:"Worked on equipment to muddy to get tricked in and out",billed:false},{id:20,date:"2026-04-14",day:"Tue",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:200,stageTotal:460,pipeSize:"42",comment:"Continued reaming then blew Hydrolics hose 200' for the day",billed:false},{id:21,date:"2026-04-15",day:"Wed",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Ream",soil:"ROCK",drilledLF:130,stageTotal:590,pipeSize:"42",comment:"Fixed rig then finished reaming",billed:false},{id:22,date:"2026-04-16",day:"Thu",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Swab",soil:"ROCK",drilledLF:590,stageTotal:590,pipeSize:"42",comment:"Swabbed bore ready to pull in morning",billed:false},{id:23,date:"2026-04-17",day:"Fri",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Pull",soil:"ROCK",drilledLF:590,stageTotal:590,pipeSize:"30",comment:"Pulled pipe",billed:false},{id:24,date:"2026-04-18",day:"Sat",sup:"Ramiro",rig:"220X300",bore:"1",boreLF:590,stage:"Clean",comment:"Cleaning up",billed:false},{id:25,date:"2026-04-20",day:"Mon",sup:"Ramiro",rig:"220X300",bore:"1",comment:"Rain out",billed:false},{id:26,date:"2026-04-21",day:"Tue",sup:"Ramiro",rig:"220X300",comment:"Rain out",billed:false},{id:27,date:"2026-04-22",day:"Wed",sup:"Ramiro",rig:"220X300",stage:"Clean",comment:"Finished cleaning up",billed:false}]},
  "P4605645": {duc:"P4605645",customer:"Bobcat",city:"Lubbock Tx",pm:"Perry",planLF:1284,planDays:109,planRev:0,pipeSize:"6\"",reaperSize:"10\"",rig:"23x30DR",startDate:"2026-04-13",tbc:"2026-07-31",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-04-13",day:"Mon",sup:"Edward",rig:"23x30DR",bore:"1",boreLF:340,stage:"MOB",comment:"Mob to job",billed:false},{id:2,date:"2026-04-14",day:"Tue",sup:"Edward",rig:"23x30DR",bore:"1",boreLF:340,stage:"Pilot",soil:"ROCK",drilledLF:340,stageTotal:340,pipeSize:"6",comment:"Setup dug pits and drilled pilot",billed:false},{id:3,date:"2026-04-15",day:"Wed",sup:"Edward",rig:"23x30DR",bore:"1",boreLF:340,stage:"Ream",soil:"ROCK",drilledLF:340,stageTotal:340,pipeSize:"6",comment:"Waited on bore approval then reamed the bore",billed:false},{id:4,date:"2026-04-16",day:"Thu",sup:"Edward",rig:"23x30DR",bore:"1",boreLF:340,stage:"Pull",soil:"ROCK",drilledLF:340,stageTotal:350,pipeSize:"6",comment:"Pushed out pulled pipe",billed:false},{id:5,date:"2026-04-16",day:"Thu",sup:"Edward",rig:"23x30DR",bore:"2",boreLF:125,stage:"Pilot",soil:"DIRT",drilledLF:125,stageTotal:125,pipeSize:"6",comment:"Setup and drilled out pilot",billed:false},{id:6,date:"2026-04-17",day:"Fri",sup:"Edward",rig:"23x30DR",bore:"2",boreLF:125,stage:"Pull",soil:"DIRT",drilledLF:125,stageTotal:125,pipeSize:"6",comment:"Reamed and pulled pipe",billed:false},{id:7,date:"2026-04-20",day:"Mon",sup:"Edward",rig:"23x30DR",bore:"3",boreLF:95,stage:"Pilot",soil:"DIRT",drilledLF:95,stageTotal:95,pipeSize:"6",comment:"Got badged for airport travel to job and setup",billed:false},{id:8,date:"2026-04-21",day:"Tue",sup:"Edward",rig:"23x30DR",bore:"3",boreLF:95,stage:"Pull",soil:"DIRT",drilledLF:95,stageTotal:95,pipeSize:"6",comment:"Drilled reamed and pulled",billed:false},{id:9,date:"2026-04-22",day:"Wed",sup:"Edward",rig:"23x30DR",bore:"4",boreLF:210,stage:"Ream",soil:"DIRT",drilledLF:210,stageTotal:210,pipeSize:"6",comment:"Drilled and reamed not",billed:false},{id:10,date:"2026-04-23",day:"Thu",sup:"Edward",rig:"23x30DR",bore:"4",boreLF:210,stage:"Pull",soil:"DIRT",drilledLF:210,stageTotal:210,pipeSize:"6",comment:"Pulled pipe",billed:false},{id:11,date:"2026-04-23",day:"Thu",sup:"Edward",rig:"23x30DR",bore:"5",boreLF:81,stage:"Pull",soil:"DIRT",drilledLF:81,stageTotal:81,pipeSize:"6",comment:"Drilled reamed and pulled pipe",billed:false}]},
  "W4433901": {duc:"W4433901",customer:"CASH Construction",city:"Austin, TX",pm:"Perry Graff",planLF:1600,planDays:55,planRev:0,pipeSize:"36\"",reaperSize:"54\"",rig:"330x500",startDate:"2026-03-03",tbc:"2026-04-27",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-03-03",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"SETUP",comment:"Survey clear center line and started setting up",billed:false},{id:2,date:"2026-03-04",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"SETUP",comment:"Finished surgery continued setting up",billed:false},{id:3,date:"2026-03-05",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"SETUP",comment:"Finished setting up bore is approved start pilot in morning",billed:false},{id:4,date:"2026-03-06",day:"Fri",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:240,stageTotal:240,pipeSize:"pilot",comment:"Started pilot drilled 240' start pushing casing Monday",billed:false},{id:5,date:"2026-03-09",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",comment:"Unloaded casing",billed:false},{id:6,date:"2026-03-10",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",comment:"Job shut down for orientaition",billed:false},{id:7,date:"2026-03-11",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",comment:"Job shut down for orientaition",billed:false},{id:8,date:"2026-03-12",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",comment:"Job shut down for orientaition",billed:false},{id:9,date:"2026-03-16",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",comment:"Preped pipe for pushing",billed:false},{id:10,date:"2026-03-17",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:60,stageTotal:60,pipeSize:"pilot",comment:"Started pushing casing",billed:false},{id:11,date:"2026-03-18",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:80,stageTotal:140,pipeSize:"pilot",comment:"Continued pushing casing shut down for job sit audit",billed:false},{id:12,date:"2026-03-19",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",pipeSize:"pilot",comment:"Pulled rods out put motor on then monel subsaver striped out new on be here in morning",billed:false},{id:13,date:"2026-03-20",day:"Fri",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",pipeSize:"pilot",comment:"Sub won't be in until Saturday shut down till Monday",billed:false},{id:14,date:"2026-03-23",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",comment:"Changed sub saver started pushing rods 45' in won't go any more I am going to work on it in morning",billed:false},{id:15,date:"2026-03-24",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Waited on pipe removal tool then worked on getting casing out",billed:false},{id:16,date:"2026-03-25",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Working on getting casing out",billed:false},{id:17,date:"2026-03-26",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Continued working on getting casing out",billed:false},{id:18,date:"2026-03-27",day:"Fri",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Continued trying to get last piece off casing out can't get it moving over to get past it in morning",billed:false},{id:19,date:"2026-03-28",day:"Sat",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Moved rig over ready to drill Monday",billed:false},{id:20,date:"2026-03-30",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:210,stageTotal:210,pipeSize:"pilot",comment:"Drilled 210' for the day",billed:false},{id:21,date:"2026-03-31",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",comment:"Pushed 80' of casing then working on rig won't stay offered up and rebuilding casing tool",billed:false},{id:22,date:"2026-04-01",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Waiting on Vermeer Mechanic to fix RIG (Revs up, then idle, then stalls)",billed:false},{id:23,date:"2026-04-02",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Waited on Vermeer mechanic got rig temporarily running and ordered parts",billed:false},{id:24,date:"2026-04-06",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,drilledLF:20,stageTotal:100,comment:"Pushed 20' of casing added another piece of casing then job shut down",billed:false},{id:25,date:"2026-04-07",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Waiting on approval to go back to work got approval continue to push casing in morning",billed:false},{id:26,date:"2026-04-08",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,drilledLF:40,stageTotal:140,comment:"Pushed 40' of casing then city shut us down",billed:false},{id:27,date:"2026-04-09",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Did training waiting on city to let us go back to work",billed:false},{id:28,date:"2026-04-10",day:"Fri",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"3:30 got word that we can work Monday morning",billed:false},{id:29,date:"2026-04-13",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:80,stageTotal:180,comment:"Finished pushing casing",billed:false},{id:30,date:"2026-04-14",day:"Tue",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:30,stageTotal:240,pipeSize:"pilot",comment:"Pulled out put motor on pushed back in cleaning pipe and drilled 30'",billed:false},{id:31,date:"2026-04-15",day:"Wed",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"GRAVEL",drilledLF:70,stageTotal:310,pipeSize:"pilot",comment:"Continued pilot then having trouble with stand along pump",billed:false},{id:32,date:"2026-04-16",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"ROCK",drilledLF:255,stageTotal:565,pipeSize:"pilot",comment:"Fixed pump then drilled 255'",billed:false},{id:33,date:"2026-04-17",day:"Fri",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"ROCK",drilledLF:320,stageTotal:885,pipeSize:"pilot",comment:"Continued pilot 320' for the day",billed:false},{id:34,date:"2026-04-20",day:"Mon",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,comment:"Rain out",billed:false},{id:35,date:"2026-04-21",day:"Tue",sup:"Norberto",rig:"330x500",comment:"Rain out",billed:false},{id:36,date:"2026-04-22",day:"Wed",sup:"Norberto",rig:"330x500",comment:"Rain out",billed:false},{id:37,date:"2026-04-23",day:"Thu",sup:"Norberto",rig:"330x500",bore:"1",boreLF:1403,stage:"Pilot",soil:"ROCK",drilledLF:265,stageTotal:1083,pipeSize:"pilot",comment:"Fixed pump and drilled 265'  320' left to finish",billed:false}]},
  "G4600593": {duc:"G4600593",customer:"Ironhorse",city:"Dennison Tx",pm:"Perry Graff",planLF:4990,planDays:50,planRev:0,pipeSize:"12\"",reaperSize:"18\"",rig:"40AT",startDate:"2026-03-30",tbc:"2026-05-19",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-03-30",day:"Mon",sup:"ED",rig:"40AT",bore:"1",stage:"MOB",comment:"Mob to job",billed:false},{id:2,date:"2026-03-31",day:"Tue",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Pilot",soil:"ROCK",pipeSize:"12",comment:"Setup dug put drilled to pit",billed:false},{id:3,date:"2026-04-01",day:"Wed",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Pilot",soil:"ROCK",drilledLF:160,stageTotal:160,pipeSize:"12",comment:"Drillied 100' then pulled back started over to finish at 160' for the day",billed:false},{id:4,date:"2026-04-02",day:"Thu",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Pilot",soil:"ROCK",comment:"Rain out",billed:false},{id:5,date:"2026-04-06",day:"Mon",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Pilot",soil:"ROCK",drilledLF:230,stageTotal:390,pipeSize:"12",comment:"Travel to job pumped out pits",billed:false},{id:6,date:"2026-04-07",day:"Tue",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Ream",soil:"ROCK",drilledLF:225,stageTotal:225,pipeSize:"12",comment:"Finished pilot then reamed 225' on 12\"",billed:false},{id:7,date:"2026-04-08",day:"Wed",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Ream",soil:"ROCK",drilledLF:150,stageTotal:150,pipeSize:"12",comment:"Finished 12\" reamer then reamed 150' on 18\"",billed:false},{id:8,date:"2026-04-09",day:"Thu",sup:"ED",rig:"40AT",bore:"1",boreLF:480,soil:"ROCK",drilledLF:75,stageTotal:75,pipeSize:"12",comment:"Started pulling pipe pulled 75' wire broke digging up to reconnect wire",billed:false},{id:9,date:"2026-04-10",day:"Fri",sup:"ED",rig:"40AT",bore:"1",boreLF:480,stage:"Pull",soil:"ROCK",drilledLF:405,stageTotal:480,pipeSize:"12",comment:"Finished pulling pipe then cleaned pits",billed:false},{id:10,date:"2026-04-13",day:"Mon",sup:"ED",rig:"40AT",bore:"2",boreLF:460,stage:"Pilot",soil:"ROCK",drilledLF:460,stageTotal:460,pipeSize:"12",comment:"Setup and drilled pilot",billed:false},{id:11,date:"2026-04-14",day:"Tue",sup:"ED",rig:"40AT",bore:"2",boreLF:460,stage:"Ream",soil:"ROCK",drilledLF:390,stageTotal:390,pipeSize:"12",comment:"Put 12\" reamer on and reamed 390'",billed:false},{id:12,date:"2026-04-14",day:"Tue",sup:"Manuel",rig:"40AT",bore:"3",stage:"MOB",comment:"Mob to job",billed:false},{id:13,date:"2026-04-15",day:"Wed",sup:"ED",rig:"40AT",bore:"2",boreLF:460,stage:"Ream",soil:"ROCK",drilledLF:400,stageTotal:400,pipeSize:"12",comment:"Finished 12\" ream then reamed 400' on 18\"",billed:false},{id:14,date:"2026-04-15",day:"Wed",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Pilot",soil:"ROCK",drilledLF:225,stageTotal:225,pipeSize:"12",comment:"Setup drilled 225' and cleaned up IR",billed:false},{id:15,date:"2026-04-16",day:"Thu",sup:"ED",rig:"40AT",bore:"2",boreLF:460,stage:"Pull",soil:"ROCK",drilledLF:460,stageTotal:450,pipeSize:"12",comment:"Finished reaming pushed out and pulled pipe",billed:false},{id:16,date:"2026-04-16",day:"Thu",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Ream",soil:"ROCK",drilledLF:90,stageTotal:90,pipeSize:"12",comment:"Finished pilot then reamed 90'",billed:false},{id:17,date:"2026-04-17",day:"Fri",sup:"ED",rig:"40AT",bore:"4",boreLF:460,stage:"Pilot",soil:"ROCK",drilledLF:270,stageTotal:270,pipeSize:"12",comment:"Setup and drilled 270'",billed:false},{id:18,date:"2026-04-17",day:"Fri",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Ream",soil:"ROCK",drilledLF:410,stageTotal:450,pipeSize:"12",comment:"Finished 12\" reamer",billed:false},{id:19,date:"2026-04-20",day:"Mon",sup:"ED",rig:"40AT",bore:"4",boreLF:460,stage:"Pilot",soil:"ROCK",drilledLF:190,stageTotal:460,pipeSize:"12",comment:"Finished pilot",billed:false},{id:20,date:"2026-04-20",day:"Mon",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Ream",soil:"ROCK",drilledLF:370,stageTotal:370,pipeSize:"12",comment:"Reamed 370' on 18\"",billed:false},{id:21,date:"2026-04-21",day:"Tue",sup:"ED",rig:"40AT",bore:"4",boreLF:460,stage:"Ream",soil:"ROCK",comment:"Rain out",billed:false},{id:22,date:"2026-04-21",day:"Tue",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Ream",soil:"ROCK",comment:"Rain out",billed:false},{id:23,date:"2026-04-22",day:"Wed",sup:"ED",rig:"40AT",bore:"4",boreLF:460,stage:"Ream",soil:"ROCK",comment:"Rain out",billed:false},{id:24,date:"2026-04-22",day:"Wed",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Ream",soil:"ROCK",drilledLF:80,stageTotal:450,pipeSize:"12",comment:"Finished reaming pushed out ready to pull",billed:false},{id:25,date:"2026-04-23",day:"Thu",sup:"ED",rig:"40AT",bore:"4",boreLF:460,stage:"Ream",soil:"ROCK",drilledLF:460,stageTotal:460,pipeSize:"12",comment:"Reamed bore with 12\" reamer",billed:false},{id:26,date:"2026-04-23",day:"Thu",sup:"Manuel",rig:"40AT",bore:"3",boreLF:450,stage:"Pull",soil:"ROCK",drilledLF:450,stageTotal:450,pipeSize:"12",comment:"Finished reaming and pulled pipe",billed:false}]},
  "W4534206": {duc:"W4534206",customer:"RNGD",city:"Canton, MS",pm:"PERRY GRAFF",planLF:8524,planDays:110,planRev:0,pipeSize:"12 - 18\"",reaperSize:"18 - 28\"",rig:"100x140",startDate:"2026-04-06",tbc:"2026-07-25",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-04-06",day:"Mon",sup:"Noe",rig:"100x140",bore:"1",stage:"MOB",comment:"Finished mob",billed:false},{id:2,date:"2026-04-07",day:"Tue",sup:"Noe",rig:"100x140",bore:"1",stage:"SETUP",comment:"Went to orientation dug pit setup rig",billed:false},{id:3,date:"2026-04-08",day:"Wed",sup:"Noe",rig:"100x140",bore:"1",stage:"SETUP",comment:"They wanted us to start on different bore moved and setup",billed:false},{id:4,date:"2026-04-09",day:"Thu",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,stage:"Ream",soil:"DIRT",drilledLF:100,stageTotal:100,pipeSize:"12",comment:"Drilled pilot put reamer on and reamed 100'",billed:false},{id:5,date:"2026-04-10",day:"Fri",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,stage:"Ream",soil:"DIRT",drilledLF:580,stageTotal:680,pipeSize:"12",comment:"Finished 18\" reamer",billed:false},{id:6,date:"2026-04-11",day:"Sat",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,stage:"Ream",soil:"DIRT",drilledLF:100,stageTotal:100,pipeSize:"12",comment:"Changed reamers reamed 100' started putting pipe together ran out of strips",billed:false},{id:7,date:"2026-04-12",day:"Sun",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,soil:"DIRT",comment:"Waiting on strips to put pipe together",billed:false},{id:8,date:"2026-04-13",day:"Mon",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,stage:"Ream",soil:"DIRT",drilledLF:580,stageTotal:680,pipeSize:"12",comment:"Fixed rig then finished reaming",billed:false},{id:9,date:"2026-04-14",day:"Tue",sup:"Noe",rig:"100x140",bore:"1",boreLF:680,stage:"Pull",soil:"DIRT",drilledLF:680,stageTotal:680,pipeSize:"12",comment:"Swabbed and pulled pipe",billed:false},{id:10,date:"2026-04-15",day:"Wed",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Pilot",soil:"DIRT",drilledLF:720,stageTotal:720,pipeSize:"18",comment:"Moved rig over then drilled out pilot",billed:false},{id:11,date:"2026-04-16",day:"Thu",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Ream",soil:"DIRT",drilledLF:380,stageTotal:380,pipeSize:"18",comment:"Dug exit pit put reamer on started reaming and strung out pipe",billed:false},{id:12,date:"2026-04-17",day:"Fri",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Ream",soil:"DIRT",drilledLF:600,stageTotal:600,pipeSize:"18",comment:"Reamed 600' on 18\"",billed:false},{id:13,date:"2026-04-18",day:"Sat",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Ream",soil:"DIRT",drilledLF:240,stageTotal:240,pipeSize:"18",comment:"Finished 18\" then reamed 240'",billed:false},{id:14,date:"2026-04-19",day:"Sun",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Ream",soil:"DIRT",drilledLF:490,stageTotal:720,pipeSize:"18",comment:"Finished reaming",billed:false},{id:15,date:"2026-04-20",day:"Mon",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Swab",soil:"DIRT",drilledLF:720,stageTotal:720,pipeSize:"18",comment:"Swabbed bore put pipe together pulling tomorrow",billed:false},{id:16,date:"2026-04-21",day:"Tue",sup:"Noe",rig:"100x140",bore:"2",boreLF:700,stage:"Pull",soil:"DIRT",drilledLF:700,stageTotal:700,pipeSize:"18",comment:"Pulled pipe",billed:false},{id:17,date:"2026-04-22",day:"Wed",sup:"Noe",rig:"100x140",bore:"3",boreLF:700,stage:"Pilot",soil:"DIRT",drilledLF:700,stageTotal:700,pipeSize:"18",comment:"Drilled out pilot",billed:false},{id:18,date:"2026-04-22",day:"Wed",sup:"Ramiro",rig:"220X300",stage:"MOB",comment:"Started mob to job",billed:false},{id:19,date:"2026-04-23",day:"Thu",sup:"Noe",rig:"100x140",bore:"3",boreLF:700,stage:"Ream",soil:"DIRT",drilledLF:400,stageTotal:400,pipeSize:"18",comment:"Reamed 400' on 18\" reamer",billed:false},{id:20,date:"2026-04-23",day:"Thu",sup:"Ramiro",rig:"220X300",stage:"MOB",comment:"Finished mob",billed:false}]},
  "W4521103": {duc:"W4521103",customer:"Wilson",city:"Lewisville Tx",pm:"Perry Graff",planLF:911,planDays:26,planRev:0,pipeSize:"36\"",reaperSize:"54\"",rig:"220x500",startDate:"2026-03-06",tbc:"2026-04-01",distList:[],createdAt:"2026-04-24",entries:[{id:1,date:"2026-03-06",day:"Fri",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"MOB",comment:"Started mob to job",billed:false},{id:2,date:"2026-03-09",day:"Mon",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"SETUP",comment:"Started setting up",billed:false},{id:3,date:"2026-03-10",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"SETUP",comment:"Finished setting up",billed:false},{id:4,date:"2026-03-11",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Pilot",soil:"DIRT",drilledLF:310,stageTotal:310,comment:"Started pilot 300' for the day",billed:false},{id:5,date:"2026-03-12",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Pilot",soil:"DIRT",drilledLF:565,stageTotal:875,comment:"Continued pilot 565' for the day",billed:false},{id:6,date:"2026-03-13",day:"Fri",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"DIRT",drilledLF:90,stageTotal:90,comment:"Finished pilot then reamed 90'",billed:false},{id:7,date:"2026-03-16",day:"Mon",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"DIRT",drilledLF:240,stageTotal:330,comment:"Continued reaming cleaned up IR 240' for the day",billed:false},{id:8,date:"2026-03-17",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"DIRT",drilledLF:300,stageTotal:630,comment:"Continued reaming 300' for the day",billed:false},{id:9,date:"2026-03-18",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"DIRT",drilledLF:40,stageTotal:40,pipeSize:"22",comment:"Finished 22\" reamer then reamed 40' on 32\"",billed:false},{id:10,date:"2026-03-19",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"DIRT",drilledLF:300,stageTotal:340,pipeSize:"32",comment:"Continued reaming 300' for the day",billed:false},{id:11,date:"2026-03-20",day:"Fri",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:90,stageTotal:430,pipeSize:"32",comment:"Continued reaming 90' for the day ground is hard",billed:false},{id:12,date:"2026-03-21",day:"Sat",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"SAND",drilledLF:60,stageTotal:490,pipeSize:"32",comment:"Continued reaming ground is hard going slow pulling out Monday to check reamer",billed:false},{id:13,date:"2026-03-23",day:"Mon",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",comment:"Pulled reamer back took off pushed rods across put reamer on ready to ream",billed:false},{id:14,date:"2026-03-24",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:421,stageTotal:911,pipeSize:"32",comment:"Finished 32\" ream and setup fast line",billed:false},{id:15,date:"2026-03-25",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:210,stageTotal:210,pipeSize:"42",comment:"Started 42\" ream 210' for the day",billed:false},{id:16,date:"2026-03-26",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:210,stageTotal:420,pipeSize:"42",comment:"Continue reaming 210' for the day",billed:false},{id:17,date:"2026-03-27",day:"Fri",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:90,stageTotal:510,pipeSize:"42",comment:"Continued reaming fast line clogged up cleaned it out 90' for the day",billed:false},{id:18,date:"2026-03-28",day:"Sat",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:30,stageTotal:540,pipeSize:"42",comment:"Reamed 30' lost flow pushed out and started pulling back in",billed:false},{id:19,date:"2026-03-30",day:"Mon",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:380,stageTotal:911,pipeSize:"42",comment:"Finished pulling to bottom then finished 42\" reamer",billed:false},{id:20,date:"2026-03-31",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:240,stageTotal:240,pipeSize:"42",comment:"Reamed 240' on 50\"",billed:false},{id:21,date:"2026-04-01",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:150,stageTotal:390,pipeSize:"50",comment:"Reamed 150' of 50\"",billed:false},{id:22,date:"2026-04-02",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:100,stageTotal:490,pipeSize:"50",comment:"Continued reaming 100' for the day",billed:false},{id:23,date:"2026-04-08",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:90,stageTotal:580,pipeSize:"50",comment:"Continued reaming 90' for the day",billed:false},{id:24,date:"2026-04-07",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:90,stageTotal:670,pipeSize:"50",comment:"Continued reaming 90' for the day",billed:false},{id:25,date:"2026-04-08",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:180,stageTotal:850,pipeSize:"50",comment:"Continued reaming 180' for the day",billed:false},{id:26,date:"2026-04-09",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Ream",soil:"CLAY",drilledLF:61,stageTotal:911,pipeSize:"50",comment:"Finished reaming cleaned pit changing tooling",billed:false},{id:27,date:"2026-04-10",day:"Fri",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Swab",soil:"CLAY",pipeSize:"50",comment:"Put swab on cleaned pits",billed:false},{id:28,date:"2026-04-13",day:"Mon",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Swab",soil:"CLAY",drilledLF:600,stageTotal:600,pipeSize:"50",comment:"Swabbed 600' having to go little slow to keep mud thin enough to use",billed:false},{id:29,date:"2026-04-14",day:"Tue",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Pull",soil:"CLAY",drilledLF:911,stageTotal:911,pipeSize:"36",comment:"Finished swab and pulled pipe",billed:false},{id:30,date:"2026-04-15",day:"Wed",sup:"Felix",rig:"220x500",bore:"1",boreLF:911,stage:"Clean",comment:"Cleaning up job",billed:false},{id:31,date:"2026-04-16",day:"Thu",sup:"Felix",rig:"220x500",bore:"1",stage:"Clean",comment:"Cleaning up and working on getting eqipment out",billed:false},{id:32,date:"2026-04-17",day:"Fri",sup:"Felix",rig:"220x500",stage:"Clean",comment:"Got excavator out and cleaning up",billed:false},{id:33,date:"2026-04-20",day:"Mon",sup:"Felix",rig:"220x500",stage:"Clean",comment:"Cleaning up mud",billed:false},{id:34,date:"2026-04-21",day:"Tue",sup:"Felix",comment:"Rain out",billed:false},{id:35,date:"2026-04-22",day:"Wed",sup:"Felix",comment:"Rain out",billed:false}]},
};

const deleteLogFile = async (path) => {
  if (!path) return;
  try { await fetch(`${SUPA_URL}/storage/v1/object/${LOG_BUCKET}/${path}`, { method: 'DELETE', headers: await _lfHdr() }); } catch {}
};

// ══════════════════════════════════════════════════════════
//  SHARED COMPONENTS
// ══════════════════════════════════════════════════════════
// #DAILY_TYPE_PICK_V1 (2026-10-16) — Bill: on the Daily entry, typing a letter or number should start the search.
// A plain dropdown only jumps on the FIRST character (desktop) and not at all on a phone. This keeps the same
// fixed choice list (no free text sneaks in), but typing "40" shows 40AT / 40x55 / 24x40, "re" shows Ream, etc.
// Enter or Tab takes the top match; anything that isn't on the list is thrown back.
function PickSearch({ value, onChange, options, placeholder, style, disabled }) {
  const opts = (options || []).filter(o => o != null && o !== '');
  const [q, setQ] = useState(null);   // null = not typing, show the saved value
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const [box, setBox] = useState(null);   // list floats on the page (fixed) so a scrolling table can't clip it
  const inRef = useRef(null);
  const place = () => { try { const r = inRef.current.getBoundingClientRect(); setBox({ top: r.bottom + 2, left: r.left, w: r.width }); } catch {} };
  const listRef = useRef(null);
  useEffect(() => { if (!open) return; const close = (e) => { if (e && e.target && listRef.current && listRef.current.contains(e.target)) return; setOpen(false); }; window.addEventListener('scroll', close, true); window.addEventListener('resize', close);
    return () => { window.removeEventListener('scroll', close, true); window.removeEventListener('resize', close); }; }, [open]);
  const typed = q == null ? '' : q.trim().toLowerCase();
  const list = !typed ? opts : [...opts.filter(o => String(o).toLowerCase().startsWith(typed)), ...opts.filter(o => { const l = String(o).toLowerCase(); return !l.startsWith(typed) && l.includes(typed); })];
  const pick = (o) => { onChange(o); setQ(null); setOpen(false); };
  return (
    <div style={{ position:'relative', width:'100%', minWidth:0 }}>
      <input ref={inRef} value={q == null ? (value || '') : q} disabled={disabled} placeholder={placeholder} autoComplete="off"
        onFocus={e => { place(); setOpen(true); setHi(0); try { e.target.select(); } catch {} }}
        onChange={e => { place(); setQ(e.target.value); setOpen(true); setHi(0); }}
        onKeyDown={e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(true); setHi(h => Math.min(h + 1, Math.max(0, list.length - 1))); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setHi(h => Math.max(h - 1, 0)); }
          else if (e.key === 'Enter') { if (open && list[hi] != null) { e.preventDefault(); pick(list[hi]); } }
          else if (e.key === 'Escape') { setQ(null); setOpen(false); }
          else if (e.key === 'Tab') { if (q != null && typed && list.length) pick(list[hi] != null ? list[hi] : list[0]); }
        }}
        onBlur={() => { const q0 = q; setTimeout(() => { setOpen(false); if (q0 != null) { const t = q0.trim().toLowerCase(); if (!t) onChange(''); else { const ex = opts.find(o => String(o).toLowerCase() === t); if (ex != null) onChange(ex); } } setQ(null); }, 160); }}
        style={style} />
      {open && !disabled && list.length > 0 && box && (
        <div ref={listRef} style={{ position:'fixed', zIndex:10050, top:box.top, left:box.left, minWidth:Math.max(box.w, 90), maxHeight:230, overflowY:'auto', background:'#fff', border:'1px solid #CBD5E1', borderRadius:6, boxShadow:'0 6px 18px rgba(0,0,0,.15)', textAlign:'left' }}>
          {list.map((o, i) => (
            <div key={o} onMouseDown={e => { e.preventDefault(); pick(o); }} onMouseEnter={() => setHi(i)}
              style={{ padding:'6px 9px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap', background: i === hi ? '#E0F2FE' : '#fff', color:'#0F172A', fontWeight: o === value ? 800 : 500 }}>{o}</div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── Universal Attachments Component ──────────────────────
// Works for any module: jobs, fleet, HR, safety, etc.
// Files stored in Supabase app_storage keyed as attach:{module}:{id}:{filename}
const FILE_CATEGORIES = ['Production Log','Contract','Invoice','Photo','Permit','KMZ','Excel','Other'];

const FILE_ICONS = {
  'pdf':'📄','xlsx':'📊','xls':'📊','csv':'📊','jpg':'🖼️','jpeg':'🖼️',
  'png':'🖼️','kmz':'📍','kml':'📍','doc':'📝','docx':'📝','default':'📎'
};

const getIcon = name => {
  const ext = (name||'').split('.').pop().toLowerCase();
  return FILE_ICONS[ext] || FILE_ICONS.default;
};

const fSize = bytes => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024*1024) return `${(bytes/1024).toFixed(1)}KB`;
  return `${(bytes/1024/1024).toFixed(1)}MB`;
};

function AttachmentsSection({ module='job', id, title='Attachments' }) {
  const [files,    setFiles]    = useState([]);
  const [dragging, setDragging] = useState(false);
  const [uploading,setUploading]= useState(false);
  const [error,    setError]    = useState('');
  const inputRef = useRef(null);
  const storageKey = `attach:${module}:${id}`;

  useEffect(() => {
    (async () => {
      const saved = await sg(storageKey);
      if (saved) setFiles(saved);
    })();
  }, [id]);

  const persist = async (updated) => {
    setFiles(updated);
    await ss(storageKey, updated);
  };

  // #17 — compress photos before upload (resize + JPEG). Returns a Blob to stream straight to Storage.
  const compressImage = (file) => new Promise((resolve) => {
    if (!/^image\//.test(file.type) || /gif|svg/.test(file.type)) return resolve(null); // skip non-photos
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        try {
          const MAXD = 2000; // cap longest side at 2000px
          let { width, height } = img;
          if (width > MAXD || height > MAXD) {
            const sc = Math.min(MAXD / width, MAXD / height);
            width = Math.round(width * sc); height = Math.round(height * sc);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width; canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, width, height); // flatten transparency
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob((b) => resolve(b ? { blob: b, type: 'image/jpeg', size: b.size } : null), 'image/jpeg', 0.7);
        } catch (e) { resolve(null); }
      };
      img.onerror = () => resolve(null);
      img.src = reader.result;
    };
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(file);
  });

  // #ATTACH_STORAGE_V1 — upload each file to the log-files bucket; store only lightweight metadata (path,
  // name, type, size, label) in the row. Adding a file no longer rewrites other files' bytes.
  const handleFiles = async (fileList) => {
    setError('');
    const MAX = 4 * 1024 * 1024; // 4MB per file (checked AFTER compression)
    for (const file of fileList) {
      setUploading(true);
      try {
        const comp = await compressImage(file);
        let blob, storeType, storeSize, storeName = file.name, didCompress = false;
        if (comp && comp.size < file.size) {
          blob = comp.blob; storeType = comp.type; storeSize = comp.size; didCompress = true;
          if (!/\.jpe?g$/i.test(storeName)) storeName = storeName.replace(/\.[^.]+$/, '') + '.jpg';
        } else {
          blob = file; storeType = file.type; storeSize = file.size;
        }
        if (storeSize > MAX) { setError(`${file.name} is too large (max 4MB${didCompress?' after compression':''})`); setUploading(false); continue; }
        const path = await uploadLogFile(blob, module, id, storeName);
        const entry = {
          id:         Date.now() + Math.random(),
          name:       storeName,
          size:       storeSize,
          type:       storeType,
          category:   'Other',
          note:       '',
          date:       todayStr(),
          path,                 // Storage object path (bytes live in the bucket, not this row)
          compressed: didCompress,
        };
        const updated = [...files, entry];
        await persist(updated);
      } catch (e) {
        setError(`Failed to upload ${file.name}: ${e.message || e}`);
      }
      setUploading(false);
    }
  };

  // Opens Storage files via a short-lived signed URL; still handles legacy inline-base64 entries (pre-migration).
  const download = async (file) => {
    try {
      if (file.path) {
        const url = await signLogUrl(file.path);
        if (!url) { setError('Could not open file — please retry.'); return; }
        window.open(url, '_blank', 'noopener');
        return;
      }
      const mime = file.type || 'application/octet-stream';
      const a = document.createElement('a');
      a.href = `data:${mime};base64,${file.data}`; a.download = file.name; a.click();
    } catch { setError('Could not open file.'); }
  };

  const remove = async (fileId) => {
    const f = files.find(x => x.id === fileId);
    if (f && f.path) await deleteLogFile(f.path);
    await persist(files.filter(x => x.id !== fileId));
  };

  const updateCategory = (fileId, cat) =>
    persist(files.map(f => f.id===fileId ? {...f, category:cat} : f));

  const updateNote = (fileId, note) =>
    persist(files.map(f => f.id===fileId ? {...f, note} : f));

  return (
    <div style={{ marginTop:14 }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center',
        marginBottom:8 }}>
        <div style={{ fontSize:11, fontWeight:700, color:C.muted,
          textTransform:'uppercase', letterSpacing:0.5 }}>
          📎 {title}
        </div>
        <div style={{ display:'flex', gap:6, alignItems:'center' }}>
          {uploading && <span style={{ fontSize:10, color:C.accent }}>Uploading...</span>}
          <Btn onClick={()=>inputRef.current?.click()} variant="secondary" small>
            <Plus size={11}/>Add File
          </Btn>
          <input ref={inputRef} type="file" multiple style={{ display:'none' }}
            onChange={e=>handleFiles(Array.from(e.target.files))} />
        </div>
      </div>

      {/* Tiles */}
      {files.length > 0 && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(190px, 1fr))',
          gap:8, marginBottom:8 }}>
          {files.map(file => (
            <div key={file.id} style={{ background:C.card, border:`1px solid ${C.border}`,
              borderRadius:8, padding:8, display:'flex', flexDirection:'column', gap:5 }}>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span style={{ fontSize:18, flexShrink:0 }}>{getIcon(file.name)}</span>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:11, fontWeight:600, color:C.text,
                    whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }} title={file.name}>
                    {file.name}
                  </div>
                  <div style={{ fontSize:9, color:C.muted }}>{fSize(file.size)} · {fmtD(file.date)}</div>
                </div>
                <button onClick={()=>remove(file.id)} title="Remove"
                  style={{ background:'none', border:'none', cursor:'pointer', padding:2,
                    display:'flex', alignItems:'center' }}>
                  <Trash2 size={12} color={C.muted}/>
                </button>
              </div>
              <input value={file.note||''} onChange={e=>updateNote(file.id, e.target.value)}
                placeholder="Label (e.g. Permit)" maxLength={24}
                style={{ fontSize:11, padding:'3px 6px', border:`1px solid ${C.border}`,
                  borderRadius:5, width:'100%', boxSizing:'border-box' }} />
              <div style={{ display:'flex', gap:5, alignItems:'center' }}>
                <select value={file.category||'Other'} onChange={e=>updateCategory(file.id, e.target.value)}
                  style={{ fontSize:9, padding:'2px 4px', borderRadius:4, flex:1, minWidth:0,
                    border:`1px solid ${C.border}`, color:C.muted, background:'#F8FAFC' }}>
                  {FILE_CATEGORIES.map(c=><option key={c}>{c}</option>)}
                </select>
                <Btn onClick={()=>download(file)} variant="secondary" small>↓</Btn>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Drop / add strip (always available) */}
      <div
        onDragOver={e=>{e.preventDefault();setDragging(true);}}
        onDragLeave={()=>setDragging(false)}
        onDrop={e=>{e.preventDefault();setDragging(false);handleFiles(Array.from(e.dataTransfer.files));}}
        onClick={()=>inputRef.current?.click()}
        style={{ border:`2px dashed ${dragging?C.accent:C.border}`,
          borderRadius:8, padding: files.length>0 ? '10px' : '20px',
          background: dragging ? '#FFF4EF' : C.surface, cursor:'pointer',
          transition:'all .15s', textAlign:'center', color:C.muted, fontSize:11 }}>
        Drop files here or click to upload · Excel, PDF, Photos, KMZ · Max 4MB each
      </div>

      {error && <div style={{ color:C.red, fontSize:11, marginTop:4 }}>{error}</div>}
    </div>
  );
}

// ══════════════════════════════════════════════════════════
//  TAB 4 — DAILY OPERATIONS LOG
// ══════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════════════
//  PASTE-REPLACE BLOCK FOR DAILY LOG REWRITE — Perry Feedback v1
//  Replaces the existing OpsTab function and helpers in App.js
// ══════════════════════════════════════════════════════════════════
// ══════════════════════════════════════════════════════════
//  TAB 4 — DAILY OPERATIONS LOG  (Perry feedback rewrite)
// ══════════════════════════════════════════════════════════
const EVENT_STAGES = ['Rain','Snow','Ice','Holiday','Shutdown'];

// #JOBEVENT_V1 — non-drilling, job-wide event stages (weather / holiday / customer shutdown)
const STAGES = ['MOB','SETUP','Pilot','Ream','Casing','Swab','Pull','Inner','PH','Clean','Fuse','Delay', ...EVENT_STAGES];

const AUGER_STAGES = ['MOB','SET BX','DRILL','GRADE','PULL','Delay', ...EVENT_STAGES];

// #24 auger jobs (PM=AU): DRILL produces footage; PULL = complete + triggers the revenue checklist (matches HDD 'pull'). CMP retired — historical CMP still counts as a completed bore.
const SOILS  = ['ROCK','DIRT','SAND','CLAY','MIXED'];

// ── Keyword sets for delay/breakdown detection ───────────
// Delays = weather/delay only (Bill): delay, weather, rain, snow, ice (+ variants)
const DELAY_KEYWORDS = [
  'delay','delayed','delays','weather',
  'rain','rained','raining','rainout','rain out',
  'snow','snowed','snowing','sleet','storm','lightning',
  'ice','iced','icy','frozen','freeze','freezing'
];

const BREAKDOWN_KEYWORDS = [
  'broke down','broken','repair','mechanic','parts','motor','pump','hose',
  'hydraulic','equipment failure','worked on rig','worked on equipment',
  'tool failure','blew','striped','stripped','stalls','revs up'
];

const matchesAny = (text, list) => {
  if (!text) return false;
  const t = String(text).toLowerCase();
  return list.some(k => t.includes(k));
};

// Whole-word match so 'rain' won't hit "drain" and 'ice' won't hit "service"
const _escRe = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const matchesDelay = (text) => {
  if (!text) return false;
  const t = String(text).toLowerCase();
  return DELAY_KEYWORDS.some(k => new RegExp('\\b' + _escRe(k) + '\\b').test(t));
};

// Damage / utility-strike flag — whole-word match so "hit" won't trip on "white"/"hitch" (DAMAGE_FLAG_V1)
const DAMAGE_KEYWORDS = ['hit','struck','strike','damage','damaged','dig up','dig-up'];

const matchesWord = (text, list) => {
  if (!text) return false;
  const t = String(text).toLowerCase();
  return list.some(k => new RegExp('\\b' + k + '\\b', 'i').test(t));
};

const wkLabel = (n, total) => total ? `WK ${String(n).padStart(2,'0')} of ${total}` : `WK ${String(n).padStart(2,'0')}`;

function isSunday(dateStr) {
  if (!dateStr) return false;
  return new Date(dateStr+'T12:00:00').getDay() === 0;
}

function getDayName(dateStr) {
  if (!dateStr) return '';
  const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  return days[new Date(dateStr+'T12:00:00').getDay()];
}

// Bulk-paste (migration) — parse MM/DD/YY (or ISO) to ISO
function parseDailyDate(str){
  str=String(str||'').trim(); if(!str) return '';
  if(/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  const m=str.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/);
  if(!m) return '';
  let yr=Number(m[3]); if(yr<100) yr+=2000;
  return `${yr}-${String(Number(m[1])).padStart(2,'0')}-${String(Number(m[2])).padStart(2,'0')}`;
}

// Parse pasted rows: DATE,DAY,SUP,RIG,Bore#,LF Total,Stage,Soil,Drilled,Stg Total,Size,Pipe,Comment (DAY ignored)
function parseBulkRows(text){
  const SM={}; [...STAGES, ...AUGER_STAGES].forEach(st=>{ SM[st.toLowerCase()]=st; });
  const num=v=>{ const n=Number(String(v||'').replace(/[, ]/g,'')); return isNaN(n)?'':n; };
  const inch=v=>{ v=String(v||'').trim(); if(v && !v.includes('"') && /^\d/.test(v)) v+='"'; return v; };
  const out=[];
  String(text||'').split(/\r?\n/).forEach(line=>{
    if(!line.trim()) return;
    const c=line.split('\t');
    const iso=parseDailyDate(c[0]);
    if(!iso) return; // header or non-data row
    const rawStage=(c[6]||'').trim();
    out.push({
      date:iso, day:getDayName(iso),
      sup:(c[2]||'').trim(), rig:(c[3]||'').trim(),
      bore:(c[4]||'').trim(), boreLF:num(c[5]),
      stage: SM[rawStage.toLowerCase()] || rawStage, soil:(c[7]||'').trim(),
      drilledLF:num(c[8]), stageTotal:num(c[9]),
      pipeSize:inch(c[10]), finalPipe:inch(c[11]),
      comment:(c[12]||'').trim(),
    });
  });
  return out;
}

// Job-relative week count (Mon-Sun weeks since first entry)
function jobWeekCount(entries) {
  const dates = entries.map(e=>e.date).filter(Boolean).sort();
  if (!dates.length) return 0;
  const startMon = mondayOf(dates[0]);
  const lastMon  = mondayOf(dates[dates.length-1]);
  return Math.floor((lastMon - startMon)/(7*86400000)) + 1;
}

function mondayOf(dateStr) {
  const d = new Date(dateStr+'T12:00:00');
  const dow = d.getDay();
  d.setDate(d.getDate() - (dow===0?6:dow-1));
  d.setHours(0,0,0,0);
  return d.getTime();
}

// Weekdays count between two dates (Mon-Fri)
function weekdaysBetween(startStr, endStr) {
  if (!startStr || !endStr) return 0;
  const start = new Date(startStr+'T12:00:00');
  const end   = new Date(endStr+'T12:00:00');
  let count = 0;
  const cur = new Date(start);
  while (cur <= end) {
    const dow = cur.getDay();
    if (dow !== 0 && dow !== 6) count++;
    cur.setDate(cur.getDate()+1);
  }
  return count;
}

// Add N weekdays to a date
function addWeekdays(startStr, days) {
  if (!startStr || !days) return null;
  const d = new Date(startStr+'T12:00:00');
  let added = 0;
  while (added < days) {
    d.setDate(d.getDate()+1);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) added++;
  }
  return d.toISOString().slice(0,10);
}

// #AUGER_PULL_BILL_V1 (2026-10-26) — Bill (W46254A8 Broadhead, Titan auger): "want this to behave the same way the HDD rigs do.
// PULL should trigger billing and turn color and place on AR invoice check list." The AR "Jobs to Inv" rail and the PDF already
// took auger PULL rows, but the Daily Log screen itself only knew HDD's 'Pull' spelling — so on an auger job the PULL row never
// turned orange, never showed the INV box, never raised the "PULLS PENDING INVOICE REVIEW" bar or the job card's billing review.
// One test everywhere now. Auger crews log footage on DRILL rows and close the bore with a PULL row that usually has no LF typed,
// so an auger pull counts as billable whether or not LF was typed, and its LF is the typed LF, else the bore's LF.
const isPullStage = (e, auger) => !!e && (e.stage === 'Pull' || (!!auger && String(e.stage || '').toUpperCase() === 'PULL'));
const isBillPull  = (e, auger) => isPullStage(e, auger) && (auger || Number(e.drilledLF) > 0);
const pullLFOf    = (e, auger) => auger ? (Number(e.drilledLF) || Number(e.boreLF) || 0) : (Number(e.drilledLF) || 0);

export function OpsTab({ jobs, pendingDuc, onPendingConsumed, onDeleteJob, onUpdateJob, upn, canEdit, defaultPm }) {
  const isDesktop = useIsDesktop();
  const _augOf = (log) => { if (!log) return false; const _j = (jobs || []).find(x => x.duc === log.duc); return !!(_j && (_j.pm === 'AU' || _j.rig === 'AU')); };   // #AUGER_PULL_BILL_V1
  const [activeLog,   setActiveLog]   = useState(null);
  const [jobLogs,     setJobLogs]     = useState({});
  // #BORE_CXL_V1 (2026-10-28) — Bill: a bore worked then cancelled (E4523906 bore 35) is flagged on the BORE, never by editing
  // dailies. Kept in its own store key 'bore-flags' = { [duc]: { [bore]: { note, by, at } } }. FIN/LF math is unchanged — the
  // CXL bore's days stay in (washes out in the aggregate). Shows CXL on BY BORE (screen + PDF) and a red flag on its daily rows.
  const [boreFlags,   setBoreFlags]   = useState({});
  const [cxlOpen,     setCxlOpen]     = useState(false);
  const [cxlBore,     setCxlBore]     = useState('');
  const [cxlNote,     setCxlNote]     = useState('');
  useEffect(() => { let on = true; Promise.resolve(sg('bore-flags')).then(v => { if (on && v && typeof v === 'object') setBoreFlags(v); }).catch(() => {}); return () => { on = false; }; }, []);
  const cxlOf = (duc, bore) => { const b = String(bore ?? '').trim(); return (duc && b) ? (((boreFlags || {})[duc] || {})[b] || null) : null; };
  const _lastLogsRaw = useRef(null); // #LOG_REALTIME_V1 — last server blob applied; skip identical polls
  const _pendingAddIds = useRef(new Set()); // #LOG_DELETE_SYNC_V2 — entry ids this device just added, not yet confirmed on the server
  const [deletedDucs, setDeletedDucs] = useState([]); // DUCs the user deleted — kept out of seed re-merge
  const [saving,      setSaving]      = useState(false);
  const [saved,       setSaved]       = useState(false);
  const [showDistrib, setShowDistrib] = useState(false);
  const [newEmail,    setNewEmail]    = useState('');
  const [newEntry,    setNewEntry]    = useState(blankEntry());
  const [supMaster,   setSupMaster]   = useState([]); // Revenue-governed master sup list #SUP_MASTER_V1
  const [entryError,  setEntryError]  = useState('');
  const [exportMsg,   setExportMsg]   = useState('');
  const [filterBore,  setFilterBore]  = useState('');
  const [filterSup,   setFilterSup]   = useState('');
  const [pmFilter,    setPmFilter]    = useState(() => {   // #DEFAULT_PM_V1 — default the Daily Log to the signed-in PM
    if (defaultPm) return defaultPm;   // #CRM_V1 — Gary's CRM role opens Daily on Auger (AU)
    const local = String(upn||'').toLowerCase().split('@')[0];
    const code = PMS.find(c => { const nm=(PM_NAMES[c]||'').toLowerCase().split(/\s+/).filter(Boolean); return nm.length && nm.every(t=>local.includes(t)); });
    return code || '';
  });
  const [expandedCard, setExpandedCard] = useState(null);
  const [pendingDelete, setPendingDelete] = useState(null);
  const [pendingDeleteLog, setPendingDeleteLog] = useState(null);
  const [editEntry, setEditEntry] = useState(null);
  const [checkedJobs,  setCheckedJobs]  = useState(new Set());
  const [bulkMsg, setBulkMsg] = useState(''); // BULK_EMAIL_V1
  const [logSort, setLogSort] = useState({ key:'recent', dir:'desc' });
  const [showCompleted, setShowCompleted] = useState(false);
  const [logSearch, setLogSearch] = useState(''); // #DAILY_SEARCH_V1 — find any daily by job # (AR/Marilyn)
  const [custSend, setCustSend] = useState(null);
  const setSort = (key) => setLogSort(p => p.key === key
    ? { key, dir: p.dir === 'asc' ? 'desc' : 'asc' }
    : { key, dir: key === 'recent' ? 'desc' : 'asc' });
  const [logView, setLogView] = useState('entries');
  const [bulkOpen, setBulkOpen] = useState(false);
  const [bulkText, setBulkText] = useState('');
  const [bulkRows, setBulkRows] = useState([]);

  function blankEntry() {
    return { date: todayStr(), day: getDayName(todayStr()), sup:'', rig:'',
      bore:'', boreLF:'', stage:'', soil:'', drilledLF:'',
      stageTotal:'', pipeSize:'', finalPipe:'', comment:'' };
  }

  // ── #SAVE_MERGE_LOGS_V1 — read-merge-write for the daily-logs blob (same idea as #SAVE_MERGE_V1
  // on the Job List). PMs open the log on several devices; each holds the WHOLE blob in memory. A
  // plain { ...jobLogs, [duc]: log } write from a stale snapshot overwrites entries other devices
  // saved later (this was the EAS Fri→Mon data loss). Fix: split the two jobs —
  //   • SERVER: re-read the LATEST server blob, overlay ONLY this one duc, write that. Never spread
  //     the stale in-memory copy, so a newer entry on another device survives.
  //   • SCREEN: overlay the same single duc onto the CURRENT in-memory view via a functional update,
  //     so seed logs (PERRY_SEED_LOGS) stay visible and tombstone resolution isn't undone.
  // Pass value=null to delete a duc.
  const persistLogs = async (duc, value) => {
    // screen: change only this duc, keep everything else intact
    setJobLogs(prev => {
      const n = { ...prev };
      if (value === null) delete n[duc]; else n[duc] = value;
      return n;
    });
    // server: read latest, overlay only this duc, write
    const latest = (await sg('daily-logs')) || {};
    const writeBlob = { ...latest };
    if (value === null) delete writeBlob[duc]; else writeBlob[duc] = value;
    await ss('daily-logs', writeBlob);
    return writeBlob;
  };

  // NIL the no-drill stages (MOB/SETUP/PH/Clean/Fuse) on bulk rows
  const _bulkNorm = r => isNoDrill(r.stage)
    ? { ...r, soil:'NIL', drilledLF:0, stageTotal:0, pipeSize:'NIL', finalPipe:'NIL' }
    : r;
  const doBulkPreview = () => setBulkRows(parseBulkRows(bulkText).map(_bulkNorm));
  const addBulkEntries = async () => {
    if (!bulkRows.length) return;
    const stamped = bulkRows.map((r,i)=>({ ...r, id: Date.now()+i+Math.random(),
      drilledLF: Number(r.drilledLF)||0, boreLF: Number(r.boreLF)||0, stageTotal: Number(r.stageTotal)||0 }));
    stamped.forEach(s=>_pendingAddIds.current.add(s.id)); // #LOG_DELETE_SYNC_V2
    const updated = p => {
      const next = { ...p, entries: [...(p.entries||[]), ...stamped] };
      if (!p.actualStartDate) next.actualStartDate = stamped.map(x=>x.date).filter(Boolean).sort()[0] || null;
      return next;
    };
    setActiveLog(updated);
    if (activeLog) {
      const nl = updated(activeLog);
      await persistLogs(nl.duc, nl); _untomb(nl.duc); // #SAVE_MERGE_LOGS_V1
    }
    setBulkRows([]); setBulkText(''); setBulkOpen(false);
  };

  // Auto-open log if navigated from Job List card
  useEffect(() => {
    if (pendingDuc && Object.keys(jobLogs).length > 0) {
      openLog(pendingDuc);
      onPendingConsumed?.();
    }
  }, [pendingDuc, jobLogs]);

  // #LOG_REFRESH_V1 — one loader used at mount AND on window focus / tab-visible. Re-pulls the
  // daily-logs blob and re-applies seed merge + tombstone filtering + id-heal, IDENTICAL to the
  // original mount logic, so a refresh can never resurrect a deleted log or break entry ids. If a
  // log is open it folds in entries OTHER devices added (union by id) without dropping the local
  // user's in-progress entries or unsaved header edits.
  const loadLogs = useCallback(async () => {
    const saved = await sg('daily-logs');
    // sanitize seed distList strings into arrays
    const clean = obj => {
      if (!obj) return obj;
      const out = {};
      for (const k in obj) {
        const v = obj[k];
        out[k] = { ...v, distList: Array.isArray(v.distList) ? v.distList : [] };
      }
      return out;
    };
    const deleted = (await sg('daily-logs-deleted')) || [];
    const delArr = Array.isArray(deleted) ? deleted : [];
    // #LOG_REALTIME_V1 — if the server blob is byte-identical to what we last applied, do nothing:
    // no setState, no re-render, no disturbance to a PM mid-entry. This lets us poll aggressively.
    const _raw = JSON.stringify(saved) + '|' + JSON.stringify(delArr);
    if (_raw === _lastLogsRaw.current) return;
    _lastLogsRaw.current = _raw;
    const savedClean = clean(saved) || {};
    const merged = { ...clean(PERRY_SEED_LOGS), ...savedClean };
    // A tombstone may ONLY hide a DUC that has no saved data. If a DUC exists in the
    // saved store (it was re-added or edited), saved data ALWAYS wins — it must never be
    // wiped. This was the disappearing-entries bug: a stale tombstone deleted freshly
    // saved dailies on every reload. Deletes still stick (a deleted DUC is removed from
    // the saved store, so it stays in effectiveDel).
    const effectiveDel = delArr.filter(d => !(d in savedClean));
    effectiveDel.forEach(d => { delete merged[d]; });
    setDeletedDucs(effectiveDel);
    if (effectiveDel.length !== delArr.length) ss('daily-logs-deleted', effectiveDel); // self-heal stale tombstones
    // Heal colliding / missing entry ids (bulk-paste used Date.now()+i, manual adds used Date.now() —
    // they can land on the same id, which breaks React keys so rows in multi-entry days could not be
    // opened or edited, and an edit/delete would hit both). Re-stamp duplicates unique. #ID_HEAL_V1
    let _idChanged = false;
    Object.keys(merged).forEach(_duc => {
      const _log = merged[_duc];
      if (!_log || !Array.isArray(_log.entries)) return;
      const _seen = new Set();
      _log.entries = _log.entries.map(e => {
        let id = e.id;
        if (id == null || _seen.has(id)) { do { id = Date.now() + Math.random(); } while (_seen.has(id)); _idChanged = true; }
        _seen.add(id);
        return id === e.id ? e : { ...e, id };
      });
    });
    setJobLogs(merged);
    if (_idChanged) ss('daily-logs', merged);
    // Open log: the server is the source of truth for which entries exist, so deletes AND edits from
    // any device propagate. A local entry the server lacks is kept ONLY if THIS device just added it
    // and the server hasn't confirmed it yet (tracked in _pendingAddIds). Every other screen has no
    // such pending mark, so a delete by anyone drops everywhere. In-progress typing lives in
    // editEntry/newEntry, not in entries, so it's never disturbed. #LOG_DELETE_SYNC_V2
    setActiveLog(prev => {
      if (!prev) return prev;
      const serverLog = merged[prev.duc];
      if (!serverLog || !Array.isArray(serverLog.entries)) return prev;
      const serverIds = new Set(serverLog.entries.map(e => e.id));
      const byId = new Map();
      serverLog.entries.forEach(e => byId.set(e.id, e));            // server wins (adds + edits flow in)
      (prev.entries||[]).forEach(e => {
        if (serverIds.has(e.id)) return;                            // server already has it
        if (_pendingAddIds.current.has(e.id)) byId.set(e.id, e);    // our own unconfirmed add → keep
        // else: server dropped it (deleted elsewhere) → drop here too
      });
      _pendingAddIds.current.forEach(id => { if (serverIds.has(id)) _pendingAddIds.current.delete(id); }); // confirmed → stop tracking
      return { ...prev, entries: [...byId.values()] };
    });
  }, []);

  // initial load
  useEffect(() => { loadLogs(); }, [loadLogs]);

  // #LOG_REFRESH_V1 — re-pull when the device wakes or you switch back to the tab, so a phone/laptop
  // that's been sitting open shows current data instead of its stale startup snapshot.
  useEffect(() => {
    const onWake = () => { if (!document.hidden) loadLogs(); };
    window.addEventListener('focus', onWake);
    document.addEventListener('visibilitychange', onWake);
    return () => {
      window.removeEventListener('focus', onWake);
      document.removeEventListener('visibilitychange', onWake);
    };
  }, [loadLogs]);

  // #LOG_REALTIME_V1 — poll the daily-logs blob on a short interval so every signed-in device shows
  // others' saves within a few seconds (no sign-out/in). loadLogs is change-gated above, so an
  // unchanged poll is a no-op — no re-render, and a PM mid-entry is never disturbed. Pauses when the
  // tab is hidden to save bandwidth; the focus/visibility effect above catches up on wake.
  useEffect(() => {
    const POLL_MS = 8000;
    const id = setInterval(() => { if (!document.hidden) loadLogs(); }, POLL_MS);
    return () => clearInterval(id);
  }, [loadLogs]);

  // Supervisor master list — Revenue is the source of truth. Prefer the curated crew-list
  // (seeded/managed in the Revenue tab); fall back to distinct sups on the invoice table. #SUP_MASTER_V1
  useEffect(() => { (async () => {
    let names = [];
    const cl = await sg('crew-lists');
    if (cl && Array.isArray(cl.sups) && cl.sups.length) { names = cl.sups; }
    else { const ri = await sg('revenue-input'); if (Array.isArray(ri)) names = ri.map(r => String(r.sup||'').trim()); }
    const seen = new Set(); const out = [];
    names.forEach(n => { n = String(n||'').trim(); const k = n.toLowerCase(); if (n && !seen.has(k)) { seen.add(k); out.push(n); } });
    out.sort((a,b)=>a.localeCompare(b));
    setSupMaster(out);
  })(); }, []);

  // Picker groups: master names (Revenue truth) + any names in THIS log not on the master (flag to fix).
  const supPicker = useMemo(() => {
    const master = supMaster || [];
    const mlc = new Set(master.map(s => s.toLowerCase()));
    const inLog = [...new Set((activeLog?.entries||[]).map(e => String(e.sup||'').trim()).filter(Boolean))];
    const orphans = inLog.filter(s => !mlc.has(s.toLowerCase())).sort((a,b)=>a.localeCompare(b));
    return { master: [...master], orphans, hasMaster: master.length > 0 };
  }, [supMaster, activeLog]);

  // #DAILY_LIVE_V1 — hydrate a log's CONTRACT header live from the Job List (the Bible) at load.
  // Job List edits — typo fixes, change-order LF/days/bores, plan rev, PM swaps — flow to the daily.
  // Falls back to the stored snapshot only if the job was deleted. Daily keeps its own entries.
  const _hydrate = (log) => {
    if (!log) return log;
    const j = jobs.find(x => x.duc === log.duc);
    if (!j) return log;
    return {
      ...log,
      displayDuc: j.displayDuc || j.duc || log.displayDuc,
      customer:   j.cust  || log.customer,
      city:       j.city  || log.city,
      desc:       j.desc  || log.desc,
      pm:         PM_NAMES[j.pm] || j.pm || log.pm,
      planLF:     j.plf   || log.planLF   || 0,
      planDays:   j.days  || log.planDays || 0,
      planRev:    j.prev  || log.planRev  || 0,
      planBores:  j.bores || log.planBores|| 0,
      pipeSize:   j.pipe  || log.pipeSize,
      rig:        j.rig   || log.rig,
      startDate:  j.ad    || log.startDate,
    };
  };

  // Open a log by DUC
  const openLog = (duc) => {
    const q = String(duc).trim().toLowerCase();
    const job = jobs.find(j => String(j.duc).trim().toLowerCase() === q
      || String(j.displayDuc||'').trim().toLowerCase() === q);
    if (!job) { alert(`Job ${duc} not found in Job List`); return; }
    // #12 — Starting a daily forces the path: a pre-work job (Approved/Called In) must move to
    //        In Progress first. Warn; if declined, the daily does NOT open (no dailies on not-ready jobs).
    if (['Approved','Called In'].includes(job.stat)) {
      if (!window.confirm(`${job.displayDuc||job.duc} is ${job.stat}.\n\nStarting a daily will move it to IN PROGRESS. Make sure locates, permits and tickets are ready.\n\nContinue? #WeAreDakota`)) return;
      onUpdateJob?.(job.duc, { stat:'In Progress' });
    }
    _pendingAddIds.current = new Set(); // #LOG_DELETE_SYNC_V2 — clear pending adds when switching logs
    const existing = jobLogs[job.duc];
    if (existing) {
       setActiveLog(_hydrate({ ...existing, desc: existing.desc || job.desc || '', distList: Array.isArray(existing.distList) ? existing.distList : [], passPlan: (existing.passPlan && Object.keys(existing.passPlan).length) ? existing.passPlan : (job.passPlan || {}) }));
    } else {
      const log = {
        duc:        job.duc,
        displayDuc: job.displayDuc || job.duc,
        customer:   job.cust,
        city:       job.city,
      desc:       job.desc || '',
        pm:         PM_NAMES[job.pm] || job.pm,
        planLF:     job.plf || 0,
        planDays:   job.days || 0,
        planRev:    job.prev || 0,
        planBores:  job.bores || 0,
        pipeSize:   job.pipe || (job.desc ? (job.desc.match(/(\d+(?:\.\d+)?(?:"|')?(?:\s*(?:inch|in|HDPE|Steel|PVC|HOPE|PE))?)/i)||[''])[0] : ''),
        rig:        job.rig || '',
        passPlan:   job.passPlan ? {...job.passPlan} : {},
        startDate:  job.ad || todayStr(),
        tbc:        job.ps || '',
        reaperSize: '',
        bidLink:    '',
        kmzLink:    '',
        distList:   [],
        entries:    [],
        createdAt:  todayStr(),
      };
      setActiveLog(_hydrate(log));
    }
  };

  const saveLog = async () => {
    if (!activeLog) return;
    setSaving(true);
    await persistLogs(activeLog.duc, activeLog); // #SAVE_MERGE_LOGS_V1
    _untomb(activeLog.duc);
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  // Delete a daily: wipe its log; if it's a custom (test) job, remove the job entirely too
  const deleteDaily = async (duc) => {
    // functional updates so deleting several in a row don't clobber each other
    persistLogs(duc, null); // #SAVE_MERGE_LOGS_V1 — re-reads latest server blob, removes only this duc
    setDeletedDucs(prev => {
      const arr = Array.isArray(prev) ? prev : [];
      const n = [...new Set([...arr, duc])];
      ss('daily-logs-deleted', n);
      return n;
    });
    // #DAILY_DELETE_NOCASCADE_V1 — deleting a Daily must NOT delete the job from the Job List.
    // (Previously this cascaded onDeleteJob for custom- jobs, which silently wiped custom-added
    //  jobs like W46126A9 every time their daily was deleted, forcing repeated re-entry.)
  };
  // un-tombstone a DUC when the user actively saves/adds to it (so re-created dailies stick)
  const _untomb = (duc) => {
    if (!duc) return;
    setDeletedDucs(prev => {
      const arr = Array.isArray(prev) ? prev : [];
      if (!arr.includes(duc)) return arr;
      const n = arr.filter(d => d !== duc);
      ss('daily-logs-deleted', n);
      return n;
    });
  };

  // #JOB_COMPLETE_V1 — the field PM marks a job done from the Daily. This drives the Job List status
  // (the single source of truth), NOT a separate daily flag: it sets stat→Complete and stamps the
  // completion date (today), which stops ticket updates, drops it out of In Progress, starts the cost
  // clock, and moves it down the production line. Completion is ONE-WAY from the field — once Complete
  // the control locks; reopening to In Progress is an Admin action from the Job List. Re-completion
  // after a reopen always overrides the prior date (act_com is passed explicitly every time, so it
  // does NOT depend on the Job List's empty-only auto-stamp).
  const _markJobComplete = () => {
    const job = jobs.find(j => j.duc === activeLog.duc);
    if (!job || job.stat === 'Complete') return;
    if (!window.confirm(
      `Mark ${activeLog.displayDuc || _logNum(activeLog)} COMPLETE?\n\n` +
      `\u2022 Moves the job to COMPLETE in the Job List\n` +
      `\u2022 Stops ticket updates and drops it from In Progress\n` +
      `\u2022 Stamps today as the completion date and starts the cost clock\n\n` +
      `Reopening must be done by Admin from the Job List. #WeAreDakota`
    )) return;
    const d = new Date();
    const stamp = `${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')}/${String(d.getFullYear()).slice(-2)}`;
    onUpdateJob?.(activeLog.duc, { stat:'Complete', act_com: stamp });
  };
  const renderCompleteToggle = (compact) => {
    if (!activeLog) return null;
    const job = jobs.find(j => j.duc === activeLog.duc) || {};
    const done = job.stat === 'Complete';
    return (
      <button data-print-hide="true" type="button"
        onClick={done ? undefined : _markJobComplete} disabled={done}
        title={done ? 'Job is Complete \u2014 reopen from the Job List (Admin only)' : 'Mark this job Complete'}
        style={{ display:'inline-flex', alignItems:'center', gap:7, cursor: done?'default':'pointer',
          border:`1.5px solid ${done?C.green:C.border}`, background: done?C.green:'#fff',
          color: done?'#fff':C.text, borderRadius:7, padding: compact?'4px 10px':'6px 12px',
          fontSize: compact?11:12.5, fontWeight:800, letterSpacing:0.3, whiteSpace:'nowrap' }}>
        <span style={{ width:15, height:15, borderRadius:3,
          border:`1.5px solid ${done?'#fff':C.muted}`, background: done?'#fff':'transparent',
          color:C.green, display:'inline-flex', alignItems:'center', justifyContent:'center',
          fontSize:12, lineHeight:1, fontWeight:900 }}>{done?'\u2713':''}</span>
        {done ? 'JOB COMPLETE' : 'Mark Job Complete'}
      </button>
    );
  };

  // #10 — pick a SUP -> pull their most recent Rig/Bore/LF/Soil/Size (overridable). Bore stays blank if last one was Pulled.
  const _supFill = (supName, prev) => {
    const sName = (supName||'').toString().trim();
    if (!sName) return null;
    const es = (activeLog?.entries||[]).filter(e => (e.sup||'').toString().trim() === sName);
    if (!es.length) return { sup:sName };
    const sorted = [...es].sort((a,b)=>(b.date||'').localeCompare(a.date||'') || (b.id||0)-(a.id||0));
    const last = sorted[0];
    const lastBore = (last.bore||'').toString();
    const boreEntries = sorted.filter(e => (e.bore||'').toString() === lastBore);
    const pulled = boreEntries.some(e => isPullStage(e, _augOf(activeLog)));   // #AUGER_PULL_BILL_V1
    const lastReam = boreEntries.find(e => e.stage === 'Ream' && e.pipeSize && e.pipeSize!=='NIL')
                  || boreEntries.find(e => e.pipeSize && e.pipeSize!=='NIL');
    return {
      sup: sName,
      rig: last.rig || prev.rig,
      soil: (last.soil && last.soil!=='NIL') ? last.soil : prev.soil,
      bore: pulled ? '' : lastBore,
      boreLF: pulled ? '' : ((last.boreLF!=null && last.boreLF!=='') ? last.boreLF : prev.boreLF),
      pipeSize: pulled ? '' : (lastReam?.pipeSize || prev.pipeSize),
    };
  };
  const fillFromSup     = (supName) => setNewEntry(p => { const f=_supFill(supName,p); return f?{...p,...f}:p; });
  const fillFromSupEdit = (supName) => setEditEntry(p => {
    if (!p) return p;
    // Carry-forward (prev rig/bore/soil/pipe) only when ADDING a new entry — never when editing an existing one. #EDIT_NO_CARRY_V1
    if (!p._isNew) return { ...p, sup: (supName||'').toString() };
    const f=_supFill(supName,p); return f?{...p,...f}:p;
  });

  // ── Supervisor name gate — Revenue master is the truth; suggest near-matches, confirm new names. #SUP_GATE_V1
  const _lev = (a,b) => {
    a=String(a).toLowerCase(); b=String(b).toLowerCase();
    const m=a.length,n=b.length; if(!m)return n; if(!n)return m;
    let prev=[...Array(n+1).keys()];
    for(let i=1;i<=m;i++){ const cur=[i]; for(let j=1;j<=n;j++){ cur[j]=Math.min(prev[j]+1, cur[j-1]+1, prev[j-1]+(a[i-1]===b[j-1]?0:1)); } prev=cur; }
    return prev[n];
  };
  const _suggestMaster = (name) => {
    const nl=String(name||'').trim().toLowerCase(); if(nl.length<2) return null;
    let best=null, bestScore=Infinity;
    (supMaster||[]).forEach(m => {
      const ml=String(m).toLowerCase(); if(ml===nl) return;
      const d=_lev(nl,ml);
      const isPrefix = ml.startsWith(nl) || nl.startsWith(ml);
      // Rank by edit distance so the closest real name wins (e.g. "edward" -> "Edward G", not "ED"),
      // and scale tolerance to length so short names (ED, Ty) do not match unrelated typing.
      const maxD = Math.max(1, Math.ceil(Math.min(nl.length, ml.length) * 0.5));
      let ok=false, score=d;
      if (d<=2 && d<=maxD) ok=true;
      else if (isPrefix && nl.length>=3 && ml.length>=3 && Math.abs(nl.length-ml.length)<=4) { ok=true; score=d-0.25; }
      if (ok && score<bestScore){ bestScore=score; best=m; }
    });
    return best;
  };
  // returns the sup name to commit (possibly snapped to master), or null to abort the save
  const resolveSup = (raw) => {
    const name=String(raw||'').trim();
    if(!name) return name;
    const exact=(supMaster||[]).find(m=>String(m).toLowerCase()===name.toLowerCase());
    if(exact) return exact;
    if(!(supMaster||[]).length) return name;
    const sug=_suggestMaster(name);
    if(sug && window.confirm(`Did you mean "${sug}"?\n\nOK = use "${sug}" (on the approved list)\nCancel = keep "${name}" as typed`)) return sug;
    const goBack = window.confirm(`"${name}" is not on the approved / Revenue supervisor list.\n\nOK = go back and pick an approved name (recommended)\nCancel = add "${name}" anyway — it stays flagged. Then contact Marilyn to update the list and HR to add as Supervisor.`);
    return goBack ? null : name;
  };
  const addEntry = async () => {
    if (!canEdit) { setEntryError('View only — you don\'t have edit access to Daily Log.'); return; }
    const missing = [];
    if (!newEntry.date)                              missing.push('Date');
    if (!(newEntry.sup||'').trim())                  missing.push('SUP');
    if (!newEntry.rig)                               missing.push('Rig');
    if (!(newEntry.bore||'').toString().trim())      missing.push('Bore #');
    if (!newEntry.stage)                             missing.push('Stage');
    const _noDrill = isNoDrill(newEntry.stage);
    if (!_noDrill && (newEntry.drilledLF==='' || newEntry.drilledLF==null)) missing.push('Drilled LF');
    if (!_noDrill && (newEntry.finalPipe==='' || newEntry.finalPipe==null)) missing.push('Pipe');
    if (missing.length) { setEntryError('Required: ' + missing.join(', ')); return; }
    if (isPullStage(newEntry, _augOf(activeLog))) {   // #AUGER_PULL_BILL_V1
      const _b = String(newEntry.bore||'').trim();
      if ((activeLog?.entries||[]).some(e => isPullStage(e, _augOf(activeLog)) && String(e.bore||'').trim()===_b)) {
        setEntryError(`Bore ${_b} was already pulled - a bore can only be pulled once. Use Clean / PH / Ream for other activity.`); return;
      }
    }
    setEntryError('');
    { const _b=String(newEntry.bore||'').trim();
      const _dup=(activeLog?.entries||[]).some(e=>String(e.bore||'').trim()===_b && (e.date||'')===(newEntry.date||'') && String(e.sup||'').trim()===String(newEntry.sup||'').trim() && String(e.rig||'')===String(newEntry.rig||''));
      if(_dup && !window.confirm(`Heads up: bore ${_b} already has an entry on ${newEntry.date} for this SUP/rig. That's often a wrong date or a duplicate. Add it anyway?`)) return; }
    const _sup = resolveSup(newEntry.sup); if (_sup === null) return;
    if (_sup !== newEntry.sup) setNewEntry(p=>({...p, sup:_sup}));
    const entry = { ...newEntry, id: Date.now()+Math.random(), sup:_sup,
      day: getDayName(newEntry.date),
      drilledLF: Number(newEntry.drilledLF)||0,
      boreLF: Number(newEntry.boreLF)||0,
      stageTotal: Number(newEntry.stageTotal)||0 };
    _pendingAddIds.current.add(entry.id); // #LOG_DELETE_SYNC_V2 — protect our own add until the server confirms it
    // Lock actualStartDate to first-ever entry date (won't change on later edits)
    const updated = p => {
      const nextEntries = [...(p.entries||[]), entry];
      const next = { ...p, entries: nextEntries };
      if (!p.actualStartDate && nextEntries.length === 1) {
        next.actualStartDate = entry.date;
      }
      return next;
    };
    setActiveLog(updated);
    if (activeLog) {
      const newLog = updated(activeLog);
      await persistLogs(newLog.duc, newLog); // #SAVE_MERGE_LOGS_V1
      _untomb(newLog.duc);
    }
    setNewEntry(p => ({ ...blankEntry(), date:p.date, sup:p.sup, rig:p.rig, soil:p.soil, bore:p.bore, boreLF:p.boreLF, stageTotal:p.stageTotal, finalPipe:p.finalPipe }));  // #PREFILL_V1 — carry setup; blank drilled/stage/reamer
  };

  // #LOG_DELETE_SYNC_V1 — deleting an entry auto-persists (like add/edit), so the removal hits the
  // server immediately and other devices drop it on their next refresh instead of resurrecting it.
  const _doRemoveEntry = async (id) => {
    if (!canEdit) return;
    const base = activeLog || {};
    const newLog = { ...base, entries: (base.entries||[]).filter(e=>e.id!==id) };
    setActiveLog(newLog);
    if (activeLog) await persistLogs(newLog.duc, newLog);
  };
  const removeEntry = (id) => setPendingDelete(id);
  const openEdit = (entry, ev) => {
    if (ev && ev.target && ev.target.closest && ev.target.closest('button, input, label, a, select, textarea')) return;
    setEditEntry({ ...entry });
  };
  const saveEdit = async () => {
    if (!canEdit) return;
    if (!editEntry) return;
    if (editEntry._isNew) {
      const ne = editEntry;
      const missing = [];
      if (!ne.date)                            missing.push('Date');
      if (!(ne.sup||'').trim())                missing.push('SUP');
      if (!ne.rig)                             missing.push('Rig');
      if (!(ne.bore||'').toString().trim())    missing.push('Bore #');
      if (!ne.stage)                           missing.push('Stage');
      const _nd = isNoDrill(ne.stage);
      if (!_nd && (ne.drilledLF==='' || ne.drilledLF==null)) missing.push('Drilled LF');
      if (!_nd && (ne.finalPipe==='' || ne.finalPipe==null)) missing.push('Pipe');
      if (missing.length) { window.alert('Required: ' + missing.join(', ')); return; }
      if (isPullStage(ne, _augOf(activeLog))) {   // #AUGER_PULL_BILL_V1
        const _b = String(ne.bore||'').trim();
        if ((activeLog?.entries||[]).some(e => isPullStage(e, _augOf(activeLog)) && String(e.bore||'').trim()===_b)) {
          window.alert(`Bore ${_b} was already pulled - a bore can only be pulled once. Use Clean / PH / Ream for other activity.`); return;
        }
      }
      { const _b=String(ne.bore||'').trim();
        const _dup=(activeLog?.entries||[]).some(e=>String(e.bore||'').trim()===_b && (e.date||'')===(ne.date||'') && String(e.sup||'').trim()===String(ne.sup||'').trim() && String(e.rig||'')===String(ne.rig||''));
        if(_dup && !window.confirm(`Heads up: bore ${_b} already has an entry on ${ne.date} for this SUP/rig. That's often a wrong date or a duplicate. Add it anyway?`)) return; }
      const _sup = resolveSup(ne.sup); if (_sup === null) return;
      const entry = { ...ne, id: Date.now()+Math.random(), sup:_sup, day: getDayName(ne.date),
        drilledLF: Number(ne.drilledLF)||0, boreLF: Number(ne.boreLF)||0, stageTotal: Number(ne.stageTotal)||0 };
      delete entry._isNew;
      _pendingAddIds.current.add(entry.id); // #LOG_DELETE_SYNC_V2
      const updated = p => {
        const nextEntries = [...(p.entries||[]), entry];
        const next = { ...p, entries: nextEntries };
        if (!p.actualStartDate && nextEntries.length === 1) next.actualStartDate = entry.date;
        return next;
      };
      setActiveLog(updated);
      if (activeLog) {
        const newLog = updated(activeLog);
        await persistLogs(newLog.duc, newLog); // #SAVE_MERGE_LOGS_V1
        _untomb(newLog.duc);
      }
      setEditEntry(null);
      return;
    }
    if (isPullStage(editEntry, _augOf(activeLog))) {   // #AUGER_PULL_BILL_V1
      const _b = String(editEntry.bore||'').trim();
      if ((activeLog?.entries||[]).some(e => e.id!==editEntry.id && isPullStage(e, _augOf(activeLog)) && String(e.bore||'').trim()===_b)) {
        window.alert(`Bore ${_b} was already pulled - a bore can only be pulled once. Use Clean / PH / Ream for other activity.`); return;
      }
    }
    const _origSup = ((activeLog?.entries||[]).find(x=>x.id===editEntry.id)||{}).sup||'';
    let _sup = editEntry.sup;
    if ((_origSup||'') !== (editEntry.sup||'')) { _sup = resolveSup(editEntry.sup); if (_sup === null) return; }
    const updatedEntry = { ...editEntry, sup:_sup, day: getDayName(editEntry.date),
      drilledLF: Number(editEntry.drilledLF)||0, stageTotal: Number(editEntry.stageTotal)||0 };
    // #SAVE_MERGE_LOGS_V1 — auto-save edits to existing entries. The Save button still works
    // (it just re-saves the same activeLog), but editing no longer relies on remembering to click it.
    const newLog = { ...activeLog, entries: (activeLog.entries||[]).map(x => x.id === updatedEntry.id ? updatedEntry : x) };
    setActiveLog(newLog);
    if (activeLog) { await persistLogs(newLog.duc, newLog); _untomb(newLog.duc); }
    setEditEntry(null);
  };
  // #JOBEVENT_V1 — apply a job-wide event (Rain/Snow/Ice/Holiday/Shutdown) to every rig currently
  // on this job in one action, instead of hand-entering the same event per rig. Date-driven: the
  // Date field above is the anchor, Sup/Rig selection is irrelevant to this action.
  const applyEventToAllRigs = async () => {
    if (!canEdit) return;
    if (!editEntry) return;
    if (!editEntry.date) { window.alert('Pick a date first.'); return; }
    if (!EVENT_STAGES.includes(editEntry.stage)) { window.alert('Pick an event in the Stage field first — Rain, Snow, Ice, Holiday, or Shutdown.'); return; }
    const date = editEntry.date;
    // #JOBEVENT_FIX_V2 — group by SUPERVISOR, not Rig. Rig is an equipment size/type (from DAILY_RIGS),
    // not a unique tag per crew — two different supervisors can legitimately share the same Rig value
    // (e.g. two 40AT crews on one job), so grouping by Rig silently collapsed distinct supervisors into
    // one. Supervisor is the real unit here, matching "an event needs to be added to all 7 Supervisors."
    const bySup = {};
    (activeLog?.entries||[]).slice()
      .sort((a,b)=>(a.date||'').localeCompare(b.date||'') || (a.id||0)-(b.id||0))
      .forEach(e => { const s=(e.sup||'').toString().trim(); if (s) bySup[s] = e; }); // ascending sort → latest entry per sup wins
    const sups = Object.keys(bySup);
    if (!sups.length) { window.alert('No supervisors found on this job yet — add at least one entry first, then use this for the rest.'); return; }
    const already = new Set((activeLog?.entries||[]).filter(e=>(e.date||'')===date).map(e=>(e.sup||'').toString().trim()));
    const toAdd = sups.filter(s => !already.has(s));
    const skipped = sups.filter(s => already.has(s));
    if (!toAdd.length) { window.alert(`Every supervisor on this job already has an entry for ${date}.`); return; }
    const newEntries = toAdd.map((s,i) => {
      const last = bySup[s];
      return { id: Date.now()+Math.random()+i, date, day: getDayName(date),
        sup: s, rig: last.rig||'', bore: last.bore||'', boreLF: Number(last.boreLF)||0,
        stage: editEntry.stage, soil:'NIL', drilledLF:0, stageTotal:0, pipeSize:'NIL', finalPipe:'NIL',
        comment: editEntry.comment||'' };
    });
    newEntries.forEach(e => _pendingAddIds.current.add(e.id)); // #LOG_DELETE_SYNC_V2
    const updated = p => ({ ...p, entries: [...(p.entries||[]), ...newEntries] });
    setActiveLog(updated);
    if (activeLog) {
      const newLog = updated(activeLog);
      await persistLogs(newLog.duc, newLog); // #SAVE_MERGE_LOGS_V1
      _untomb(newLog.duc);
    }
    setEditEntry(null);
    window.alert(`Applied "${editEntry.stage}" to ${toAdd.length} supervisor${toAdd.length>1?'s':''} on ${date}.`
      + (skipped.length ? ` Skipped ${skipped.length} already logged that day: ${skipped.join(', ')}.` : ''));
  };
  // #24 — auger jobs use a different stage set; only DRILL produces footage
  const _augerLog = (() => { const _aj = jobs.find(x=>x.duc===(activeLog&&activeLog.duc)); return !!(_aj && (_aj.pm==='AU' || _aj.rig==='AU')); })();
  // #DAILY_NUM_V1 — show a log's REAL job number, never its custom-<ts> storage key.
  // Resolve order: number stamped on the log → look it up in the live Job List → fall back to the key.
  const _logNum = (log) => log ? (log.displayDuc || (jobs.find(j => j.duc === log.duc) || {}).displayDuc || log.duc) : '';
  const ACTIVE_STAGES = _augerLog ? AUGER_STAGES : STAGES;
  const isNoDrill = (st) => EVENT_STAGES.includes(st) || (_augerLog ? (!!st && st !== 'DRILL') : ['MOB','SETUP','Inner','PH','Clean','Fuse','Complete'].includes(st));
  // shared entries column header (so it shows on a blank log too)
  const _ENTRY_HEADER = (
    <div data-print-row="header" style={{ display:'grid',
      gridTemplateColumns:'46px 78px 36px 76px 70px 38px 62px 78px 56px 64px 64px 42px 42px 1fr 44px 40px',
      gap:0, padding:'4px 0', borderBottom:`1px solid ${C.border}` }}>
      {['WK','DATE','DAY','SUP','RIG','BORE','BORE LF','STAGE','SOIL','DRILLED','STG LF','SIZE','PIPE','COMMENTS','INV',''].map(h=>(
        <div key={h} style={{ fontSize:10, fontWeight:700, color:C.muted,
          letterSpacing:0.5, textTransform:'uppercase', textAlign:'center', padding:'0 3px' }}>{h}</div>
      ))}
    </div>
  );
  const _ELBL = { display:'flex', flexDirection:'column', gap:3, fontSize:11, fontWeight:700, color:C.muted };
  const _EINP = { fontSize:13, padding:'6px 8px', border:`1px solid ${C.border}`, borderRadius:6, width:'100%', boxSizing:'border-box' };

  const addEmail = () => {
    if (!newEmail.trim()) return;
    setActiveLog(p => ({ ...p, distList: [...(Array.isArray(p.distList)?p.distList:[]), newEmail.trim()] }));
    setNewEmail('');
  };

  const removeEmail = (email) => setActiveLog(p => ({
    ...p, distList: (Array.isArray(p.distList)?p.distList:[]).filter(e=>e!==email) }));

  // ── COMPUTED METRICS ──────────────────────────────────
  const computeMetrics = (log) => {
    if (!log) return {};
    const entries = log.entries || [];
    const _mj = jobs.find(x=>x.duc===log.duc) || {};
    const _auger = _mj.pm==='AU' || _mj.rig==='AU';
    const pulls   = _auger ? entries.filter(e => (Number(e.drilledLF)||0) !== 0) : entries.filter(e => e.stage === 'Pull' && e.drilledLF > 0);
    const totalLF = pulls.reduce((s,e) => s + (Number(e.drilledLF)||0), 0);
    const boresDone = _auger ? [...new Set(entries.filter(e=>{const _s=String(e.stage||'').toUpperCase();return _s==='PULL'||_s==='CMP';}).map(e=>String(e.bore)))].length : [...new Set(pulls.map(e => String(e.bore)))].length;
    // rig-day = one date + SUP + rig, so two crews on a job the same date = two rig-days
    const _rk = e => `${e.date||''}|${String(e.sup||'').trim().toUpperCase()}|${String(e.rig||'').trim().toUpperCase()}`;
    const phDays = [...new Set(entries.filter(e => e.stage === 'PH' && e.date).map(_rk))].length;
    // delay days: comment matches delay keywords OR explicit Delay stage
    const delayDays = [...new Set(
      entries.filter(e => (e.stage === 'Delay' || matchesDelay(e.comment)) && e.date).map(_rk)
    )].length;
    // breakdowns: comment matches breakdown keywords (separate metric for fleet)
    const breakdownDays = [...new Set(
      entries.filter(e => matchesAny(e.comment, BREAKDOWN_KEYWORDS) && e.date).map(_rk)
    )].length;
    const rigDates = [...new Set(entries.filter(e=>e.drilledLF>0 && e.date).map(_rk))].length;
    const totalDays = [...new Set(entries.filter(e=>e.date).map(_rk))].length;
    const planFinLF = log.planDays ? (log.planLF / log.planDays) : 0;
    // Per Bill: Actual FIN/LF = Pulled LF / total Days
    const actFinLF  = totalDays ? (totalLF / totalDays) : 0;
    const pctComplete = log.planLF ? Math.round(totalLF / log.planLF * 100) : 0;

    let slippage = 'on-track';
    if (planFinLF > 0 && actFinLF > 0) {
      const r = actFinLF / planFinLF;
      if (r < 0.6) slippage = 'critical';
      else if (r < 0.8) slippage = 'warning';
    }

    const remaining = log.planLF - totalLF;
    const projDays  = actFinLF > 0 ? Math.ceil(remaining / actFinLF) : null;
    const overPlan  = log.planLF > 0 && totalLF >= log.planLF; // met/exceeded planned footage — scope grew

    // Field complete date: latest entry with stage = 'Complete'
    const completeEntries = entries.filter(e => e.stage === 'Complete');
    const fieldCompleteDate = completeEntries.length
      ? completeEntries.map(e=>e.date).sort().slice(-1)[0]
      : null;

    // Projected complete (PLAN): plan start + planDays weekdays
    const projectedCompleteDate = log.startDate && log.planDays
      ? addWeekdays(log.startDate, log.planDays) : null;
    // Per Bill: Actual Proj Complete = 1st entry date + planDays weekdays (Mon-Fri only)
    const firstEntryDate = entries.map(e=>e.date).filter(Boolean).sort()[0] || null;
    const actualProjComplete = firstEntryDate && log.planDays
      ? addWeekdays(firstEntryDate, log.planDays) : null;
    // Adjusted completion at current pace — only meaningful when slipping (ADJ_COMPLETE_V1)
    const adjustedCompleteDate = (projDays != null && slippage !== 'on-track')
      ? addWeekdays(todayStr(), projDays) : null;
    const daysLate = (adjustedCompleteDate && actualProjComplete)
      ? Math.max(0, weekdaysBetween(actualProjComplete, adjustedCompleteDate) - 1) : 0;

    // Job-relative weeks
    const jobWeeks = jobWeekCount(entries);
    const planWeeks = log.planDays ? Math.ceil(log.planDays / 5) : 0;

    // Reamer auto = pipe × 1.5 (display only if blank)
    const reamerAuto = (() => {
      if (log.reaperSize) return log.reaperSize;
      if (!log.pipeSize) return '';
      const m = String(log.pipeSize).match(/(\d+(?:\.\d+)?)/);
      if (!m) return '';
      return (parseFloat(m[1]) * 1.5).toFixed(0) + '"';
    })();

    return { totalLF, boresDone, phDays, delayDays, breakdownDays, rigDates, totalDays,
      planFinLF, actFinLF, pctComplete, slippage, projDays, remaining, overPlan,
      fieldCompleteDate, projectedCompleteDate, actualProjComplete, firstEntryDate,
      adjustedCompleteDate, daysLate,
      jobWeeks, planWeeks, reamerAuto };
  };
  const metrics = useMemo(() => computeMetrics(activeLog), [activeLog]);

  // ── CSV EXPORT ────────────────────────────────────────
  const buildAndDownloadCSV = (log, m) => {
    if (!log) return;
    const rows = [
      ['Live Job List (tickets, KMZ, attachments):', 'https://ducdope.com/'],
      [],
      ['DUC','Customer','City','PM','Plan LF','Plan Days','Plan Rev','Rig','Start Date','Pipe Size','Reamer Size'],
      [log.duc, log.customer, log.city, log.pm,
       log.planLF, log.planDays, log.planRev, log.rig,
       log.startDate, log.pipeSize, m.reamerAuto],
      [],
      ['Wk','Date','Day','Supervisor','Rig','Bore #','Bore LF','Stage','Soil','Drilled LF','Stage Total','Reamer Size','Pipe','Comment','Billed'],
      ...(log.entries||[])
        .slice()
        .sort((a,b) => (b.date||'').localeCompare(a.date||''))
        .map(e => [
          wkLabel(isoWeekNum(e.date)), e.date, e.day, e.sup, e.rig, e.bore,
          e.boreLF, e.stage, e.soil, e.drilledLF, e.stageTotal, e.pipeSize,
          e.finalPipe, e.comment, e.billed?'YES':''
        ]),
      [],
      ['SUMMARY (Plan / Actual / %)'],
      ['Days',          log.planDays, m.totalDays,
        log.planDays?Math.round(m.totalDays/log.planDays*100)+'%':''],
      ['Total Job LF',  log.planLF,   m.totalLF,
        m.pctComplete+'%'],
      ['PH Days',       '—',                m.phDays, ''],
      ['Bore Count',    log.planBores || '—', m.boresDone, ''],
      ['Delays',        '—',                m.delayDays,
        m.totalDays?Math.round(m.delayDays/m.totalDays*100)+'%':''],
      ['Breakdowns',    '—',                m.breakdownDays, ''],
      ['FIN/LF/Day',    m.planFinLF.toFixed(1), m.actFinLF.toFixed(1),
        m.planFinLF?Math.round(m.actFinLF/m.planFinLF*100)+'%':''],
      ['Awarded Date',  log.startDate, '', ''],
      ['Start Date',    log.startDate, log.entries?.[0]?.date||'', ''],
      ['Proj Complete', m.projectedCompleteDate||'', m.fieldCompleteDate||'', ''],
      ['Pipe Size',     log.pipeSize, '', ''],
      ['Reamer Size',   m.reamerAuto, '', ''],
      ['Week Count',    `WK 01 of ${m.planWeeks||'?'}`, `WK ${String(m.jobWeeks).padStart(2,'0')}`, ''],
    ];
    const csv = rows.map(r => r.map(v => `"${String(v||'').replace(/"/g,'""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type:'text/csv' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    const _safe = s => String(s||'').replace(/[^A-Za-z0-9]+/g,'_').replace(/^_+|_+$/g,'').slice(0,40);
    a.href = url; a.download = `${_logNum(log)}_${_safe(log.customer)}_${_safe(log.city)}_DailyLog.csv`; a.click();
    setExportMsg('CSV downloaded'); setTimeout(()=>setExportMsg(''), 3000);
  };
  const exportCSV = () => buildAndDownloadCSV(activeLog, metrics);

  const printPDF = () => {
    window.print();
    setExportMsg('Print dialog opened — save as PDF'); setTimeout(()=>setExportMsg(''), 4000);
  };

  // ── PDF (screenshot) — PDF_SCREENSHOT_V1 ─────────────────
  const _loadScript = (src) => new Promise((resolve, reject) => {
    if ([...document.scripts].some(x => x.src === src)) return resolve();
    const el = document.createElement('script');
    el.src = src; el.onload = () => resolve(); el.onerror = () => reject(new Error('Failed to load library'));
    document.head.appendChild(el);
  });
  const _ensurePdfLibs = async () => {
    if (!window.html2canvas) await _loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
    if (!window.jspdf)       await _loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
  };
  const generateReportPDF = async () => {
    await _ensurePdfLibs();
    const node = document.querySelector('[data-print-report]');
    if (!node) throw new Error('Report not found on page');
    // Browsers cap canvas height (~16k px). A long daily report at scale 2 can blow past that,
    // and html2canvas silently drops the bottom of the page — that's why the Production table
    // (which sits at the bottom) was missing from emailed PDFs. Scale down so it always fits.
    const _fullH = node.scrollHeight || node.offsetHeight || 0;
    const _MAXC = 14000;
    let _scale = 2;
    if (_fullH > 0 && _fullH * _scale > _MAXC) _scale = Math.max(1, _MAXC / _fullH);
    // Safe page-break lines = bottom edge of every table row + bottom of each report block,
    // measured from the DOM (CSS px from node top). The image slicer cuts only at these, so a
    // page break never slices through a row.
    const _rectTop = node.getBoundingClientRect().top;
    const _stops = [];
    node.querySelectorAll('tr').forEach(tr => { _stops.push(tr.getBoundingClientRect().bottom - _rectTop); });
    Array.from(node.children).forEach(ch => { _stops.push(ch.getBoundingClientRect().bottom - _rectTop); });
    const canvas = await window.html2canvas(node, {
      scale: _scale, backgroundColor: '#ffffff', useCORS: true, logging: false,
      ignoreElements: (n) => n.getAttribute && n.getAttribute('data-print-hide') === 'true',
    });
    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF('l', 'pt', 'tabloid');            // 17 x 11 in landscape — width for 4 columns
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const imgW = pageW;
    // CSS-px stops -> canvas px (html2canvas rendered at _scale); in range, unique, sorted
    const _cs = Array.from(new Set(_stops.map(s => Math.round(s * _scale))))
      .filter(s => s > 0 && s < canvas.height).sort((a, b) => a - b);
    const pagePx = pageH * (canvas.width / imgW);          // one page height in canvas px
    const _pages = [];
    let _start = 0;
    while (_start < canvas.height - 1) {
      const _target = _start + pagePx;
      if (_target >= canvas.height) { _pages.push([_start, canvas.height]); break; }
      let _cut = -1;
      for (const s of _cs) { if (s > _start + pagePx * 0.5 && s <= _target) _cut = s; }  // prefer a full-ish page
      if (_cut < 0) { for (const s of _cs) { if (s > _start && s <= _target) _cut = s; } } // else any safe stop
      if (_cut < 0) _cut = Math.floor(_target);            // block taller than a page → hard cut (rare)
      _pages.push([_start, _cut]);
      _start = _cut;
    }
    _pages.forEach(([y0, y1], idx) => {
      const sh = y1 - y0;
      const sc = document.createElement('canvas');
      sc.width = canvas.width; sc.height = sh;
      sc.getContext('2d').drawImage(canvas, 0, y0, canvas.width, sh, 0, 0, canvas.width, sh);
      const data = sc.toDataURL('image/jpeg', 0.92);
      if (idx > 0) pdf.addPage();
      pdf.addImage(data, 'JPEG', 0, 0, imgW, sh * (imgW / canvas.width));
    });
    const _safe = (v) => String(v||'').replace(/[^A-Za-z0-9]+/g,'_').replace(/^_+|_+$/g,'').slice(0,40);
    const filename = `${_logNum(activeLog)}_${_safe(activeLog.customer)}_${_safe(activeLog.city)}_DailyOps.pdf`;
    const blob = pdf.output('blob');
    return { pdf, blob, filename };
  };
  // ── EMAIL REPORT — PDF to internal dist list (EMAIL_REPORT_V1) ──
  const emailReport = async () => {
    try {
      setExportMsg('Building PDF…');
      const { blob, base64: b64, filename } = await buildLogPDF(activeLog.duc); // #EMAIL_USES_BUILDER_V1 — clean text PDF incl. Production
      const mb = blob.size / 1048576;
      if (mb > 3) {
        setExportMsg(`PDF too large to email (${mb.toFixed(1)} MB). Filter the range or tell Claude.`);
        setTimeout(()=>setExportMsg(''), 8000); return;
      }
      setExportMsg('Sending…');
      const _j = jobs.find(x => x.duc === activeLog.duc) || {};
      const _isAuger = activeLog.pm === 'AU' || _j.rig === 'AU';
      const _pmName = _pmTitle(activeLog.pm) || 'UNKNOWN PM';
      const _pmMail = _pmEmail(activeLog.pm);   // #DAILYOPS_ROUTING_V1
      const _submittedBy = _nameFromUpn(upn) || _pmName;   // #DAILYOPS_SUBMITTEDBY_V1
      const subject = _dailyOpsSubject(activeLog.pm, _isAuger, { jobNo: _logNum(activeLog), customer: activeLog.customer, city: activeLog.city });
      const html = `<p>Daily Operations Report attached.</p>`
        + `<p><strong>${_logNum(activeLog)}</strong> — ${activeLog.customer||''} &middot; ${activeLog.city||''}</p>`
        + (activeLog.desc ? `<p>${activeLog.desc}</p>` : '')
        + `<p>Submitted by: ${_submittedBy}</p>`
        + `<p>#WEAREDAKOTA</p>`;
      const res = await fetch('/api/send-email', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ subject, html, ...(_pmMail ? { cc: [_pmMail] } : {}), attachments:[{ name: filename, contentType:'application/pdf', contentBytes: b64 }] })
      });
      const data = await res.json();
      if (data && data.ok) {
        setExportMsg(`✓ Emailed to distribution list (${data.count||1})`);
      } else {
        setExportMsg('Email failed: ' + ((data && (data.message||data.error)) || 'unknown'));
      }
      setTimeout(()=>setExportMsg(''), 8000);
    } catch (err) {
      setExportMsg('Email failed: ' + (err && err.message ? err.message : 'unknown'));
      setTimeout(()=>setExportMsg(''), 8000);
    }
  };

  // ── BULK EMAIL — data-built PDFs, grouped by PM (BULK_EMAIL_V1) ──
  const _pmTitle = (v) => {
    const map = { PG:'Perry Graff', CT:'Cory Tate', CJ:'Chris Jurcik', RM:'Ruben Mendez', AU:'Auger' };
    const key = (v||'').trim().toUpperCase();
    if (map[key]) return map[key];
    return (v||'').trim().split(/\s+/)
      .map(w => w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w).join(' ');
  };
  const _safeName = (v) => String(v||'').replace(/[^A-Za-z0-9]+/g,'_').replace(/^_+|_+$/g,'').slice(0,40);
  // #DAILYOPS_ROUTING_V1 (2026-08-26) — Bill/Nathan: none of the 3 Daily Ops sends ever cc'd the
  // person who filed it — _pmTitle only ever resolved a display NAME, never an email, and none of
  // the send-email calls passed a "to"/"cc" at all (always fell through to the server's default
  // M365_DIST_LIST). That's why Bill's mail-relay traffic never showed a send TO Cory: nothing was
  // ever addressed to him. Same static roster as SEED_ROLES below (Auger has no single owner yet —
  // same open item noted in #DAILYOPS_SUBJECT_V1 below).
  const _pmEmail = (v) => {
    const map = { PG:'perry.graff@dakotautility.com', CT:'cory.tate@dakotautility.com', CJ:'chris.jurcik@dakotautility.com', RM:'ruben.mendez@dakotautility.com' };
    return map[(v||'').trim().toUpperCase()] || '';
  };
  // #DAILYOPS_SUBMITTEDBY_V1 (2026-08-26) — Bill: an Auger daily emails "Submitted by: Auger" because
  // AU has no one real person mapped to it (see #DAILYOPS_ROUTING_V1 above) and never will — Auger
  // dailies get filed by whoever's on the rig that day, not a fixed PM. Rather than guess a name,
  // read who's ACTUALLY signed in and sending it (`upn`, already available on every OpsTab function
  // via closure — same identity Safety already stamps onto reportedBy) and turn it into a name from
  // the email's local part. Works for anyone, present or future hires, no roster to maintain.
  const saveCxl = async (duc, bore, note, remove) => {   // #BORE_CXL_V1 — fresh read, merge, write
    const b = String(bore || '').trim(); if (!duc || !b) return;
    let cur = {}; try { const v = await sg('bore-flags'); if (v && typeof v === 'object') cur = v; } catch {}
    const jf = { ...(cur[duc] || {}) };
    if (remove) delete jf[b]; else jf[b] = { note: String(note || '').trim(), by: _nameFromUpn(upn) || String(upn || ''), at: new Date().toISOString() };
    const next = { ...cur, [duc]: jf };
    const ok = await ss('bore-flags', next);
    if (ok === false) { setExportMsg('CXL not saved — sign in again'); return; }
    setBoreFlags(next); setCxlOpen(false); setCxlBore(''); setCxlNote('');
    setExportMsg(remove ? `Bore ${b} CXL removed` : `Bore ${b} flagged CXL`); setTimeout(() => setExportMsg(''), 4000);
  };
  const _nameFromUpn = (u) => {
    const local = String(u || '').split('@')[0];
    if (!local) return '';
    return local.split(/[._-]+/).filter(Boolean).map(w => w[0].toUpperCase() + w.slice(1).toLowerCase()).join(' ');
  };
  // #DAILYOPS_SUBJECT_V1 — single builder for every internal Daily Ops send (was 3 separate ad-hoc
  // subject strings across emailReport / dailyEmailForJob / emailSelected). isAuger mirrors the same
  // test buildLogPDF already uses (pm code or rig code === 'AU'). Empty/unresolved PM name renders as
  // "UNKNOWN PM" instead of silently dropping the name (the Ruben-missing-name bug).
  // #DAILYOPS_SUBJECT_V2 (2026-08-26) — Bill: "Email should also include ... Job Number (If known),
  // City and/or customer in subject." Optional jobInfo = { jobNo, customer, city }; only passed when
  // the send is unambiguously about ONE job (a bulk send covering several jobs for one PM keeps the
  // plain subject — cramming one job's info into a subject covering 3 others would be misleading).
  const _dailyOpsSubject = (pmCode, isAuger, jobInfo) => {
    const name = _pmTitle(pmCode) || 'UNKNOWN PM';
    let s = `${name} - ${isAuger ? 'Auger ' : ''}Daily Ops`;
    if (jobInfo) {
      const bits = [jobInfo.jobNo, jobInfo.customer, jobInfo.city].filter(Boolean);
      if (bits.length) s += ` — ${bits.join(' · ')}`;
    }
    return s;
  };

  // Build a clean report PDF directly from a log's data (works without the log being open)
  const buildLogPDF = async (duc, external = false) => {
    await _ensurePdfLibs();
    const { jsPDF } = window.jspdf;
    const j = jobs.find(x => x.duc === duc) || {};
    const log = jobLogs[duc] || {};
    let _hasBid = false;
    try { const _bidSlots = await sg('slots:job:'+duc); _hasBid = !!(_bidSlots && _bidSlots.bid && (_bidSlots.bid.data || _bidSlots.bid.path)); } catch {}
    const entries = (log.entries || []).slice().sort((a,b)=>(b.date||'').localeCompare(a.date||''));

    // ── metrics (mirror the on-screen report) ──
    const planLF    = log.planLF   || j.plf  || 0;
    const planDays  = log.planDays || j.days || 0;
    const planBores = log.planBores || j.bores || 0;
    const startDate = log.startDate || j.ad || '';
    const pipeSize  = j.pipe || log.pipeSize || '';
    const _auger    = j.pm==='AU' || j.rig==='AU';
    const pulls     = _auger ? entries.filter(e => (Number(e.drilledLF)||0) !== 0) : entries.filter(e => e.stage === 'Pull' && e.drilledLF > 0);
    const totalLF   = pulls.reduce((s,e)=>s+(Number(e.drilledLF)||0),0);
    const boresDone = _auger ? [...new Set(entries.filter(e=>{const _s=String(e.stage||'').toUpperCase();return _s==='PULL'||_s==='CMP';}).map(e=>String(e.bore)))].length : [...new Set(pulls.map(e=>String(e.bore)))].length;
    const _rk = e => `${e.date||''}|${String(e.sup||'').trim().toUpperCase()}|${String(e.rig||'').trim().toUpperCase()}`;
    const phDays    = [...new Set(entries.filter(e=>e.stage==='PH' && e.date).map(_rk))].length;
    const delayDays = [...new Set(entries.filter(e=>(e.stage==='Delay'||matchesDelay(e.comment)) && e.date).map(_rk))].length;
    const totalDays = [...new Set(entries.filter(e=>e.date).map(_rk))].length;
    const planFinLF = planDays ? planLF/planDays : 0;
    const actFinLF  = totalDays ? totalLF/totalDays : 0;
    const pctComplete = planLF ? Math.round(totalLF/planLF*100) : 0;
    const firstEntryDate = entries.map(e=>e.date).filter(Boolean).sort()[0] || null;
    const projectedCompleteDate = startDate && planDays ? addWeekdays(startDate, planDays) : null;
    const actualProjComplete = firstEntryDate && planDays ? addWeekdays(firstEntryDate, planDays) : null;
    const completeEntries = entries.filter(e=>e.stage==='Complete');
    const fieldCompleteDate = completeEntries.length ? completeEntries.map(e=>e.date).sort().slice(-1)[0] : null;
    const jobWeeks  = jobWeekCount(entries);
    const planWeeks = planDays ? Math.ceil(planDays/5) : 0;
    const reamerAuto = (() => {
      if (log.reaperSize) return log.reaperSize;
      if (!pipeSize) return '';
      const m = String(pipeSize).match(/(\d+(?:\.\d+)?)/);
      return m ? (parseFloat(m[1])*1.5).toFixed(0)+'"' : '';
    })();
    const isComplete = j.stat === 'Complete';
    const unbilled   = (_auger ? entries.filter(e => isBillPull(e, true)) : pulls).filter(e=>!e.billed).length;   // #AUGER_PULL_BILL_V1 — auger: PULL rows, not every footage row
    const remaining  = (planLF||0) - totalLF;
    const projDays   = actFinLF > 0 ? Math.ceil(remaining/actFinLF) : null;
    const overPlan   = (planLF||0) > 0 && totalLF >= (planLF||0);
    let slipColor = [232,93,36], slipLabel = '';
    if (planFinLF>0 && actFinLF>0) { const r=actFinLF/planFinLF;
      if(r<0.6){slipColor=[220,38,38];slipLabel='SLIPPING';}
      else if(r<0.8){slipColor=[180,83,9];slipLabel='WATCH';} }
    if (overPlan) { slipColor=[22,163,74]; slipLabel=''; } // exceeded plan — no slip warning

    const pdf = new jsPDF('l','pt','letter');
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const M = 30;
    const right = pageW - M;
    const gridW = right - M;

    // ── HEADER (logo + title + badges + PM block) ──
    const drawHeader = () => {
      const topY = M;
      try { pdf.addImage('data:image/jpeg;base64,'+LOGO_COLOR_B64, 'JPEG', M, topY, 100, 42); } catch(e){}
      const tx = M + 112;
      pdf.setFont('helvetica','bold'); pdf.setFontSize(20); pdf.setTextColor(17,24,39);
      pdf.text('DAILY OPERATIONS REPORT', tx, topY+16);
      if (_hasBid && !external) {  // #BID_LINK_TOP_V1 — compact "View BID" beside the title; hidden on external/customer sends
        const _titleW = pdf.getTextWidth('DAILY OPERATIONS REPORT');
        pdf.setFont('helvetica','bold'); pdf.setFontSize(10); pdf.setTextColor(13,71,161);
        const _bidTxt = 'View BID  >';
        const _bx = tx + _titleW + 14;
        pdf.textWithLink(_bidTxt, _bx, topY+16, { url: 'https://ducdope.com/?job=' + encodeURIComponent(duc) + '&open=bid' });
        pdf.setDrawColor(13,71,161); pdf.setLineWidth(0.5); pdf.line(_bx, topY+18, _bx + pdf.getTextWidth(_bidTxt), topY+18); pdf.setLineWidth(1);
        pdf.setTextColor(17,24,39);
      }
      pdf.setFontSize(13);
      pdf.text(`${j.displayDuc || duc}  -  ${j.cust||''}  -  ${j.city||''}`, tx, topY+33);
      let hy = topY+46;
      if (j.desc) {
        pdf.setFont('helvetica','normal'); pdf.setFontSize(9); pdf.setTextColor(107,114,128);
        const d = String(j.desc).replace(j.cust||'','').replace(/^\s*[-\u2013]\s*/,'');
        pdf.text(d.slice(0,95), tx, hy); hy += 13;
      }
      if (isComplete) {
        let bx = tx;
        pdf.setFillColor(21,128,61); pdf.roundedRect(bx, hy-9, 64, 14, 3, 3, 'F');
        pdf.setFont('helvetica','bold'); pdf.setFontSize(8); pdf.setTextColor(255,255,255);
        pdf.text('COMPLETE', bx+8, hy+1); bx += 72;
        if (unbilled > 0) {
          const label = `BILLING PENDING - ${unbilled} pull${unbilled>1?'s':''}`;
          const w = pdf.getTextWidth(label) + 14;
          pdf.setFillColor(254,243,199); pdf.setDrawColor(245,158,11);
          pdf.roundedRect(bx, hy-9, w, 14, 3, 3, 'FD');
          pdf.setTextColor(146,64,14); pdf.text(label, bx+7, hy+1);
        }
        hy += 9;
      }
      pdf.setFont('helvetica','bold'); pdf.setFontSize(13); pdf.setTextColor(17,24,39);
      pdf.text(`PM: ${_pmTitle(j.pm)||'UNKNOWN PM'}`, right, topY+15, {align:'right'});
      pdf.setFont('helvetica','normal'); pdf.setFontSize(8); pdf.setTextColor(107,114,128);
      pdf.text(new Date().toLocaleString('en-US',{month:'numeric',day:'numeric',year:'2-digit',hour:'numeric',minute:'2-digit'}), right, topY+27, {align:'right'});
      pdf.setTextColor(232,93,36); pdf.setFontSize(8.5);
      pdf.text('dakotautility.com', right, topY+39, {align:'right'});
      pdf.setTextColor(107,114,128); pdf.setFontSize(7.5);
      pdf.text('#WEAREDAKOTA', right, topY+49, {align:'right'});
      const dividerY = Math.max(hy+6, topY+56);
      pdf.setDrawColor(226,232,240); pdf.line(M, dividerY, right, dividerY);
      return dividerY + 10;
    };

    // ── SUMMARY GRID (PLAN / ACTUAL / %) ──
    const drawGrid = (startY) => {
      const labelW = 60;
      const heads = ['Day(s)','Total Job LF','PH Days','Bore(s)','FIN/LF','Award','Start','Proj Complete','Pipe Size','Reamer Size','WK Count'];
      const colW = (gridW - labelW) / heads.length;
      const rowH = 16;
      let y = startY;
      const cell = (txt,i,yy) => pdf.text(String(txt), M+labelW+i*colW+colW/2, yy+11, {align:'center'});
      // header
      pdf.setFillColor(241,245,249); pdf.rect(M, y, gridW, rowH, 'F');
      pdf.setFont('helvetica','bold'); pdf.setFontSize(6.3); pdf.setTextColor(71,85,105);
      heads.forEach((h,i)=>cell(h,i,y)); y += rowH;
      // PLAN
      const planVals = [planDays||'-', (planLF||0).toLocaleString(), '-',planBores||'-',
        planFinLF?planFinLF.toFixed(0)+'/d':'-', fmtD(startDate), '-',
        '-', pipeSize||'-', reamerAuto||'-',
        planWeeks?String(planWeeks).padStart(2,'0'):'-'];
      pdf.setFillColor(255,245,239); pdf.rect(M, y, gridW, rowH, 'F');
      pdf.setFont('helvetica','bold'); pdf.setFontSize(7.5); pdf.setTextColor(154,52,18);
      pdf.text('PLAN', M+5, y+11);
      pdf.setFontSize(7.5); planVals.forEach((v,i)=>cell(v,i,y)); y += rowH;
      // ACTUAL
      const actVals = [totalDays, (totalLF||0).toLocaleString(), phDays, boresDone,
        actFinLF?actFinLF.toFixed(0)+'/d':'-', fmtD(startDate),
        fmtD(firstEntryDate), fmtD(fieldCompleteDate||actualProjComplete),
        pipeSize||'-', reamerAuto||'-', jobWeeks?String(jobWeeks).padStart(2,'0'):'-'];
      pdf.setFillColor(239,246,255); pdf.rect(M, y, gridW, rowH, 'F');
      pdf.setTextColor(29,78,216); pdf.text('ACTUAL', M+5, y+11);
      actVals.forEach((v,i)=>cell(v,i,y)); y += rowH;
      // %
      const pctVals = [planDays?Math.round(totalDays/planDays*100)+'%':'', pctComplete+'%','',
        planBores?Math.round(boresDone/planBores*100)+'%':'','',
        planFinLF?Math.round(actFinLF/planFinLF*100)+'%':'','','','','',
        planWeeks?Math.round(jobWeeks/planWeeks*100)+'%':''];
      pdf.setFillColor(248,250,252); pdf.rect(M, y, gridW, rowH, 'F');
      pdf.setFont('helvetica','bold'); pdf.setFontSize(6.3); pdf.setTextColor(71,85,105);
      pdf.text('%', M+5, y+11);
      pctVals.forEach((v,i)=>{ if(v) cell(v,i,y); }); y += rowH;
      pdf.setDrawColor(226,232,240); pdf.rect(M, startY, gridW, y-startY);
      return y;
    };

    // ── PROGRESS BAR + RATE + DELAY KPI ──
    const drawProgress = (startY) => {
      let y = startY + 14;
      pdf.setFont('helvetica','bold'); pdf.setFontSize(9); pdf.setTextColor(17,24,39);
      pdf.text(`${(totalLF||0).toLocaleString()} / ${(planLF||0).toLocaleString()} LF`, M, y);
      pdf.setFont('helvetica','bold'); pdf.setFontSize(9); pdf.setTextColor(slipColor[0],slipColor[1],slipColor[2]);
      const compTxt = overPlan ? `${pctComplete}% Complete · OVER PLAN` : `${pctComplete}% Complete`;
      if (slipLabel) {
        const gap = 6, boltW = 6;
        const total = pdf.getTextWidth(compTxt) + gap + boltW + 2 + pdf.getTextWidth(slipLabel);
        let sx = right - total;
        pdf.text(compTxt, sx, y); sx += pdf.getTextWidth(compTxt) + gap;
        pdf.setFillColor(slipColor[0],slipColor[1],slipColor[2]);
        pdf.lines([[-3,4.5],[2,0],[-0.8,3.5],[3.8,-5],[-2.2,0],[0.2,-3]], sx+3, y-7, [1,1], 'F', true);
        sx += boltW + 2;
        pdf.text(slipLabel, sx, y);
      } else {
        pdf.text(compTxt, right, y, {align:'right'});
      }
      y += 6;
      const barH = 5, pct = Math.min(pctComplete,100)/100;
      pdf.setFillColor(226,232,240); pdf.roundedRect(M, y, gridW, barH, 2, 2, 'F');
      if (pct > 0) { pdf.setFillColor(slipColor[0],slipColor[1],slipColor[2]);
        pdf.roundedRect(M, y, Math.max(2, gridW*pct), barH, 2, 2, 'F'); }
      y += barH + 11;
      if (overPlan) {
        pdf.setFont('helvetica','bold'); pdf.setFontSize(8); pdf.setTextColor(22,163,74);
        const t = `Exceeded planned LF by ${Math.abs(remaining||0).toLocaleString()} LF`; pdf.text(t, M, y);
        pdf.setFont('helvetica','normal'); pdf.setTextColor(0,0,0);
        pdf.text(`  \u2014  scope grew beyond original plan`, M + pdf.getTextWidth(t), y);
        y += 11;
      } else if (projDays != null) {
        pdf.setFont('helvetica','normal'); pdf.setFontSize(8); pdf.setTextColor(0,0,0);
        const a = 'At current rate \u2014 '; pdf.text(a, M, y);
        const wa = pdf.getTextWidth(a);
        pdf.setFont('helvetica','bold'); pdf.setTextColor(slipColor[0],slipColor[1],slipColor[2]);
        const b = `${projDays} more rig days`; pdf.text(b, M+wa, y);
        const wb = pdf.getTextWidth(b);
        pdf.setFont('helvetica','normal'); pdf.setTextColor(0,0,0);
        pdf.text(` to complete  \u00b7  ${(remaining||0).toLocaleString()} LF remaining`, M+wa+wb, y);
        y += 11;
      }
      if (totalDays > 0) {
        pdf.setFont('helvetica','normal'); pdf.setFontSize(8);
        pdf.setTextColor(delayDays>0?180:107, delayDays>0?83:114, delayDays>0?9:128);
        pdf.text(`${delayDays} weather/delay days of ${totalDays} actual days  \u00b7  ${Math.round(delayDays/totalDays*100)}% lost to delays`, M, y);
        y += 8;
      }
      if (overPlan && planFinLF>0 && actFinLF>0 && actFinLF < planFinLF*0.8) {
        pdf.setFont('helvetica','bold'); pdf.setFontSize(8); pdf.setTextColor(133,79,11);
        pdf.text(`Daily rate below plan: ${Math.round(actFinLF)} vs ${Math.round(planFinLF)} LF/day planned`, M, y);
        y += 8;
      }
      return y + 6;
    };

    // ── ENTRIES TABLE (#DAILY_RPT_DAYBLOCK_V1: day-grouped like the editing view; days newest-first, bores high→low) ──
    const tcols = [['WK',32],['Date',44],['Day',26],['Sup',52],['Rig',38],['Bore',28],
      ['Bore LF',36],['Stage',40],['Soil',38],['Drilled',42],['Stg LF',38],['Size',30],
      ['Pipe',32],['Comments',0],['Inv',22]];
    const fixedW = tcols.reduce((s,c)=>s+c[1],0);
    tcols[13][1] = Math.max(120, gridW - fixedW);
    const colX = []; { let cx=M; tcols.forEach(([_,w])=>{ colX.push(cx); cx+=w; }); }
    const drawTableHead = (y) => {
      pdf.setFillColor(241,245,249); pdf.rect(M, y, gridW, 14, 'F');
      pdf.setFont('helvetica','bold'); pdf.setFontSize(6); pdf.setTextColor(71,85,105);
      let x = M; tcols.forEach(([label,w])=>{ pdf.text(label, x+2, y+9); x += w; });
      return y + 14;
    };
    // #AUGER_PILL_PARITY_V1 — auger jobs spell their stages differently (PULL/DRILL, all-caps,
    // per AUGER_STAGES) than HDD's (Pull/Ream, title-case). This function only matched HDD spellings,
    // so every auger stage fell through to the flat gray default — no green PULL, no amber DRILL,
    // same complaint Bill raised about the billed/INV checkbox never lighting up for auger pulls
    // (that checkbox is gated on the same isPull test elsewhere). isAuger param recognizes both.
    const stagePill = (stage, dly, isAuger) => {
      if (stage==='Pull' || (isAuger && stage==='PULL'))     return {bg:[220,252,231], fg:[21,128,61], label:'PULL'};
      if (stage==='Inner')    return {bg:[220,252,231], fg:[21,128,61], label:'INNER'};
      if (stage==='Complete') return {bg:[220,252,231], fg:[21,128,61], label:stage};
      if (dly || stage==='Delay') return {bg:[254,226,226], fg:[185,28,28], label:stage||'Delay'};
      if (stage==='Pilot')    return {bg:[239,246,255], fg:[30,64,175], label:stage};
      if (stage==='Ream' || (isAuger && stage==='DRILL'))     return {bg:[254,243,199], fg:[180,83,9], label:stage};
      if (stage==='Swab')     return {bg:[243,232,255], fg:[107,33,168], label:stage};
      if (stage==='Casing')   return {bg:[204,251,241], fg:[15,118,110], label:stage};
      if (!stage) return null;
      return {bg:[248,250,252], fg:[107,114,128], label:stage};
    };

    // #DAYBLOCK_ROW_V1 — draw one entry row. lead = [WK,Date,Day,Sup,Rig] fills the identity cols
    // (used for single-entry days that render as one flat line); lead=null leaves them blank (a
    // child row under a multi-entry day bar). wkChange draws the bold week-boundary rule on top.
    const drawEntryRow = (e, i, lead, wkChange, y) => {
      const commentW = tcols[13][1] - 4;
      const commentLines = pdf.splitTextToSize(String(e.comment||''), commentW);
      const rowH = Math.max(14, commentLines.length*8 + 6);
      if (y + rowH > pageH - M - 16) { pdf.addPage(); y = drawTableHead(M); }
      const isPull  = e.stage === 'Pull' || (_auger && e.stage === 'PULL');
      const isDelay = e.stage === 'Delay' || matchesDelay(e.comment);
      const isComp  = e.stage === 'Complete';
      let bg = null;
      if (isPull && e.billed) bg = [255,240,230];
      else if (isPull)        bg = [255,212,194];
      else if (isComp)        bg = [240,253,244];
      else if (i % 2 === 1)   bg = [250,251,252];
      if (bg) { pdf.setFillColor(bg[0],bg[1],bg[2]); pdf.rect(M, y, gridW, rowH, 'F'); }
      if (isDelay) { pdf.setFillColor(191,219,254); pdf.rect(colX[13], y, tcols[13][1], rowH, 'F'); }
      const _cx = cxlOf(duc, e.bore);   // #BORE_CXL_V1
      const accent = _cx ? [220,38,38] : isPull ? (e.billed?[251,146,60]:[232,93,36]) : isComp ? [21,128,61] : isDelay ? [29,78,216] : null;
      if (accent) { pdf.setFillColor(accent[0],accent[1],accent[2]); pdf.rect(M, y, 3, rowH, 'F'); }
      // top rule: bold black at a week boundary wins; otherwise the pull accent line
      if (wkChange) { pdf.setDrawColor(0,0,0); pdf.setLineWidth(1.2); pdf.line(M, y, right, y); pdf.setLineWidth(1); }
      else if (isPull) { pdf.setDrawColor(e.billed?251:232, e.billed?146:93, e.billed?60:36); pdf.line(M, y, right, y); }
      if (lead) { pdf.setFont('helvetica','bold'); pdf.setFontSize(6.5); pdf.setTextColor(30,41,59);
        for (let c=0;c<5;c++){ const t=pdf.splitTextToSize(String(lead[c]??''), tcols[c][1]-3); pdf.text(t, colX[c]+2, y+9); } }
      pdf.setFont('helvetica', isPull?'bold':'normal'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
      const vals = [null,null,null,null,null,
        (e.bore||'') + (_cx ? ' CXL' : ''), (e.boreLF!=null&&e.boreLF!==''?Number(e.boreLF).toLocaleString():''), null, e.soil||'',
        (e.drilledLF!=null&&e.drilledLF!==''?Number(e.drilledLF).toLocaleString():''), (e.stageTotal!=null&&e.stageTotal!==''?Number(e.stageTotal).toLocaleString():''),
        e.pipeSize||'', e.finalPipe||''];
      for (let c=5;c<13;c++){ if (c===7) continue;
        const t = pdf.splitTextToSize(String(vals[c]??''), tcols[c][1]-3);
        if (c===5 && _cx) { pdf.setFont('helvetica','bold'); pdf.setTextColor(220,38,38); }   // #BORE_CXL_V1
        pdf.text(t, colX[c]+2, y+9);
        if (c===5 && _cx) { pdf.setFont('helvetica', isPull?'bold':'normal'); pdf.setTextColor(30,30,30); } }
      const sp = stagePill(e.stage, isDelay, _auger);
      if (sp) {
        pdf.setFont('helvetica','bold'); pdf.setFontSize(6);
        const lbl = String(sp.label);
        const tw = pdf.getTextWidth(lbl);
        const pw = Math.min(tcols[7][1]-4, tw+8);
        const px = colX[7] + (tcols[7][1]-pw)/2;
        pdf.setFillColor(sp.bg[0],sp.bg[1],sp.bg[2]);
        pdf.roundedRect(px, y+2.5, pw, 9, 2.5, 2.5, 'F');
        pdf.setTextColor(sp.fg[0],sp.fg[1],sp.fg[2]);
        pdf.text(lbl, colX[7]+tcols[7][1]/2, y+9, {align:'center'});
      }
      pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
      pdf.text(commentLines, colX[13]+2, y+9);
      if (e.billed) { pdf.setFont('helvetica','bold'); pdf.setTextColor(21,128,61); pdf.text('Y', colX[14]+2, y+9); }
      if (isPull) { pdf.setDrawColor(e.billed?251:232, e.billed?146:93, e.billed?60:36); pdf.line(M, y+rowH, right, y+rowH); }
      else { pdf.setDrawColor(226,232,240); pdf.line(M, y+rowH, right, y+rowH); }
      return y + rowH;
    };
    // ââ PRODUCTION (#PROD_PDF_V1) â supervisor summary first, BY BORE wrapped 20/column ââ
    const drawProduction = (startY) => {
      const _bm = {};
      entries.forEach(e => {
        const bore = String(e.bore||'').trim(); if (!bore) return;
        const b = _bm[bore] || (_bm[bore] = { sups:{}, dates:new Set(), pulled:0 });
        if (e.date) b.dates.add(e.date);
        const sup = String(e.sup||'').trim();
        if (sup && e.date) (b.sups[sup] = b.sups[sup] || new Set()).add(e.date);
        if (e.stage === 'Pull' || (_auger && (Number(e.drilledLF)||0) !== 0)) b.pulled += (Number(e.drilledLF)||0);
      });
      const bores = Object.keys(_bm);
      if (!bores.length) return startY;
      const nat = (a,b)=>{ const na=parseFloat(a), nb=parseFloat(b); if(!isNaN(na)&&!isNaN(nb)&&na!==nb) return na-nb; return String(a).localeCompare(String(b)); };
      bores.sort(nat);
      const r1 = n => Math.round(n*10)/10;
      const detail = bores.map(bore => { const b=_bm[bore]; const days=b.dates.size; const pulled=Math.round(b.pulled);
        const se=Object.entries(b.sups).sort((x,y)=>y[1].size-x[1].size);
        const supLabel = se.length>1 ? `${se[0][0]} +${se.length-1}` : (se[0]?se[0][0]:'—');
        return { bore, supLabel, days, pulled, finlf: days? r1(pulled/days):0, cxl: cxlOf(duc, bore) }; });   // #BORE_CXL_V1
      const roll = {};
      bores.forEach(bore => { const b=_bm[bore]; const names=Object.keys(b.sups); const n=names.length||1;
        names.forEach(s=>{ const r=roll[s]||(roll[s]={days:0,pulled:0}); r.days+=b.dates.size/n; r.pulled+=b.pulled/n; }); });
      const supRows = Object.keys(roll).map(s=>{ const r=roll[s]; return { sup:s, days:r1(r.days), pulled:Math.round(r.pulled), finlf:r.days?r1(r.pulled/r.days):0 }; }).sort((a,b)=>b.finlf-a.finlf);
      const gDays = bores.reduce((t,bore)=>t+_bm[bore].dates.size,0);
      const gPulled = Math.round(bores.reduce((t,bore)=>t+_bm[bore].pulled,0));
      const gFin = gDays? r1(gPulled/gDays):0;
      const TH = 13;
      const drawTbl = (cols, rows, x0, yy, total) => {
        const tw = cols.reduce((s,c)=>s+c[1],0);
        pdf.setFillColor(241,245,249); pdf.rect(x0, yy, tw, TH, 'F');
        pdf.setFont('helvetica','bold'); pdf.setFontSize(6); pdf.setTextColor(71,85,105);
        let cx=x0; cols.forEach(([lbl,w,al])=>{ if(al==='l') pdf.text(String(lbl),cx+3,yy+8.5); else pdf.text(String(lbl),cx+w/2,yy+8.5,{align:'center'}); cx+=w; });
        let ry=yy+TH;
        pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
        rows.forEach(r=>{ let rx=x0; cols.forEach(([lbl,w,al],ci)=>{ const v=String(r[ci]??''); if(al==='l') pdf.text(v,rx+3,ry+8.5); else pdf.text(v,rx+w/2,ry+8.5,{align:'center'}); rx+=w; });
          pdf.setDrawColor(238,238,238); pdf.line(x0,ry+TH,x0+tw,ry+TH); ry+=TH; });
        if (total){ pdf.setFillColor(254,249,231); pdf.rect(x0,ry,tw,TH,'F'); pdf.setFont('helvetica','bold'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
          let rx=x0; cols.forEach(([lbl,w,al],ci)=>{ const v=String(total[ci]??''); if(al==='l') pdf.text(v,rx+3,ry+8.5); else pdf.text(v,rx+w/2,ry+8.5,{align:'center'}); rx+=w; }); ry+=TH; }
        pdf.setDrawColor(226,232,240); pdf.rect(x0, yy, tw, ry-yy);
        return ry;
      };
      let y = startY + 12;
      if (y + 70 > pageH - M - 16) { pdf.addPage(); y = M; }
      pdf.setFont('helvetica','bold'); pdf.setFontSize(11); pdf.setTextColor(232,93,36);
      pdf.text('PRODUCTION', M, y);
      const cap = s => { s=String(s||'').trim(); return s.length>70? s.slice(0,70).trim()+'…' : s; };
      const hdr = [j.cust, j.city, cap(j.desc)].filter(Boolean).join('  ·  ');
      if (hdr){ pdf.setFont('helvetica','normal'); pdf.setFontSize(8); pdf.setTextColor(107,114,128); pdf.text(hdr, right, y, {align:'right'}); }
      y += 14;
      pdf.setFont('helvetica','bold'); pdf.setFontSize(7); pdf.setTextColor(120,120,120);
      pdf.text('BY SUPERVISOR · shared bores split evenly', M, y+6); y += 11;
      y = drawTbl([['SUP',68,'l'],['DAYS',36,'c'],['PULLED LF',54,'c'],['FIN/LF',42,'c']],
                  supRows.map(s=>[s.sup, s.days, s.pulled?s.pulled.toLocaleString():'', s.finlf]),
                  M, y, ['GRAND TOTAL', gDays, gPulled.toLocaleString(), gFin]);
      y += 14;
      pdf.setFont('helvetica','bold'); pdf.setFontSize(7); pdf.setTextColor(120,120,120);
      pdf.text('BY BORE', M, y+6); y += 11;
      const boreCols=[['SUP',44,'l'],['BORE',26,'c'],['DAYS',26,'c'],['PULLED LF',40,'c'],['FIN/LF',32,'c']];
      const colW = boreCols.reduce((s,c)=>s+c[1],0);
      const GAP = 12;
      const perBand = Math.max(1, Math.floor((gridW + GAP) / (colW + GAP)));
      const CH = 20;
      const chunks=[]; for(let i=0;i<detail.length;i+=CH) chunks.push(detail.slice(i,i+CH));
      let bi=0;
      while (bi < chunks.length){
        const band = chunks.slice(bi, bi+perBand);
        const bandRows = Math.max(...band.map(c=>c.length));
        const bandH = TH*(1+bandRows);
        if (y + bandH > pageH - M - 16){ pdf.addPage(); y = M; }
        let bx=M, maxY=y;
        band.forEach(chunk=>{ const data=chunk.map(d=>[d.supLabel,d.bore,d.days,d.cxl?'CXL':(d.pulled?d.pulled.toLocaleString():''),d.cxl?'—':(d.days?d.finlf:'—')]);
          const ey=drawTbl(boreCols, data, bx, y, null); maxY=Math.max(maxY,ey); bx += colW + GAP; });
        y = maxY + 2; bi += perBand;
      }
      if (y + TH > pageH - M - 16){ pdf.addPage(); y=M; }
      const gt=[['GRAND TOTAL',70,'l'],[String(gDays),26,'c'],[gPulled.toLocaleString(),40,'c'],[String(gFin),32,'c']];
      const gtw=gt.reduce((s,c)=>s+c[1],0);
      pdf.setFillColor(254,249,231); pdf.rect(M,y,gtw,TH,'F'); pdf.setDrawColor(226,232,240); pdf.rect(M,y,gtw,TH);
      pdf.setFont('helvetica','bold'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
      let gx=M; gt.forEach(([v,w,al])=>{ if(al==='l') pdf.text(String(v),gx+3,y+8.5); else pdf.text(String(v),gx+w/2,y+8.5,{align:'center'}); gx+=w; }); y+=TH;
      y += 11;
      pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(120,120,120);
      pdf.text('PULLED LF = Pull-stage footage · DAYS = every day on the bore · FIN/LF = pulled ÷ days · shared bores split evenly. #WeAreDakota', M, y);
      // #BORE_CXL_V1 — cancelled bores: footnote (reason only on internal sends)
      detail.filter(d=>d.cxl).forEach(d=>{ y += 9; if (y > pageH - M - 16){ pdf.addPage(); y = M; }
        pdf.setFont('helvetica','bold'); pdf.setFontSize(6.5); pdf.setTextColor(185,28,28);
        const _t = `Bore ${d.bore} CXL (${d.days} ${d.days===1?'day':'days'}, ${d.supLabel})` + (external ? ' — bore cancelled; days stay in FIN/LF.' : ` — ${d.cxl.note}${d.cxl.by?` · flagged by ${d.cxl.by}`:''}. Days stay in FIN/LF.`);
        pdf.text(pdf.splitTextToSize(_t, gridW), M, y); });
      return y;
    };
    const drawPassTracker = (startY) => {
      const rig = String(log.rig||'').toLowerCase();
      if (!['100x140','220x300','220x500','330x500','at120','r4','r5'].includes(rig)) return startY;
      const _allEsP = entries || [];
      const PC = [['mobIn','MOB'],['pilot','PILOT'],['r12','R12'],['r18','R18'],['r24','R24'],['r30','R30'],['r36','R36'],['r42','R42'],['r48','R48'],['r54','R54'],['misc','MISC'],['swab','SWAB'],['pull','PULL'],['mobOut','MOB']];
      const bucket = sz => { const n=parseFloat(String(sz||'').replace(/[^0-9.]/g,'')); if(!n) return null; const B=[12,18,24,30,36,42,48,54]; let best=B[0],bd0=Math.abs(n-best); B.forEach(b=>{const d=Math.abs(n-b); if(d<bd0){bd0=d;best=b;}}); return 'r'+best; };
      const lastD=_allEsP.filter(e=>['Pilot','Ream','Casing','Swab','Pull'].includes(e.stage)).map(e=>e.date).filter(Boolean).sort().slice(-1)[0]||null;
      // #PASS_BY_BORE_V1 (PDF) — same counter on the whole job and on each BORE + SUP slice
      const countP = (es) => {
        const byStage = st => [...new Set(es.filter(e=>e.stage===st && e.date).map(e=>e.date))].length;
        const a = { mobIn:0, pilot:byStage('Pilot'), r12:0,r18:0,r24:0,r30:0,r36:0,r42:0,r48:0,r54:0, misc:0, swab:byStage('Swab'), pull:byStage('Pull'), mobOut:0 };
        const bd={}; es.filter(e=>e.stage==='Ream' && e.date).forEach(e=>{ const b=bucket(e.pipeSize); if(b){ (bd[b]=bd[b]||new Set()).add(e.date); }});
        ['r12','r18','r24','r30','r36','r42','r48','r54'].forEach(k=>{ a[k]=bd[k]?bd[k].size:0; });
        const mobD=[...new Set(es.filter(e=>['MOB','SETUP'].includes(e.stage) && e.date).map(e=>e.date))].sort();
        mobD.forEach(d=>{ if(lastD && d>lastD) a.mobOut++; else a.mobIn++; });
        a.misc=[...new Set(es.filter(e=>e.date && !String(e.stage||'').trim()).map(e=>e.date))].length;
        return a;
      };
      const a = countP(_allEsP);
      const _natP = (x,y) => { const na=parseFloat(x), nb=parseFloat(y); if(!isNaN(na)&&!isNaN(nb)&&na!==nb) return na-nb; return String(x).localeCompare(String(y)); };
      const _sl = {};
      _allEsP.forEach(e=>{ if(!e.date) return; const bore=String(e.bore||'').trim()||'—'; const sup=String(e.sup||'').trim()||'—'; const k=bore+'|'+sup; (_sl[k]=_sl[k]||{bore,sup,first:e.date,es:[]}).es.push(e); if(e.date<_sl[k].first) _sl[k].first=e.date; });
      const boreRowsP = Object.values(_sl).sort((x,y)=>_natP(x.bore,y.bore) || x.first.localeCompare(y.first)).map(r=>({...r, a:countP(r.es)}));
      const showBoreP = boreRowsP.length > 1;
      const plan = log.passPlan || {};
      const sumO = o => Math.round(PC.reduce((t,[k])=>t+(Number(o[k])||0),0)*10)/10;
      const TH2 = 14, labelW = showBoreP ? 86 : 46, totW = 46, nCols = PC.length;
      const colW = (gridW - labelW - totW) / nCols;
      let y = startY + 14;
      if (y + TH2*(3 + (showBoreP ? boreRowsP.length : 0)) + 26 > pageH - M - 16) { pdf.addPage(); y = M; }
      pdf.setFont('helvetica','bold'); pdf.setFontSize(11); pdf.setTextColor(232,93,36);
      pdf.text('PASS TRACKER', M, y);
      pdf.setFont('helvetica','normal'); pdf.setFontSize(8); pdf.setTextColor(107,114,128);
      pdf.text('Days per pass  ·  ACTUAL live from entries', right, y, {align:'right'});
      y += 8;
      const x0 = M;
      const bounds=[x0, x0+labelW]; for(let i=1;i<=nCols;i++) bounds.push(x0+labelW+i*colW); bounds.push(x0+gridW);
      pdf.setFillColor(241,245,249); pdf.rect(x0, y, gridW, TH2, 'F');
      pdf.setFont('helvetica','bold'); pdf.setFontSize(6); pdf.setTextColor(71,85,105);
      PC.forEach(([k,lbl],i)=>{ pdf.text(String(lbl), x0+labelW+i*colW+colW/2, y+9, {align:'center'}); });
      pdf.text('TOT DAY(S)', x0+gridW-totW/2, y+9, {align:'center'});
      let ry = y+TH2;
      const drawRow = (lbl, o, fr, fg, fb) => {
        pdf.setFillColor(fr,fg,fb); pdf.rect(x0, ry, gridW, TH2, 'F');
        pdf.setFillColor(254,249,231); pdf.rect(x0+gridW-totW, ry, totW, TH2, 'F');
        pdf.setFont('helvetica','bold'); pdf.setFontSize(6.8); pdf.setTextColor(30,30,30);
        pdf.text(lbl, x0+4, ry+9);
        pdf.setFont('helvetica','normal');
        PC.forEach(([k],i)=>{ const v=o[k]; pdf.text(v?String(v):'', x0+labelW+i*colW+colW/2, ry+9, {align:'center'}); });
        pdf.setFont('helvetica','bold'); pdf.text(String(sumO(o)), x0+gridW-totW/2, ry+9, {align:'center'});
        ry += TH2;
      };
      if (showBoreP) { pdf.setFont('helvetica','bold'); pdf.setFontSize(6); pdf.setTextColor(71,85,105); pdf.text('BORE #', x0+4, y+9); pdf.text('SUP', x0+34, y+9); }
      drawRow('PLAN', plan, 255,245,239);
      const _hLines = [y, y+TH2, y+2*TH2];
      if (showBoreP) {
        boreRowsP.forEach(r => {
          pdf.setFillColor(255,255,255); pdf.rect(x0, ry, gridW, TH2, 'F');
          pdf.setFillColor(254,249,231); pdf.rect(x0+gridW-totW, ry, totW, TH2, 'F');
          pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(30,30,30);
          pdf.text(String(r.bore), x0+14, ry+9, {align:'center'});
          pdf.text(pdf.splitTextToSize(String(r.sup), labelW-36)[0]||'', x0+34, ry+9);
          PC.forEach(([k],i)=>{ const v=r.a[k]; pdf.text(v?String(v):'', x0+labelW+i*colW+colW/2, ry+9, {align:'center'}); });
          pdf.setFont('helvetica','bold'); pdf.text(String(sumO(r.a)), x0+gridW-totW/2, ry+9, {align:'center'});
          ry += TH2; _hLines.push(ry);
        });
      }
      const _actTop = ry;
      drawRow(showBoreP ? 'ACTUAL (JOB)' : 'ACTUAL', a, 239,246,255);
      pdf.setDrawColor(203,213,225); pdf.setLineWidth(0.5);
      bounds.forEach(xx=>pdf.line(xx, y, xx, ry));
      _hLines.forEach(yy=>pdf.line(x0, yy, x0+gridW, yy));
      pdf.line(x0, ry, x0+gridW, ry);
      if (showBoreP) { pdf.setDrawColor(30,30,30); pdf.setLineWidth(1.2); pdf.line(x0, _actTop, x0+gridW, _actTop); }
      pdf.setLineWidth(0.2);
      y = ry + 11;
      pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(120,120,120);
      pdf.text('PLAN carries from the Job List.   ACTUAL = day-count per pass, live from entries.   MISC = blank-stage days.' + (showBoreP ? '   BORE rows by SUP; ACTUAL (JOB) counts rig days once.' : '') + '   #WeAreDakota', M, y);
      return y;
    };
    let y = drawHeader();
    y = drawGrid(y);
    y = drawProgress(y);
    if (!entries.length) {
      pdf.setFont('helvetica','normal'); pdf.setFontSize(9); pdf.setTextColor(150,150,150);
      pdf.text('No entries recorded for this job.', M, y+12);
    } else {
      y = drawTableHead(y);
      // #DAILY_RPT_DAYBLOCK_V2 — group by DATE + SUP + RIG. A single day can have several
      // supervisors/rigs on the job; each becomes its OWN block with its bores beneath, so a
      // second supervisor's entries are never folded under the first one's name (the ED/MANUEL
      // mix-up). Matches the on-screen editing view. Days newest-first; bores high->low.
      const _sortedE = entries.slice().sort((a,b)=>{
        const d=(b.date||'').localeCompare(a.date||''); if(d) return d;
        const su=String(a.sup||'').localeCompare(String(b.sup||'')); if(su) return su;
        const ri=String(a.rig||'').localeCompare(String(b.rig||'')); if(ri) return ri;
        return (Number(b.bore)||0)-(Number(a.bore)||0);
      });
      const _groups=[]; const _gx={};
      _sortedE.forEach(e=>{ const k=`${e.date||''}|${e.sup||''}|${e.rig||''}`; if(!(k in _gx)){_gx[k]=_groups.length; _groups.push({date:e.date,sup:e.sup,rig:e.rig,day:e.day,rows:[]});} _groups[_gx[k]].rows.push(e); });
      _groups.forEach(g=>g.rows.sort((a,b)=>(Number(b.bore)||0)-(Number(a.bore)||0)||(b.id||0)-(a.id||0)));
      let _lastWk=null; let _prevDate=null;
      // #DAILY_RPT_OFFJOB_V1 — mirror the on-screen OFF JOB break: when >14 days pass between
      // consecutive worked days, draw an amber divider so a year-boundary week jump (e.g. WK 04
      // in 2026 down to WK 46 in 2025) reads as an off-job gap, not a sort error.
      const _drawOffJobBar = (gap, olderD, newerD, yy) => {
        const bh = 15;
        if (yy + bh + 4 > pageH - M - 16) { pdf.addPage(); yy = drawTableHead(M); }
        yy += 4;
        pdf.setFillColor(254,243,199); pdf.setDrawColor(217,119,6); pdf.setLineWidth(0.8);
        if (pdf.setLineDashPattern) pdf.setLineDashPattern([2,2], 0);
        pdf.roundedRect(M, yy, gridW, bh, 3, 3, 'FD');
        if (pdf.setLineDashPattern) pdf.setLineDashPattern([], 0);
        pdf.setLineWidth(1);
        pdf.setFont('helvetica','bold'); pdf.setFontSize(8); pdf.setTextColor(146,64,14);
        pdf.text(`OFF JOB — ${gap} DAYS  (${fmtD(olderD)} to ${fmtD(newerD)})`, M + gridW/2, yy+10, {align:'center'});
        return yy + bh + 4;
      };
      _groups.forEach(g=>{
        const dk = g.date||'';
        const rows = g.rows;
        const e0 = rows[0] || {};
        const _wk = isoWeekNum(dk); const _wkChange = (_wk !== _lastWk); _lastWk = _wk;
        const _gap = (_prevDate && dk) ? Math.round((new Date(_prevDate+'T12:00:00') - new Date(dk+'T12:00:00'))/86400000) : 0;
        if (_gap > 14) y = _drawOffJobBar(_gap, dk, _prevDate, y);
        const pulled = rows.filter(r=>isPullStage(r, _auger)).length;   // #AUGER_PULL_BILL_V1
        const dayLF = rows.reduce((s,r)=>s+(Number(r.stageTotal)||0),0);
        if (rows.length === 1) {
          // #DAYBLOCK_SINGLE_V1 — one entry → one clean flat line (no header bar / tree).
          const lead = [wkLabel(_wk), fmtD(dk), g.day||e0.day||'', g.sup||'', g.rig||''];
          y = drawEntryRow(e0, 0, lead, _wkChange, y);
        } else {
          if (y + 30 > pageH - M - 16) { pdf.addPage(); y = drawTableHead(M); }
          // day-group bar (carries WK/Date/Day/Sup/Rig once, plus the summary)
          pdf.setFillColor(236,239,244); pdf.rect(M, y, gridW, 15, 'F');
          // #WEEK_RULE_V2 — bold black rule ONLY at a week boundary (WK changed), not every day.
          if (_wkChange) { pdf.setDrawColor(0,0,0); pdf.setLineWidth(1.2); pdf.line(M, y, right, y); pdf.setLineWidth(1); }
          pdf.setFont('helvetica','bold'); pdf.setFontSize(7); pdf.setTextColor(30,41,59);
          const dvals = [wkLabel(_wk), fmtD(dk), g.day||e0.day||'', g.sup||'', g.rig||''];
          for (let c=0;c<5;c++){ const t=pdf.splitTextToSize(String(dvals[c]??''), tcols[c][1]-3); pdf.text(t, colX[c]+2, y+10); }
          pdf.setFont('helvetica','normal'); pdf.setFontSize(6.5); pdf.setTextColor(71,85,105);
          const summ = rows.length + ' bores \u00B7 ' + rows.length + ' entries \u00B7 ' + pulled + ' pulled \u00B7 ' + dayLF.toLocaleString() + ' LF';
          pdf.text(summ, right-2, y+10, {align:'right'});
          y += 15;
          rows.forEach((e, i) => { y = drawEntryRow(e, i, null, false, y); });
        }
        _prevDate = dk;
      });
    }
    y = drawPassTracker(y);
    y = drawProduction(y);
    const pages = pdf.internal.getNumberOfPages();
    for (let p=1;p<=pages;p++){ pdf.setPage(p); pdf.setFont('helvetica','normal'); pdf.setFontSize(7); pdf.setTextColor(160,160,160);
      pdf.text('#WEAREDAKOTA', M, pageH-12); pdf.text(`Page ${p} of ${pages}`, right-54, pageH-12); }
    const filename = `${j.displayDuc || duc}_${_safeName(j.cust)}_${_safeName(j.city)}_DailyOps.pdf`;
    const blob = pdf.output('blob');
    const base64 = pdf.output('datauristring').split(',')[1];
    return { blob, base64, filename };
  };

  // Email the Daily Report to a customer via Graph (typed/confirmed address, PDF attached)
  // #6 — per-job helpers so the summary and opened views perform identically
  const csvForJob = (duc) => { const raw = jobLogs[duc]; if (!raw) return; const log = _hydrate(raw); buildAndDownloadCSV(log, computeMetrics(log)); };
  const pdfForJob = async (duc) => {
    setCustSend({ duc, msg: 'Building PDF\u2026' });
    try {
      const { blob, filename } = await buildLogPDF(duc);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      setCustSend({ duc, msg: '\u2713 PDF downloaded' });
    } catch (e) { setCustSend({ duc, msg: 'PDF failed: ' + (e&&e.message?e.message:'error') }); }
    setTimeout(()=>setCustSend(null), 5000);
  };
  const dailyEmailForJob = async (duc) => {
    setCustSend({ duc, msg: 'Building PDF\u2026' });
    try {
      const j = jobs.find(x => x.duc === duc) || {};
      const _isAuger = j.pm === 'AU' || j.rig === 'AU';
      const _pmName = _pmTitle(j.pm) || 'UNKNOWN PM';
      const _pmMail = _pmEmail(j.pm);   // #DAILYOPS_ROUTING_V1
      const _submittedBy = _nameFromUpn(upn) || _pmName;   // #DAILYOPS_SUBMITTEDBY_V1
      const { base64, filename } = await buildLogPDF(duc);
      const mb = (base64.length * 0.75) / 1048576;
      if (mb > 3) { setCustSend({ duc, msg: `PDF too large to email (${mb.toFixed(1)} MB).` }); setTimeout(()=>setCustSend(null), 8000); return; }
      setCustSend({ duc, msg: 'Sending to distribution list\u2026' });
      const subject = _dailyOpsSubject(j.pm, _isAuger, { jobNo: j.displayDuc || duc, customer: j.cust, city: j.city });
      const html = `<p>Daily Operations Report attached.</p>`
        + `<p><strong>${j.displayDuc || duc}</strong> \u2014 ${j.cust||''}${j.city?` &middot; ${j.city}`:''}</p>`
        + `<p>Submitted by: ${_submittedBy}</p>`
        + `<p>#WEAREDAKOTA</p>`;
      const res = await fetch('/api/send-email', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ subject, html, ...(_pmMail ? { cc: [_pmMail] } : {}), attachments:[{ name: filename, contentType:'application/pdf', contentBytes: base64 }] }) });
      const data = await res.json();
      if (data && data.ok) setCustSend({ duc, msg: `\u2713 Emailed to distribution list (${data.count||1})` });
      else setCustSend({ duc, msg: 'Email failed: ' + ((data&&(data.message||data.error))||'unknown') });
    } catch (e) { setCustSend({ duc, msg: 'Email failed: ' + (e&&e.message?e.message:'error') }); }
    setTimeout(()=>setCustSend(null), 8000);
  };

  const emailCustomer = async (job, distArr) => {
    const saved = [...new Set((distArr||[]).map(e=>String(e).trim()).filter(e=>e.includes('@')))];
    const def = saved.join(', ');
    const raw = window.prompt(`Send the Daily Report for ${job.displayDuc || job.duc} to which customer email(s)?\nSeparate multiple with commas. Saved recipients are pre-filled and remembered for next time.`, def);
    if (raw === null) return;
    const valid = [...new Set(String(raw).split(/[;,\n]/).map(s=>s.trim()).filter(Boolean))].filter(e => e.includes('@'));
    if (!valid.length) { setCustSend({ duc: job.duc, msg: "That doesn't look like an email address." }); setTimeout(()=>setCustSend(null), 6000); return; }
    const base = (activeLog && activeLog.duc === job.duc) ? activeLog : (jobLogs[job.duc] || null);
    if (base) {
      const mergedLog = { ...base, distList: valid };
      try { await persistLogs(job.duc, mergedLog); } catch(_) {}
      if (activeLog && activeLog.duc === job.duc) setActiveLog(mergedLog);
    }
    setCustSend({ duc: job.duc, msg: 'Building PDF\u2026' });
    try {
      const { base64, filename } = await buildLogPDF(job.duc, true); // external/customer — strip internal bid link
      const mb = (base64.length * 0.75) / 1048576;
      if (mb > 3) { setCustSend({ duc: job.duc, msg: `PDF too large to email (${mb.toFixed(1)} MB).` }); setTimeout(()=>setCustSend(null), 8000); return; }
      setCustSend({ duc: job.duc, msg: `Sending to ${valid.length} recipient${valid.length>1?'s':''}\u2026` });
      const subject = `Daily Operations Report \u2014 ${job.displayDuc || job.duc}${job.cust?` (${job.cust})`:''}`;
      const html = `<p>Please find attached the Daily Operations Report.</p>`
        + `<p><strong>${job.displayDuc || job.duc}</strong> \u2014 ${job.cust||''}${job.city?` &middot; ${job.city}`:''}</p>`
        + (job.pm ? `<p>PM: ${_pmTitle(job.pm)}</p>` : '')
        + `<p>#WEAREDAKOTA</p>`;
      const res = await fetch('/api/send-email', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ to: valid, subject, html, attachments:[{ name: filename, contentType:'application/pdf', contentBytes: base64 }] }) });
      const data = await res.json();
      if (data && data.ok) setCustSend({ duc: job.duc, msg: `\u2713 Sent to ${valid.join(', ')}` });
      else setCustSend({ duc: job.duc, msg: `Failed: ${(data&&(data.message||data.error))||'error'}` });
    } catch (e) {
      setCustSend({ duc: job.duc, msg: 'Failed: ' + (e&&e.message?e.message:'error') });
    }
    setTimeout(()=>setCustSend(null), 8000);
  };

  // Group selected logs by PM, one email per PM with that PM's PDFs attached
  const emailSelected = async () => {
    const ducs = [...checkedJobs];
    if (!ducs.length) return;
    try {
      setBulkMsg('Preparing\u2026');
      await _ensurePdfLibs();
      const groups = {};
      ducs.forEach(duc => {
        const j = jobs.find(x => x.duc === duc) || {};
        const isAuger = j.pm === 'AU' || j.rig === 'AU';
        const key = `${j.pm||''}|${isAuger}`;
        (groups[key] = groups[key] || { pmCode: j.pm||'', isAuger, ducs: [] }).ducs.push(duc);
      });
      const groupKeys = Object.keys(groups);
      let sent = 0; const issues = [];
      for (let i=0;i<groupKeys.length;i++) {
        const { pmCode, isAuger, ducs: groupDucs } = groups[groupKeys[i]];
        const pmName = _pmTitle(pmCode) || 'UNKNOWN PM';
        const label = isAuger ? `${pmName} (Auger)` : pmName;
        setBulkMsg(`Building ${label} (${i+1}/${groupKeys.length})\u2026`);
        const attachments = []; let total = 0;
        for (const duc of groupDucs) {
          const { blob, base64, filename } = await buildLogPDF(duc);
          total += blob.size;
          attachments.push({ name: filename, contentType:'application/pdf', contentBytes: base64 });
        }
        if (total > 3*1048576) { issues.push(`${label}: too large (${(total/1048576).toFixed(1)}MB)`); continue; }
        setBulkMsg(`Sending ${label}\u2026`);
        // #DAILYOPS_SUBJECT_V2 — only fold job info into the subject when this PM's group is a single
        // job; a bulk send covering several jobs keeps the plain "{PM} - Daily Ops" subject.
        const _soloJob = groupDucs.length === 1 ? (jobs.find(x=>x.duc===groupDucs[0])||{}) : null;
        const subject = _dailyOpsSubject(pmCode, isAuger, _soloJob ? { jobNo: _soloJob.displayDuc || groupDucs[0], customer: _soloJob.cust, city: _soloJob.city } : null);
        const _pmMail = _pmEmail(pmCode);   // #DAILYOPS_ROUTING_V1
        const _submittedBy = _nameFromUpn(upn) || pmName;   // #DAILYOPS_SUBMITTEDBY_V1
        const list = groupDucs.map(d => { const j = jobs.find(x=>x.duc===d)||{};
          return `<li><strong>${j.displayDuc || d}</strong> \u2014 ${j.cust||''}${j.city?' \u00b7 '+j.city:''}</li>`; }).join('');
        const html = `<p>Daily Operations Report(s) attached \u2014 ${groupDucs.length} job(s):</p><ul>${list}</ul>`
          + `<p>Submitted by: ${_submittedBy}</p><p>#WEAREDAKOTA</p>`;
        try {
          const res = await fetch('/api/send-email', { method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ subject, html, ...(_pmMail ? { cc: [_pmMail] } : {}), attachments }) });
          const data = await res.json();
          if (data && data.ok) sent++; else issues.push(`${label}: ${(data&&(data.message||data.error))||'error'}`);
        } catch (err) { issues.push(`${label}: ${err && err.message ? err.message : 'error'}`); }
      }
      let msg = sent ? `\u2713 Sent ${sent} email${sent>1?'s':''} to dist list` : 'No emails sent';
      if (issues.length) msg += ` \u2014 ${issues.join('; ')}`;
      setBulkMsg(msg);
      if (sent && !issues.length) setCheckedJobs(new Set());
      setTimeout(()=>setBulkMsg(''), 12000);
    } catch (err) {
      setBulkMsg('Failed: ' + (err && err.message ? err.message : 'unknown'));
      setTimeout(()=>setBulkMsg(''), 10000);
    }
  };

  // ── PM DASHBOARD (no active log) ──────────────────────
  if (!activeLog) {
    // #DAILY_SEARCH_V1 — search spans active + completed/archived and ignores the stat toggle/PM
    // chips (so sales/AR can pull up any daily) — matches Job #, City, Customer, and Pipe Size.
    // Widened 2026-08-27 (was Job # only) per Bill: "sales guys go into these looking for jobs in
    // City, customer etc." — same fix pattern as #FLEET_SEARCH_V1 (match the fully-built row).
    const _q = (logSearch||'').trim().toLowerCase();
    const pmJobs = jobs.filter(j => {
        if (Array.isArray(deletedDucs) && deletedDucs.includes(j.duc)) return false;
        if (_q) {
          const _pipe = String(j.pipe || getPipeSize(j.desc) || '').toLowerCase();
          return String(j.duc||'').toLowerCase().includes(_q)
                    || String(j.displayDuc||'').toLowerCase().includes(_q)
                    || String(j.cust||'').toLowerCase().includes(_q)
                    || String(j.city||'').toLowerCase().includes(_q)
                    || _pipe.includes(_q);
        }
        return j.stat === (showCompleted ? 'Complete' : 'In Progress') && (!pmFilter || j.pm === pmFilter);
      })
      .map(j => {
        const _entries = jobLogs[j.duc]?.entries || [];
        const _last = _entries.length ? _entries.map(e=>e.date).filter(Boolean).sort().slice(-1)[0] : '';
        return { j, _last };
      })
      .sort((a,b) => {
        const dir = logSort.dir === 'asc' ? 1 : -1;
        if (logSort.key === 'cust') return dir * String(a.j.cust||'').localeCompare(String(b.j.cust||''));
        if (logSort.key === 'city') return dir * String(a.j.city||'').localeCompare(String(b.j.city||''));
        return dir * String(a._last||'').localeCompare(String(b._last||''));
      })
      .map(x => x.j);

    const jobStats = (job) => {
      const log = jobLogs[job.duc];
      const entries = log?.entries || [];
      const aug = job.pm === 'AU' || job.rig === 'AU';   // #AUGER_PULL_BILL_V1
      const pulls = entries.filter(e => isBillPull(e, aug));
      const totalLF = aug ? entries.reduce((s,e)=>s+(Number(e.drilledLF)||0), 0) : pulls.reduce((s,e)=>s+e.drilledLF, 0);   // auger footage is on DRILL rows (#24)
      const boreCt  = [...new Set(pulls.map(e=>String(e.bore)))].length;
      const rigDates = [...new Set(entries.filter(e=>e.drilledLF>0).map(e=>e.date))].length;
      const actFinLF = rigDates > 0 ? totalLF / rigDates : 0;
      const planFinLF = job.days && job.plf ? job.plf / job.days : 0;
      const pct = job.plf ? Math.round(totalLF / job.plf * 100) : 0;
      const remaining = (job.plf||0) - totalLF;
      const projDays = actFinLF > 0 ? Math.ceil(remaining / actFinLF) : null;
      const unbilled = pulls.filter(e=>!e.billed).length;
      const lastEntry = entries.length > 0
        ? entries.map(e=>e.date).filter(Boolean).sort().slice(-1)[0] : null;
      const recentEntries = entries.slice().sort((a,b)=>(b.date||'').localeCompare(a.date||'')).slice(0,5);
      return { totalLF, boreCt, rigDates, actFinLF, planFinLF, pct, remaining, projDays, unbilled, lastEntry, recentEntries, entries, aug };
    };

    const toggleCard = (duc) => setExpandedCard(p => p===duc ? null : duc);
    const toggleCheck = (duc) => setCheckedJobs(p => {
      const n = new Set(p);
      n.has(duc) ? n.delete(duc) : n.add(duc);
      return n;
    });

    return (
      <div>
        {/* #DAILYLOG_FREEZE_V1 (2026-08-28) — Bill: PM choice/search/recent/customer/city/completed
            should stay visible while scrolling the log list. Sticky, same top offset as the Jobs
            table's own frozen header row so it sits right below the nav bar without overlap. */}
        <div data-print-hide="true" style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
          marginBottom:12, flexWrap:'wrap', gap:8, position:'sticky', top:isDesktop?67:56, zIndex:40,
          background:'#F8FAFC', padding:'8px 10px', borderRadius:8, boxShadow:'0 2px 6px rgba(0,0,0,0.06)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
            <span style={{ fontWeight:800, fontSize:15, color:C.text }}>Daily Log</span>
            {['','CT','CJ','RM','PG','AU'].map(pm => (   /* #DAILY_PM_INITIALS_V1 (2026-10-16) — initials, same as everywhere else */
              <div key={pm} onClick={()=>setPmFilter(pm)} title={pm ? (PM_NAMES[pm]||pm) : 'All PMs'}
                style={{ padding:'4px 12px', borderRadius:20, fontSize:11, fontWeight:700,
                  cursor:'pointer', border:`1px solid ${pmFilter===pm?C.accent:C.border}`,
                  background: pmFilter===pm ? C.accent : '#F8FAFC',
                  color: pmFilter===pm ? '#fff' : C.muted,
                  transition:'all .15s' }}>
                {pm === '' ? 'All' : pm}
              </div>
            ))}
          </div>
          <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
            {/* #DAILY_SEARCH_V1 — search any daily by Job #, City, Customer, or Pipe Size (spans active + completed) */}
            <div style={{ position:'relative', display:'flex', alignItems:'center' }}>
              <input value={logSearch} onChange={e=>setLogSearch(e.target.value)}
                placeholder="Search Job #, City, Customer, Pipe"
                style={{ width:210, padding:'4px 24px 4px 11px', fontSize:11, fontWeight:600,
                  borderRadius:20, border:`1px solid ${logSearch?C.accent:C.border}`,
                  background:'#F8FAFC', color:C.text, outline:'none' }} />
              {logSearch && <span onClick={()=>setLogSearch('')} title="Clear"
                style={{ position:'absolute', right:9, cursor:'pointer', color:C.muted,
                  fontWeight:800, fontSize:13, lineHeight:1 }}>×</span>}
            </div>
            {[['recent','Recent'],['cust','Customer'],['city','City']].map(([k,lbl])=>{
              const on = logSort.key===k;
              return (
                <div key={k} onClick={()=>setSort(k)} title={`Sort by ${lbl}`}
                  style={{ padding:'4px 9px', borderRadius:20, fontSize:11, fontWeight:700,
                    cursor:'pointer', border:`1px solid ${on?C.accent:C.border}`,
                    background: on?C.accent:'#F8FAFC', color: on?'#fff':C.muted,
                    display:'flex', alignItems:'center', gap:3, transition:'all .15s' }}>
                  {lbl}{on && <span style={{ fontSize:9 }}>{logSort.dir==='asc'?'▲':'▼'}</span>}
                </div>
              );
            })}
            <div onClick={()=>setShowCompleted(p=>!p)}
              title={showCompleted ? 'Showing completed jobs — tap for active' : 'Show completed jobs'}
              style={{ padding:'4px 12px', borderRadius:20, fontSize:11, fontWeight:700,
                cursor:'pointer', border:`1px solid ${showCompleted?C.green:C.border}`,
                background: showCompleted ? C.green : '#F8FAFC',
                color: showCompleted ? '#fff' : C.muted, transition:'all .15s' }}>
              {showCompleted ? '✓ Completed' : 'Completed'}
            </div>
            <span style={{ color:C.muted, fontSize:11 }}>{pmJobs.length} jobs</span>
            {/* #12 — 'New Log' removed: dailies are only opened from the Job List (keeps the real-DUC link, no duplicate logs). */}
          </div>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
          {pmJobs.map(job => {
            const s = jobStats(job);
            const isExp = expandedCard === job.duc;
            const isChk = checkedJobs.has(job.duc);
            const pctColor = s.pct>=80?C.green:s.pct>0?C.blue:C.muted;
            const log = jobLogs[job.duc];
            const distArr = Array.isArray(log?.distList) ? log.distList : [];

            return (
              <div key={job.duc} style={{ background:C.card,
                border:`1px solid ${isExp?C.accent:C.border}`,
                borderWidth: isExp ? 1.5 : 0.5,
                borderRadius:10, overflow:'hidden',
                boxShadow:'0 1px 3px rgba(0,0,0,0.04)', transition:'border-color .15s' }}>

                {/* #DAILY_MOBILE_JOBCARD_V1 (2026-10-16) — Bill: every phone card laid out the same (the Arguijo one was the model):
                    line 1 = job #, status, PM, customer · city; line 2 = description (stops short), %, Upd date, Open Log pinned right.
                    The ⚡ Review chip stays desktop-only. */}
                {!isDesktop ? (() => {
                  const _pmAbbrM = Object.keys(PM_NAMES).find(k => PM_NAMES[k] === job.pm) || job.pm || '';
                  const _descM = job.desc ? job.desc.replace(job.cust,'').replace(/^\s*[-–]\s*/,'') : '';
                  return (
                    <div onClick={()=>toggleCard(job.duc)} style={{ padding:'8px 10px', cursor:'pointer' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:6, minWidth:0 }}>
                        <input type="checkbox" checked={isChk} onClick={e=>{e.stopPropagation();toggleCheck(job.duc);}} style={{ margin:0, cursor:'pointer', flex:'0 0 16px', width:16, minWidth:16, maxWidth:16, height:16, padding:0 }} />{/* #DAILY_MOBILE_JOBCARD_V2 — phone CSS stretches inputs to full width; pin the box so job # / customer stay on screen */}
                        <span style={{ color:C.accent, fontFamily:"Arial Narrow, Arial, sans-serif", fontWeight:800, fontSize:15, flexShrink:0 }}>{job.displayDuc || job.duc}</span>
                        <span style={{ flexShrink:0, transform:'scale(.9)', transformOrigin:'left center' }}><StatusBadge status={job.stat} /></span>
                        {_pmAbbrM && <span style={{ flexShrink:0, fontSize:10, fontWeight:800, color:C.accent, background:'#FFF0E6', border:`1px solid ${C.accent}`, borderRadius:5, padding:'1px 5px' }}>{_pmAbbrM}</span>}
                        <span style={{ minWidth:0, flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:12.5 }}>
                          <b style={{ color:C.text }}>{job.cust}</b><span style={{ color:C.muted, fontSize:11 }}> · {job.city}</span></span>
                        <button onClick={e=>{ e.stopPropagation(); setPendingDeleteLog(job.duc); }} title="Delete this daily"
                          style={{ background:'none', border:'none', cursor:'pointer', padding:2, opacity:0.35, flexShrink:0, display:'flex' }}><Trash2 size={13} color={C.muted}/></button>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:5, minWidth:0 }}>
                        <span style={{ flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', fontSize:11, color:C.muted }}>{_descM ? `— ${_descM}` : ''}</span>
                        <span style={{ flexShrink:0, fontSize:12.5, fontWeight:800, color:pctColor, minWidth:30, textAlign:'right' }}>{s.pct}%</span>
                        <span style={{ flexShrink:0, fontSize:11, fontWeight:700, color: s.lastEntry ? C.text : C.muted, minWidth:74, textAlign:'right' }}>{s.lastEntry ? `Upd ${fmtD(s.lastEntry)}` : 'No entries'}</span>
                        <button onClick={e=>{ e.stopPropagation(); openLog(job.duc); }} title="Open full daily log"
                          style={{ flexShrink:0, background:C.accent, color:'#fff', border:'none', borderRadius:6, padding:'5px 11px', fontSize:11, fontWeight:800, cursor:'pointer', whiteSpace:'nowrap' }}>Open Log</button>
                      </div>
                    </div>
                  );
                })() : (
                <div onClick={()=>toggleCard(job.duc)}
                  style={{ display:'flex', alignItems:'center', gap:8,
                    padding:'9px 14px', cursor:'pointer', flexWrap:'wrap' }}>
                  <input type="checkbox" checked={isChk}
                    onClick={e=>{e.stopPropagation();toggleCheck(job.duc);}}
                    style={{ margin:0, cursor:'pointer' }} />
                  <span style={{ color:C.accent, fontFamily:"Arial Narrow, Arial, sans-serif",
                    fontWeight:800, fontSize:16, minWidth:88 }}>{job.displayDuc || job.duc}</span>
                  <StatusBadge status={job.stat} />
                  {(() => {
                    const _pmAbbr = Object.keys(PM_NAMES).find(k => PM_NAMES[k] === job.pm) || job.pm || '';
                    return _pmAbbr ? (
                      <span style={{ fontSize:11, fontWeight:800, color:C.accent,
                        background:'#FFF0E6', border:`1px solid ${C.accent}`,
                        borderRadius:6, padding:'2px 7px', letterSpacing:0.3 }}>{_pmAbbr}</span>
                    ) : null;
                  })()}
                  <span style={{ fontWeight:700, fontSize:13, color:C.text }}>{job.cust}</span>
                  <span style={{ fontSize:11, color:C.muted }}>· {job.city}</span>
                  {job.desc && <span style={{ fontSize:11, color:C.muted, fontWeight:500, marginLeft:6, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>— {job.desc.replace(job.cust,'').replace(/^\s*[-–]\s*/,'')}</span>}
                  <span style={{ flex:1 }}/>
                  {s.unbilled > 0 && (() => {
                    const _done = job.stat === 'Complete';
                    return (
                      <span style={{ display:'inline-flex', alignItems:'center', gap:3,
                        padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700,
                        background: _done ? '#FEF3C7' : '#FFF0E6',
                        color: _done ? '#92400E' : C.accent,
                        border:`1px solid ${_done ? '#F59E0B' : C.accent}` }}>
                        {_done ? `⚠ Billing pending · ${s.unbilled}` : `⚡ ${s.unbilled} Review`}
                      </span>
                    );
                  })()}
                  <span style={{ fontSize:13, fontWeight:800, color:pctColor, minWidth:36, textAlign:'right' }}>
                    {s.pct}%
                  </span>
                  <span style={{ fontSize:12, fontWeight:700,
                    color: s.lastEntry ? C.text : C.muted,
                    minWidth:92, textAlign:'right' }}>
                    {s.lastEntry ? `Upd ${fmtD(s.lastEntry)}` : 'No entries'}
                  </span>
                  <button onClick={e=>{ e.stopPropagation(); openLog(job.duc); }}
                    title="Open full daily log"
                    style={{ background:C.accent, color:'#fff', border:'none', borderRadius:6,
                      padding:'4px 12px', fontSize:11, fontWeight:800, letterSpacing:0.3,
                      cursor:'pointer', whiteSpace:'nowrap' }}>Open Log</button>
                  <span onClick={e=>{ e.stopPropagation(); toggleCard(job.duc); }}
                    title={isExp?'Collapse':'Expand preview'}
                    style={{ color:C.muted, fontSize:13, cursor:'pointer', padding:'0 2px' }}>{isExp?'▲':'▼'}</span>
                  <button onClick={e=>{ e.stopPropagation(); setPendingDeleteLog(job.duc); }}
                    title="Delete this daily"
                    style={{ background:'none', border:'none', cursor:'pointer',
                      padding:'2px 2px', marginLeft:2, opacity:0.4, display:'flex',
                      alignItems:'center' }}
                    onMouseEnter={e=>e.currentTarget.style.opacity=1}
                    onMouseLeave={e=>e.currentTarget.style.opacity=0.4}>
                    <Trash2 size={14} color={C.muted}/>
                  </button>
                </div>
                )}

                {s.pct > 0 && (
                  <div style={{ height:3, background:C.border }}>
                    <div style={{ width:`${Math.min(s.pct,100)}%`, height:'100%',
                      background:s.pct>=80?C.green:C.blue, transition:'width .3s' }}/>
                  </div>
                )}

                {isExp && (
                  <div style={{ borderTop:`1px solid ${C.border}`,
                    padding:'12px 14px', background:'#FAFAFA' }}>

                    <div style={{ display:'grid',
                      gridTemplateColumns: isDesktop ? 'repeat(6,1fr)' : 'repeat(3,1fr)',
                      gap:6, marginBottom:12 }}>
                      {[
                        ['Plan FIN/LF', s.planFinLF>0?`${s.planFinLF.toFixed(0)}/day`:'—', C.muted],
                        ['Act FIN/LF',  s.actFinLF>0?`${s.actFinLF.toFixed(0)}/day`:'—',
                          s.actFinLF>0&&s.planFinLF>0 ? (s.actFinLF>=s.planFinLF?C.green:s.actFinLF>=s.planFinLF*0.8?C.yellow:C.red) : C.muted],
                        ['LF Completed', s.totalLF.toLocaleString(), C.green],
                        ['Bore Count',   s.boreCt, C.blue],
                        ['Remaining LF', s.remaining>0?s.remaining.toLocaleString():'Done', s.remaining>0?C.text:C.green],
                        ['Proj Days',    s.projDays!=null?`~${s.projDays}d`:'—',
                          s.projDays!=null&&job.days?(s.projDays<=(job.days-(s.rigDates||0))?C.green:C.red):C.muted],
                      ].map(([l,v,clr])=>(
                        <div key={l} style={{ background:C.card, border:`1px solid ${C.border}`,
                          borderRadius:8, padding:'8px 10px', textAlign:'center' }}>
                          <div style={{ fontSize:9, color:C.muted, fontWeight:600,
                            textTransform:'uppercase', letterSpacing:0.4, marginBottom:3 }}>{l}</div>
                          <div style={{ fontSize:14, fontWeight:800, color:clr,
                            fontFamily:"Arial Narrow, Arial, sans-serif" }}>{v}</div>
                        </div>
                      ))}
                    </div>

                    {s.recentEntries.length > 0 && (
                      <div style={{ marginBottom:10 }}>
                        <div style={{ fontSize:10, fontWeight:700, color:C.muted,
                          textTransform:'uppercase', letterSpacing:0.5, marginBottom:5 }}>
                          Recent Entries (newest first)
                        </div>
                        {s.recentEntries.map((e,i) => {
                          const isPull = isPullStage(e, s.aug);   // #AUGER_PULL_BILL_V1
                          return (
                            <div key={e.id||i} style={{
                              display:'flex', alignItems:'center', gap:8,
                              padding:'4px 8px', borderRadius:4, fontSize:11,
                              background: isPull?'#FFF0E6':'transparent',
                              borderLeft: isPull?`3px solid ${C.accent}`:'3px solid transparent',
                              fontWeight: isPull?700:400 }}>
                              <span style={{ color:C.muted, minWidth:40 }}>{fmtD(e.date)}</span>
                              <span style={{ color:C.muted, minWidth:24 }}>{e.day}</span>
                              <span style={{ color:'#1D4ED8', fontWeight:600, minWidth:40 }}>{e.bore}</span>
                              <span style={{ color:isPull?C.accent:C.muted, fontWeight:isPull?700:400, minWidth:60 }}>{e.stage}</span>
                              <span style={{ color:C.blue, fontWeight:600, minWidth:50 }}>
                                {e.drilledLF>0?e.drilledLF.toLocaleString()+' LF':''}
                              </span>
                              {e.pipeSize && <span style={{ color:isPull?C.accent:C.muted, fontSize:10 }}>{e.pipeSize}</span>}
                              <span style={{ color:C.muted, flex:1, overflow:'hidden',
                                textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{e.comment}</span>
                              {isPull && !e.billed && (
                                <span style={{ fontSize:10, fontWeight:700, color:C.accent,
                                  background:'#FFF0E6', padding:'1px 6px', borderRadius:10,
                                  border:`1px solid ${C.accent}`, flexShrink:0 }}>⚡ Review</span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {distArr.length > 0 && (
                      <div style={{ fontSize:11, color:C.muted, marginBottom:10 }}>
                        📧 Dist: {distArr.join(' · ')}
                      </div>
                    )}

                    <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                      {/* #DAILYLOG_RM_OPENFULLLOG_V1 (2026-08-24) — Bill: redundant with the "Open Log"
                          pill already in the card header, removed per his markup on the punch list. */}
                      <Btn onClick={()=>csvForJob(job.duc)} variant="secondary" small>📥 CSV</Btn>
                      <Btn onClick={()=>pdfForJob(job.duc)} variant="secondary" small>🖨️ PDF (Print)</Btn>
                      <Btn onClick={()=>dailyEmailForJob(job.duc)} variant="secondary" small>📧 DAILY EMAIL</Btn>
                      <Btn onClick={()=>emailCustomer(job, distArr)} variant="secondary" small>📧 Email Customer</Btn>
                    </div>
                    {custSend && custSend.duc===job.duc && (
                      <div style={{ fontSize:11, fontWeight:700, color:C.text, marginTop:6 }}>{custSend.msg}</div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {checkedJobs.size > 0 && (
          <div data-print-hide="true" style={{ position:'sticky', bottom:isDesktop?16:72,
            background:C.card, border:`1px solid ${C.accent}`,
            borderRadius:10, padding:'10px 14px', marginTop:10,
            display:'flex', gap:8, flexWrap:'wrap', alignItems:'center',
            boxShadow:'0 4px 16px rgba(232,93,36,0.2)' }}>
            <span style={{ fontWeight:700, fontSize:12, color:C.text }}>
              {checkedJobs.size} job{checkedJobs.size>1?'s':''} selected:
            </span>
            <Btn variant="primary" small onClick={emailSelected}>📧 Email Selected</Btn>
            <Btn variant="secondary" small onClick={()=>{
              const ducs = [...checkedJobs].join(', ');
              window.open(`mailto:?subject=Daily Production Report – ${ducs}&body=Please find the attached daily production reports for: ${ducs}`,'_blank');
            }}>📧 Email Customer</Btn>
            <Btn variant="secondary" small onClick={()=>{
              const selected = [...checkedJobs];
              if (!selected.length) return;
              const rows = [
                ['Live Job List (tickets, KMZ, attachments):', 'https://ducdope.com/'],
                [],
                ['DUC','Customer','City','PM','Date','Day','Supervisor','Rig','Bore #','Bore LF','Stage','Soil','Drilled LF','Stage Total','Reamer Size','Pipe','Comment','Billed']
              ];
              selected.forEach(duc => {
                const j = jobs.find(x => x.duc === duc);
                const log = jobLogs[duc];
                const entries = (log?.entries || []).slice().sort((a,b)=>(b.date||'').localeCompare(a.date||''));
                if (!entries.length) {
                  rows.push([duc, j?.cust||'', j?.city||'', j?.pm||'', '(no entries)','','','','','','','','','','','','','']);
                } else {
                  entries.forEach(e => rows.push([duc, j?.cust||'', j?.city||'', j?.pm||'', e.date, e.day, e.sup, e.rig, e.bore, e.boreLF, e.stage, e.soil, e.drilledLF, e.stageTotal, e.pipeSize, e.finalPipe, e.comment, e.billed?'YES':'']));
                }
              });
              const csv = rows.map(r => r.map(v => `"${String(v??'').replace(/"/g,'""')}"`).join(',')).join('\n');
              const blob = new Blob([csv], { type:'text/csv' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              const stamp = new Date().toISOString().slice(0,10);
              a.href = url; a.download = `Dakota_BulkExport_${selected.length}jobs_${stamp}.csv`; a.click();
              URL.revokeObjectURL(url);
            }}>📥 Bulk CSV</Btn>
            <Btn variant="ghost" small onClick={()=>setCheckedJobs(new Set())}>✕ Clear</Btn>
            {bulkMsg && (
              <span style={{ fontSize:12, fontWeight:600, color:C.text, marginLeft:4,
                flexBasis:'100%', paddingTop:2 }}>{bulkMsg}</span>
            )}
          </div>
        )}

        {pendingDeleteLog != null && (() => {
          const _dj = jobs.find(x => x.duc === pendingDeleteLog) || {};
          const _isCustom = String(pendingDeleteLog).startsWith('custom-');
          const _label = `${_dj.displayDuc || _dj.duc || pendingDeleteLog}${_dj.cust?` · ${_dj.cust}`:''}${_dj.city?` · ${_dj.city}`:''}`;
          return (
            <div onClick={()=>setPendingDeleteLog(null)}
              style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', zIndex:200,
                display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
              <div onClick={e=>e.stopPropagation()}
                style={{ background:'#fff', borderRadius:14, maxWidth:400, width:'100%',
                  padding:'22px 22px 18px', boxShadow:'0 20px 50px rgba(0,0,0,0.30)',
                  borderTop:`5px solid ${C.red}` }}>
                <div style={{ fontSize:19, fontWeight:800, color:C.text, marginBottom:6 }}>
                  Whoa there, cowboy 🤠
                </div>
                <div style={{ fontSize:14, color:C.muted, marginBottom:10, lineHeight:1.45 }}>
                  {_isCustom
                    ? 'This is a custom test job — deleting wipes the daily AND removes the job entirely. No takebacks.'
                    : 'This wipes all daily entries for this job. The job stays in the Job List, but the log resets to empty. No takebacks.'}
                </div>
                <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:18,
                  background:'#F8FAFC', borderRadius:6, padding:'8px 10px' }}>
                  {_label}
                </div>
                <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                  <Btn onClick={()=>setPendingDeleteLog(null)} variant="secondary">Nope, keep it</Btn>
                  <Btn onClick={()=>{ deleteDaily(pendingDeleteLog); setPendingDeleteLog(null); }}
                    variant="primary" style={{ background:C.red, color:'#fff' }}>Yep, delete</Btn>
                </div>
              </div>
            </div>
          );
        })()}
      </div>
    );
  }

  // ── ACTIVE LOG VIEW ───────────────────────────────────
  const entries = activeLog.entries || [];
  const distArr = Array.isArray(activeLog.distList) ? activeLog.distList : [];

  // entries newest-on-top
  const sortedEntries = entries.slice().sort((a,b)=>(b.date||'').localeCompare(a.date||''));
  const filteredEntries = sortedEntries.filter(e =>
    (!filterBore || String(e.bore) === String(filterBore)) &&
    (!filterSup  || e.sup === filterSup));
  const unbilledPulls = filteredEntries.filter(e=>isBillPull(e, _augerLog)&&!e.billed);   // #AUGER_PULL_BILL_V1
  // #DAILY_ADDRIG_V1 (2026-10-13) — Bill: separate rigs ADDED to a job from the original without touching the
  // stage pills or the PULL / Complete / PH row colors. Only the identity block (WK · DATE · DAY · SUP · RIG) gets
  // tinted. A "rig" = SUP + RIG on the log (two 40x55s on one job are only told apart by crew — no unit # is logged).
  // Original = every SUP+RIG logged on the job's first day; anything that shows up later gets its own color.
  const _arKey = (e) => { const r = String(e.rig||'').trim().toUpperCase(); return r ? `${String(e.sup||'').trim().toUpperCase()}|${r}` : ''; };
  const _AR_PAL = [ { bg:'#CCFBF1', bar:'#0D9488', tx:'#115E59' }, { bg:'#ECFCCB', bar:'#65A30D', tx:'#3F6212' }, { bg:'#FEF9C3', bar:'#CA8A04', tx:'#854D0E' } ];
  const addedRig = (() => {
    const withRig = entries.filter(e => e.date && _arKey(e)).slice().sort((a,b)=>(a.date||'').localeCompare(b.date||''));
    if (!withRig.length) return { of: () => null, orig: [], added: [] };
    const d0 = withRig[0].date; const orig = new Set(); const added = []; const seen = {};
    withRig.forEach(e => { const k=_arKey(e); if (e.date===d0) { orig.add(k); return; } if (orig.has(k) || seen[k]) return;
      seen[k] = { k, sup: String(e.sup||'').trim(), rig: String(e.rig||'').trim(), from: e.date, c: _AR_PAL[added.length % _AR_PAL.length] }; added.push(seen[k]); });
    return { of: (e) => { const k=_arKey(e); return (k && seen[k]) ? seen[k].c : null; }, orig: [...orig], added };
  })();

  // Excel-style summary grid value getters
  const slipColor = metrics.overPlan ? C.green
    : metrics.slippage === 'critical' ? C.red
    : metrics.slippage === 'warning' ? C.yellow : C.green;

  return (
    <div data-print-report>
      {/* ── EDIT ENTRY (tap a row/card) — EDIT_ENTRY_V1 ── */}
      {editEntry && (
        <div data-print-hide="true" onClick={()=>setEditEntry(null)}
          style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', zIndex:210,
            display:'flex', alignItems:'flex-start', justifyContent:'center', padding:'40px 16px', overflowY:'auto' }}>
          <div onClick={ev=>ev.stopPropagation()}
            style={{ background:'#fff', borderRadius:14, maxWidth:560, width:'100%',
              padding:'18px 20px', boxShadow:'0 20px 50px rgba(0,0,0,0.30)',
              borderTop:`5px solid ${C.accent}` }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
              <div style={{ fontSize:17, fontWeight:800, color:C.text }}>{editEntry._isNew ? 'Add entry' : 'Edit entry'}</div>
              <span onClick={()=>setEditEntry(null)} style={{ cursor:'pointer', fontSize:24, color:C.muted, fontWeight:700, lineHeight:1 }}>×</span>
            </div>
            {(() => {
              const { master, orphans, hasMaster } = supPicker;
              const _btn = (su, flagged) => { const on=(editEntry.sup||'')===su; return (
                <button key={(flagged?'o:':'m:')+su} type="button" onClick={()=>fillFromSupEdit(su)}
                  title={flagged?'Not on the Revenue master list — likely a typo or a supervisor not yet set up in Revenue. Fix in the Revenue tab.':undefined}
                  style={{ fontSize:11, fontWeight:700, padding:'3px 11px', borderRadius:20,
                    border:`1px ${flagged?'dashed':'solid'} ${flagged?C.yellow:(on?C.accent:C.border)}`,
                    background:flagged?(on?C.yellow:'#FFFBEB'):(on?C.accent:'#F8FAFC'),
                    color:flagged?(on?'#fff':C.yellow):(on?'#fff':C.muted), cursor:'pointer' }}>{flagged?'⚠ '+su:su}</button>
              ); };
              const _legacy = !hasMaster && !orphans.length
                ? [...new Set((activeLog?.entries||[]).map(e=>e.sup).filter(Boolean))].sort() : null;
              if (_legacy && !_legacy.length) return null;
              return (
                <div style={{ display:'flex', alignItems:'center', gap:5, flexWrap:'wrap', marginBottom:12 }}>
                  <span style={{ fontSize:9, fontWeight:800, color:'#94A3B8', textTransform:'uppercase', letterSpacing:0.5 }}>{hasMaster?'Supervisors':'Recent SUPs'}</span>
                  {(_legacy||master).map(su => _btn(su,false))}
                  {orphans.map(su => _btn(su,true))}
                  <span style={{ fontSize:9, color:C.muted, fontStyle:'italic' }}>tap to fill, or type a name in Sup</span>
                </div>
              );
            })()}
            {/* ── LAST ACTIVITY BY RIG — read-only reference inside the Add/Edit modal (#10b-modal) ── */}
            {(() => {
              const _sup = (editEntry.sup||'').toString().trim();
              if (!_sup) return null;
              const _es = (activeLog?.entries||[]).filter(e => (e.sup||'').toString().trim() === _sup && (editEntry._isNew || e.id !== editEntry.id));
              if (!_es.length) return null;
              const _byRig = {};
              [..._es].sort((a,b)=>(b.date||'').localeCompare(a.date||'') || (b.id||0)-(a.id||0))
                .forEach(e => { const r=(e.rig||'—').toString(); if(!_byRig[r]) _byRig[r]=e; });
              const _rigs = Object.keys(_byRig);
              return (
                <div style={{ background:'#F1F5FB', border:`1px solid ${C.border}`, borderRadius:8,
                  padding:'8px 11px', marginBottom:12 }}>
                  <div style={{ fontSize:9, fontWeight:800, color:C.accent, textTransform:'uppercase',
                    letterSpacing:0.5, marginBottom:6 }}>
                    Where {_sup} left off{_rigs.length>1 ? ` · ${_rigs.length} rigs` : ''}
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
                    {_rigs.map(r => {
                      const e = _byRig[r];
                      const _pulled = e.stage==='Pull' || (_augerLog && e.stage==='PULL'); // #AUGER_PILL_PARITY_V1
                      const _done   = e.stage==='Complete';
                      return (
                        <div key={r} style={{ display:'flex', flexWrap:'wrap', alignItems:'center',
                          gap:9, fontSize:12, lineHeight:1.3 }}>
                          <span style={{ fontWeight:800, color:C.text, minWidth:56 }}>{r}</span>
                          <span style={{ color:C.muted }}>{fmtD(e.date)}</span>
                          <span style={{ color:C.muted }}>Bore <b style={{ color:C.blue }}>{e.bore||'—'}</b></span>
                          <span style={{ fontWeight:700, color: _done?C.green : _pulled?C.green : (e.stage==='Delay'||EVENT_STAGES.includes(e.stage))?C.yellow : C.text }}>
                            {e.stage||'—'}{_pulled?' ✓':''}
                          </span>
                          <span style={{ color:C.muted }}>Stg Tot <b style={{ color:C.text }}>{(e.stageTotal!=null&&e.stageTotal!=='')?Number(e.stageTotal).toLocaleString():'—'}</b></span>
                          <span style={{ color:C.muted }}>Pipe <b style={{ color:C.text }}>{e.pipeSize||'—'}</b></span>
                          {e.comment ? <span style={{ color:C.muted, fontStyle:'italic', flex:'1 1 100%',
                            overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>"{e.comment}"</span> : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
            <div style={{ display:'grid', gridTemplateColumns: isDesktop ? '1fr 1fr 1fr' : '1fr 1fr', gap:10 }}>
              <label style={_ELBL}>Date<input type="date" value={editEntry.date||''} onChange={ev=>setEditEntry(p=>({...p, date:ev.target.value}))} style={_EINP} /></label>
              <label style={_ELBL}>Sup<input value={editEntry.sup||''} onChange={ev=>setEditEntry(p=>({...p, sup:ev.target.value}))} onBlur={ev=>fillFromSupEdit(ev.target.value)} style={_EINP} /></label>
              <label style={_ELBL}>Rig<PickSearch value={editEntry.rig||''} onChange={v=>setEditEntry(p=>({...p, rig:v}))} options={DAILY_RIGS} placeholder="type to search" style={_EINP} /></label>
              <label style={_ELBL}>Bore #<input value={editEntry.bore||''} onChange={ev=>setEditEntry(p=>({...p, bore:ev.target.value}))} style={_EINP} /></label>
              <label style={_ELBL}>Bore LF<input type="number" value={editEntry.boreLF ?? ''} onChange={ev=>setEditEntry(p=>({...p, boreLF: ev.target.value===''?'':Number(ev.target.value)}))} style={_EINP} /></label>
              <label style={_ELBL}>Stage<PickSearch value={editEntry.stage||''} options={ACTIVE_STAGES} placeholder="type to search" onChange={v=>{const nd=isNoDrill(v);setEditEntry(p=>({...p, stage:v, ...(nd?{soil:'NIL',drilledLF:0,stageTotal:0,pipeSize:'NIL',finalPipe:'NIL'}:(isNoDrill(p.stage)?{soil:'',drilledLF:'',stageTotal:'',pipeSize:'',finalPipe:''}:{}))}));}} style={_EINP} /></label>
              <label style={_ELBL}>Soil<PickSearch value={editEntry.soil||''} disabled={isNoDrill(editEntry.stage)} onChange={v=>setEditEntry(p=>({...p, soil:v}))} options={isNoDrill(editEntry.stage) ? [...SOILS,'NIL'] : SOILS} placeholder="type to search" style={_EINP} /></label>
              <label style={_ELBL}>Drilled LF<input type="number" disabled={isNoDrill(editEntry.stage)} value={editEntry.drilledLF ?? ''} onChange={ev=>setEditEntry(p=>({...p, drilledLF: ev.target.value===''?'':Number(ev.target.value)}))} style={_EINP} /></label>
              <label style={_ELBL}>Stg LF<input type="number" disabled={isNoDrill(editEntry.stage)} value={editEntry.stageTotal ?? ''} onChange={ev=>setEditEntry(p=>({...p, stageTotal: ev.target.value===''?'':Number(ev.target.value)}))} style={_EINP} /></label>
              <label style={_ELBL}>Size<input disabled={isNoDrill(editEntry.stage)} value={editEntry.pipeSize||''} onChange={ev=>setEditEntry(p=>({...p, pipeSize:ev.target.value}))} onBlur={ev=>{const v=ev.target.value.trim();if(v&&!v.includes('"')){const m=v.match(/^(\d+(?:\.\d+)?)(\s*.*)?$/);if(m)setEditEntry(p=>({...p,pipeSize:m[1]+'"'+(m[2]||'')}))}}} style={_EINP} /></label>
              <label style={_ELBL}>Pipe<input disabled={isNoDrill(editEntry.stage)} value={editEntry.finalPipe||''} onChange={ev=>setEditEntry(p=>({...p, finalPipe:ev.target.value}))} onBlur={ev=>{const v=ev.target.value.trim();if(v&&!v.includes('"')){const m=v.match(/^(\d+(?:\.\d+)?)(\s*.*)?$/);if(m)setEditEntry(p=>({...p,finalPipe:m[1]+'"'+(m[2]||'')}))}}} style={_EINP} /></label>
              <div style={{ display:'flex', alignItems:'flex-end' }}>
                {editEntry._isNew && EVENT_STAGES.includes(editEntry.stage) && (
                  <Btn variant="secondary" small onClick={applyEventToAllRigs} title="Applies this event to every rig currently on this job for the Date above — not just this one entry" style={{ width:'100%' }}>☂️ Apply to All Rigs on Job</Btn>
                )}
              </div>
            </div>
            <label style={{..._ELBL, marginTop:10}}>Comment<textarea value={editEntry.comment||''} rows={2} onChange={ev=>setEditEntry(p=>({...p, comment:ev.target.value}))} spellCheck={true} autoCorrect="on" autoCapitalize="sentences" style={{..._EINP, resize:'vertical', minHeight:44}} /></label>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:16, gap:10 }}>
              {editEntry._isNew ? <span /> : <Btn variant="ghost" small onClick={()=>{ const id=editEntry.id; setEditEntry(null); removeEntry(id); }} style={{ color:C.red }}>🗑 Delete</Btn>}
              <div style={{ display:'flex', gap:10 }}>
                <Btn variant="secondary" onClick={()=>setEditEntry(null)}>Cancel</Btn>
                <Btn variant="primary" onClick={saveEdit}>{editEntry._isNew ? 'Add entry' : 'Save changes'}</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ── DELETE CONFIRM (cheeky) — DELETE_CONFIRM_V1 ── */}
      {pendingDelete != null && (() => {
        const _ent = (activeLog.entries||[]).find(e => e.id === pendingDelete);
        const _label = _ent ? `${fmtD(_ent.date)}${_ent.stage?` · ${_ent.stage}`:''}${_ent.bore?` · Bore ${_ent.bore}`:''}` : 'this entry';
        return (
          <div data-print-hide="true" onClick={()=>setPendingDelete(null)}
            style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.55)', zIndex:200,
              display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
            <div onClick={e=>e.stopPropagation()}
              style={{ background:'#fff', borderRadius:14, maxWidth:380, width:'100%',
                padding:'22px 22px 18px', boxShadow:'0 20px 50px rgba(0,0,0,0.30)',
                borderTop:`5px solid ${C.red}` }}>
              <div style={{ fontSize:19, fontWeight:800, color:C.text, marginBottom:6 }}>
                Whoa there, cowboy 🤠
              </div>
              <div style={{ fontSize:14, color:C.muted, marginBottom:10, lineHeight:1.45 }}>
                You sure you wanna delete this one? No takebacks.
              </div>
              <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:18,
                background:'#F8FAFC', borderRadius:6, padding:'8px 10px' }}>
                {_label}
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <Btn onClick={()=>setPendingDelete(null)} variant="secondary">Nope, keep it</Btn>
                <Btn onClick={()=>{ _doRemoveEntry(pendingDelete); setPendingDelete(null); }}
                  variant="primary" style={{ background:C.red, color:'#fff' }}>Yep, delete</Btn>
              </div>
            </div>
          </div>
        );
      })()}
      {/* ── TOP BAR (screen only) ── */}
      <div data-print-hide="true" style={{ display:'flex', justifyContent:'space-between',
        alignItems:'center', marginBottom:10, flexWrap:'wrap', gap:8,
        position: isDesktop ? 'sticky' : 'static', top: isDesktop ? 67 : 'auto', zIndex: isDesktop ? 40 : 'auto',
        background: isDesktop ? C.bg : 'transparent', padding: isDesktop ? '8px 0' : 0,
        borderBottom: isDesktop ? `1px solid ${C.border}` : 'none' }}> {/* STICKY_ACTIONBAR_V1 */}
        <div style={{ display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}> {/* #DAILY_MOBILE_HDR_V1 */}
          <Btn onClick={()=>{ setActiveLog(null); setExpandedCard(null); setEditEntry(null); setShowDistrib(false); setBulkOpen(false); }} variant="secondary" small>← All Logs</Btn>
          <Btn onClick={()=>window.dispatchEvent(new CustomEvent('openJobsList',{detail:{duc:activeLog.duc}}))}
            variant="secondary" small title="Open this job in Job List (for KMZ + attachments)">📍 Job List · KMZ</Btn>
          {/* #DAILYLOG_VIEWBID_V1 — opens the same in-app BID overlay (#BID_VIEWER_V1) used elsewhere in
              the app, instead of navigating away. Closing it (×/Esc) returns to this exact Daily —
              nothing unmounts, so scroll position + search state are never lost. No BID on file yet →
              falls back to the existing 'openJobsList' jump so it can be added there. */}
          <Btn onClick={async()=>{
              try {
                const slots = await sg('slots:job:' + activeLog.duc);
                if (slots && slots.bid && (slots.bid.data || slots.bid.path)) {
                  window.dispatchEvent(new CustomEvent('dope-open-bid', { detail: slots.bid }));
                  return;
                }
              } catch {}
              window.dispatchEvent(new CustomEvent('openJobsList',{detail:{duc:activeLog.duc}}));
            }}
            variant="secondary" small title="View this job's BID — opens on top of this Daily, closes back here">📄 View BID</Btn>
          {isDesktop && (<>
          <span style={{ color:C.accent, fontFamily:"Arial Narrow, Arial, sans-serif",
            fontWeight:800, fontSize:18 }}>{_logNum(activeLog)}</span>
          <span style={{ color:C.text, fontSize:13, fontWeight:600 }}>{activeLog.customer}</span>
          <span style={{ color:C.muted, fontSize:12 }}>· {activeLog.city}</span>
          {activeLog.desc && <div style={{ color:C.muted, fontSize:12, fontWeight:500, marginTop:2 }}>{activeLog.desc}</div>}
          </>)}
        </div>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
          {exportMsg && <span style={{ color:C.green, fontSize:11, alignSelf:'center' }}>{exportMsg}</span>}
          <Btn onClick={exportCSV} variant="secondary" small>📥 CSV</Btn>
          <Btn onClick={async()=>{ /* #PRINT_USES_BUILDER_V1 — identical to Email PDF */ const pv=openPrintView({ title:'Daily Log', status:'Building PDF\u2026' }); /* #PRINT_VIEW_V1 */ try{ const {blob,filename}=await buildLogPDF(activeLog.duc); pv.setPdf(blob, filename); }catch(e){ pv.fail(e); setExportMsg('PDF failed: '+(e&&e.message?e.message:'error')); } setTimeout(()=>setExportMsg(''),4000); }} variant="secondary" small>🖨️ PDF (Print)</Btn>
          <Btn onClick={emailReport} variant="secondary" small>📧 DAILY EMAIL</Btn>
          <Btn onClick={()=>emailCustomer(jobs.find(x=>x.duc===activeLog.duc)||{duc:activeLog.duc,cust:activeLog.customer,city:activeLog.city,pm:activeLog.pm}, distArr)} variant="secondary" small>📧 Email Customer</Btn>
          {canEdit && <Btn onClick={()=>{ setCxlOpen(o=>!o); setCxlBore(''); setCxlNote(''); }} variant="secondary" small title="Flag a bore that was worked then cancelled — dailies stay as entered">⛔ CXL Bore</Btn>}
          <Btn onClick={()=>setShowDistrib(p=>!p)} variant="secondary" small>📋 Edit List</Btn>
          <Btn onClick={saveLog} variant={saved?'success':'primary'} small>
            <Save size={12}/>{saving?'Saving...':saved?'✓ #WRD':'Save'}
          </Btn>
        </div>
      </div>

      {/* #BORE_CXL_V1 — flag / unflag a cancelled bore */}
      {cxlOpen && canEdit && (() => {
        const _bores = [...new Set((activeLog.entries || []).map(e => String(e.bore || '').trim()).filter(Boolean))]
          .sort((a, b) => { const na = parseFloat(a), nb = parseFloat(b); return (!isNaN(na) && !isNaN(nb) && na !== nb) ? na - nb : a.localeCompare(b); });
        const _have = Object.entries((boreFlags || {})[activeLog.duc] || {});
        const _ex = cxlBore ? cxlOf(activeLog.duc, cxlBore) : null;
        return (
          <div data-print-hide="true" style={{ background:'#FEF2F2', border:'1px solid #FCA5A5', borderRadius:8, padding:12, marginBottom:10 }}>
            <div style={{ fontWeight:900, color:'#B91C1C', fontSize:13, marginBottom:6 }}>⛔ Cancelled bore (CXL)</div>
            <div style={{ fontSize:11.5, color:C.muted, marginBottom:8 }}>For a bore that was worked, then cancelled. Dailies stay exactly as entered — the bore gets CXL on the bore list and a red flag on its daily rows. Days still count in FIN/LF.</div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
              <select value={cxlBore} onChange={e => { const b = e.target.value; setCxlBore(b); const f = cxlOf(activeLog.duc, b); setCxlNote(f ? f.note : ''); }}
                style={{ padding:'6px 8px', borderRadius:6, border:`1px solid ${C.border}`, fontSize:13 }}>
                <option value="">Bore #…</option>
                {_bores.map(b => <option key={b} value={b}>{b}{cxlOf(activeLog.duc, b) ? ' · CXL' : ''}</option>)}
              </select>
              <input value={cxlNote} onChange={e => setCxlNote(e.target.value)} placeholder="Why? (e.g. hit obstruction 8/7 — customer cancelled bore)"
                style={{ flex:'1 1 320px', padding:'6px 8px', borderRadius:6, border:`1px solid ${C.border}`, fontSize:13 }} />
              <Btn small onClick={() => { if (!cxlBore) { setExportMsg('Pick the bore #'); return; } if (!cxlNote.trim()) { setExportMsg('Add a reason so the question doesn\'t come back'); return; } saveCxl(activeLog.duc, cxlBore, cxlNote, false); }}>{_ex ? 'Update CXL' : 'Flag CXL'}</Btn>
              {_ex && <Btn small variant="secondary" onClick={() => { if (window.confirm(`Remove the CXL flag from bore ${cxlBore}?`)) saveCxl(activeLog.duc, cxlBore, '', true); }}>Remove CXL</Btn>}
              <Btn small variant="secondary" onClick={() => setCxlOpen(false)}>Close</Btn>
            </div>
            {_have.length > 0 && <div style={{ marginTop:8, fontSize:11.5, color:'#7F1D1D' }}>
              {_have.map(([b, f]) => <div key={b}><strong>Bore {b} · CXL</strong> — {f.note}{f.by ? ` · ${f.by}` : ''}{f.at ? ` ${fmtD(String(f.at).slice(0,10))}` : ''}</div>)}
            </div>}
          </div>);
      })()}

      {/* ── DISTRIBUTION LIST (screen only) ── */}
      {showDistrib && (
        <div data-print-hide="true" style={{ background:'#FFF4EF', border:`1px solid #FDBA99`, borderRadius:8,
          padding:12, marginBottom:10 }}>
          <div style={{ fontWeight:700, fontSize:12, color:C.accent, marginBottom:8 }}>
            📧 DISTRIBUTION LIST — {_logNum(activeLog)}
          </div>
          <div style={{ display:'flex', gap:6, marginBottom:8 }}>
            <input value={newEmail} onChange={e=>setNewEmail(e.target.value)}
              placeholder="email@domain.com" type="email" style={{ flex:1 }}
              onKeyDown={e=>e.key==='Enter'&&addEmail()} />
            <Btn onClick={addEmail} variant="primary" small><Plus size={12}/>Add</Btn>
          </div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {distArr.map(email => (
              <span key={email} style={{ background:'#DBEAFE', color:'#1E40AF',
                padding:'3px 8px', borderRadius:20, fontSize:11, fontWeight:600,
                display:'flex', alignItems:'center', gap:5 }}>
                {email}
                <span onClick={()=>removeEmail(email)}
                  style={{ cursor:'pointer', color:C.red, fontWeight:800 }}>×</span>
              </span>
            ))}
            {!distArr.length && <span style={{ color:C.muted, fontSize:11 }}>No recipients yet</span>}
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════════════════════
           REPORT CARD (matches Perry's Excel layout)
         ══════════════════════════════════════════════════════ */}
      <div data-print-section style={{ background:C.card, border:`1px solid ${C.border}`,
        borderRadius:10, marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.06)',
        overflow:'hidden' }}>

        {/* HEADER: logo + title + LINK to BID/KMZ */}
        <div style={{ display:'grid', gridTemplateColumns: isDesktop ? 'auto 1fr auto' : 'auto 1fr',
          gridTemplateAreas: isDesktop ? '"logo title pm"' : '"logo pm" "title title"', /* #DAILY_MOBILE_HDR_V1 */
          alignItems:'center', gap: isDesktop ? 14 : '8px 10px', padding: isDesktop ? '10px 14px' : '10px 12px',
          borderBottom:`1px solid ${C.border}`, background:'#FFFFFF' }}>
          <img src={`data:image/jpeg;base64,${LOGO_COLOR_B64}`}
            style={{ gridArea:'logo', height: isDesktop ? 48 : 40, width:'auto', objectFit:'contain' }} alt="Dakota" />
          <div style={{ gridArea:'title', minWidth:0 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:14, flexWrap:'wrap' }}>
              <div style={{ color:C.text, fontFamily:"Arial Narrow, Arial, sans-serif",
                fontWeight:900, fontSize: isDesktop ? 26 : 21, letterSpacing:0.5, lineHeight:1.05 }}>
                DAILY OPERATIONS REPORT
              </div>
              {(() => {
                const _job = jobs.find(j => j.duc === activeLog.duc) || {};
                const _done = _job.stat === 'Complete';
                const _pending = unbilledPulls.length;
                return (
                  <div data-print-hide="true" style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center' }}>
                    {renderCompleteToggle(false)}
                    {_done && <span style={{ fontSize:10, color:C.muted, fontStyle:'italic' }}>locked · reopen from Job List (Admin)</span>}
                    {_done && _pending > 0 && (
                      <span style={{ fontSize:11, fontWeight:800, color:'#92400E', background:'#FEF3C7',
                        border:'1px solid #F59E0B', borderRadius:6, padding:'3px 11px', letterSpacing:0.3 }}>
                        ⚠ BILLING PENDING · {_pending} pull{_pending>1?'s':''}
                      </span>
                    )}
                  </div>
                );
              })()}
            </div>
            <div style={{ color:C.text, fontFamily:"Arial Narrow, Arial, sans-serif",
              fontSize: isDesktop ? 18 : 16, fontWeight:800, marginTop:3, letterSpacing:0.3 }}>
            {_logNum(activeLog)} – {activeLog.customer} – {activeLog.city}
            </div>
            {activeLog.desc && <div style={{ color:C.muted, fontSize:13, fontWeight:500, marginTop:2, fontFamily:'Arial Narrow, Arial, sans-serif' }}>{activeLog.desc.replace(activeLog.customer,'').replace(/^\s*[-–]\s*/,'')}</div>}
            <div style={{ display:'none', gap:14, marginTop:3 }}>
              {activeLog.bidLink ? (
                <a href={activeLog.bidLink} target="_blank" rel="noreferrer"
                  style={{ fontSize:10, color:C.blue, fontWeight:700, textDecoration:'underline' }}>
                  🔗 LINK to BID
                </a>
              ) : (
                <span style={{ fontSize:10, color:C.muted }}>LINK to BID (set in dist panel)</span>
              )}
              {activeLog.kmzLink ? (
                <a href={activeLog.kmzLink} target="_blank" rel="noreferrer"
                  style={{ fontSize:10, color:C.blue, fontWeight:700, textDecoration:'underline' }}>
                  📍 LINK to KMZ
                </a>
              ) : (
                <span style={{ fontSize:10, color:C.muted }}>LINK to KMZ</span>
              )}
            </div>
          </div>
          <div style={{ gridArea:'pm', textAlign:'right', minWidth:0 }}>
            <div style={{ marginBottom:4, display:'flex', alignItems:'baseline', flexWrap:'wrap',
              justifyContent:'flex-end', gap: isDesktop ? 8 : '0 8px' }}>
              <span style={{ color:C.text, fontFamily:"Arial Narrow, Arial, sans-serif",
                fontWeight:800, fontSize: isDesktop ? 18 : 15 }}>
                PM: {(()=>{ const p=String(activeLog.pm||''); if(!p) return '—'; if(PM_NAMES[p]) return PM_NAMES[p]; const k=Object.keys(PM_NAMES).find(k=>{ const full=PM_NAMES[k]; return full===p || full.startsWith(p+' ') || full.split(' ')[0]===p; }); return k?PM_NAMES[k]:p; })()}
              </span>
              <span style={{ color:C.muted, fontSize:10 }}>
                {new Date().toLocaleString('en-US',{month:'numeric',day:'numeric',year:'2-digit',hour:'numeric',minute:'2-digit'})}
              </span>
            </div>
            <div style={{ color:C.accent, fontSize:11, fontWeight:700 }}>dakotautility.com</div>
            <div style={{ color:C.muted, fontSize:10 }}>#WEAREDAKOTA</div>
          </div>
        </div>

        {/* ── COMPACT FILTER STRIP (above table header) ── */}
        {(activeLog.entries||[]).length > 0 && (() => {
          const _entries = activeLog.entries || [];
          const allBores = [...new Set(_entries.map(e=>e.bore).filter(Boolean))].sort((a,b)=>String(a).localeCompare(String(b),undefined,{numeric:true}));
          const allSups  = [...new Set(_entries.map(e=>e.sup).filter(Boolean))].sort();
          return (
            <div data-print-hide="true" style={{ display:'flex', alignItems:'center', gap:8,
              padding:'6px 14px', background:'#FFFFFF', borderTop:`1px solid ${C.border}` }}>
              <span style={{ fontSize:9, fontWeight:800, color:'#94A3B8', textTransform:'uppercase', letterSpacing:0.6 }}>Filter</span>
              <select value={filterBore} onChange={e=>setFilterBore(e.target.value)}
                style={{ fontSize:11, padding:'2px 6px', width:110, borderRadius:4, border:`1px solid ${C.border}`, background:'#FFFFFF', flex:'0 0 auto' }}>
                <option value="">All Bores</option>
                {allBores.map(b=><option key={b} value={b}>Bore {b}</option>)}
              </select>
              <select value={filterSup} onChange={e=>setFilterSup(e.target.value)}
                style={{ fontSize:11, padding:'2px 6px', width:130, borderRadius:4, border:`1px solid ${C.border}`, background:'#FFFFFF', flex:'0 0 auto' }}>
                <option value="">All SUPs</option>
                {allSups.map(s=><option key={s} value={s}>{s}</option>)}
              </select>
              {(filterBore||filterSup) && (
                <button onClick={()=>{setFilterBore('');setFilterSup('');}}
                  style={{ fontSize:10, padding:'2px 8px', background:'transparent', color:C.muted,
                    border:`1px solid ${C.border}`, borderRadius:4, fontWeight:700, cursor:'pointer', flex:'0 0 auto' }}>
                  ✕
                </button>
              )}
              <span style={{ color:C.muted, fontSize:10, marginLeft:'auto', fontWeight:600 }}>
                {filteredEntries.length} entries · {filteredEntries.filter(e=>isBillPull(e, _augerLog)).length} pulls
              </span>
            </div>
          );
        })()}

        {/* ── SUMMARY GRID — PLAN / ACTUAL / % (11 cols, polished) ── */}
        <div style={{ overflowX:'auto', background:'#FFFFFF' }}>
          <div style={{ display:'grid', minWidth:880,
            gridTemplateColumns:'78px repeat(11, minmax(72px, 1fr))',
            borderBottom:`1px solid ${C.border}` }}>

            {/* HEADER ROW */}
            <div style={{ background:'#F1F5F9', padding:'8px 8px', fontSize:9,
              fontWeight:800, color:'#475569', textTransform:'uppercase',
              letterSpacing:0.5, borderRight:`1px solid ${C.border}` }}></div>
            {['Day(s)','Total Job LF','PH Days','Bore(s)','FIN/LF','Award',
              'Start','Proj Complete','Pipe Size','Reamer Size','WK Count'].map(h => (
              <div key={h} style={{ background:'#F1F5F9', padding:'8px 5px',
                fontSize:9, fontWeight:800, color:'#475569', textTransform:'uppercase',
                letterSpacing:0.4, textAlign:'center', borderRight:`1px solid ${C.border}`,
                lineHeight:1.1 }}>
                {h}
              </div>
            ))}

            {/* PLAN ROW */}
            <div style={{ background:'linear-gradient(90deg,#FED7C7,#FFE8DD)',
              padding:'6px 8px', fontSize:11, fontWeight:900, color:'#9A3412',
              letterSpacing:0.6, borderRight:`1px solid ${C.border}` }}>
              ▲ PLAN
            </div>
            {[
              activeLog.planDays || '—',
              (activeLog.planLF||0).toLocaleString(),
              '—',
              activeLog.planBores || '—',
              metrics.planFinLF ? metrics.planFinLF.toFixed(0)+'/d' : '—',
              fmtD(activeLog.startDate) || '—',
              '—',
              '—',
              activeLog.pipeSize || '—',
              metrics.reamerAuto || '—',
              metrics.planWeeks ? String(metrics.planWeeks).padStart(2,'0') : '—',
            ].map((v,i)=>(
              <div key={i} style={{ background:'#FFF5EF', padding:'6px 5px',
                fontSize:13, fontWeight:800, color:'#9A3412', textAlign:'center',
                borderRight:`1px solid #FECACA` }}>
                {v}
              </div>
            ))}

            {/* ACTUAL ROW */}
            <div style={{ background:'linear-gradient(90deg,#BFDBFE,#DBEAFE)',
              padding:'6px 8px', fontSize:11, fontWeight:900, color:'#1E3A8A',
              letterSpacing:0.6, borderRight:`1px solid ${C.border}`, borderTop:`1px solid ${C.border}` }}>
              ▲ ACTUAL
            </div>
            {[
              metrics.totalDays,
              metrics.totalLF.toLocaleString(),
              metrics.phDays,
              metrics.boresDone,
              metrics.actFinLF ? metrics.actFinLF.toFixed(0)+'/d' : '—',
              fmtD(activeLog.startDate) || '—',
              fmtD(metrics.firstEntryDate) || '—',
              fmtD(metrics.fieldCompleteDate || metrics.actualProjComplete) || '—',
              activeLog.pipeSize || '—',
              metrics.reamerAuto || '—',
              metrics.jobWeeks ? String(metrics.jobWeeks).padStart(2,'0') : '—',
            ].map((v,i)=>(
              <div key={i} style={{ background:'#EFF6FF', padding:'6px 5px',
                fontSize:13, fontWeight:800,
                color: i===4 ? slipColor : '#1D4ED8', textAlign:'center',
                borderRight:`1px solid #BFDBFE`, borderTop:`1px solid ${C.border}` }}>
                {v}
              </div>
            ))}

            {/* % ROW */}
            <div style={{ background:'#F1F5F9', padding:'6px 8px', fontSize:10, fontWeight:800,
              color:'#475569', letterSpacing:0.6,
              borderRight:`1px solid ${C.border}`, borderTop:`1px solid ${C.border}` }}>
              %
            </div>
            {[
              activeLog.planDays ? Math.round(metrics.totalDays/activeLog.planDays*100)+'%' : '',
              metrics.pctComplete+'%',
              metrics.totalDays ? Math.round(metrics.phDays/metrics.totalDays*100)+'%' : '',
              activeLog.planBores ? Math.round(metrics.boresDone/activeLog.planBores*100)+'%' : '',
              metrics.planFinLF ? Math.round(metrics.actFinLF/metrics.planFinLF*100)+'%' : '',
              '', '', '', '', '',
              metrics.planWeeks ? Math.round(metrics.jobWeeks/metrics.planWeeks*100)+'%' : '',
            ].map((v,i)=>(
              <div key={i} style={{ padding:'6px 5px', fontSize:11, fontWeight:700,
                color: '#475569', textAlign:'center', background:'#F8FAFC',
                borderRight:`1px solid ${C.border}`, borderTop:`1px solid ${C.border}` }}>
                {v}
              </div>
            ))}
          </div>
        </div>

        {/* PROGRESS BAR + slippage note */}
        <div style={{ padding:'10px 14px', borderTop:`1px solid ${C.border}` }}>
          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
            <span style={{ fontSize:11, fontWeight:700, color:C.text }}>
              {(metrics.totalLF||0).toLocaleString()} / {(activeLog.planLF||0).toLocaleString()} LF
            </span>
            <span style={{ fontSize:12, fontWeight:800, color:slipColor }}>
              {metrics.pctComplete}% Complete
              {metrics.overPlan && ' ✓ OVER PLAN'}
              {!metrics.overPlan && metrics.slippage==='critical' && ' ⚠️ SLIPPING'}
              {!metrics.overPlan && metrics.slippage==='warning' && ' ⚡ WATCH'}
            </span>
          </div>
          <ProgressBar value={metrics.totalLF||0} max={activeLog.planLF||1}
            color={C.accent} />
          {metrics.overPlan ? (
            <div style={{ color:C.text, fontSize: isDesktop ? 13 : 10, fontWeight:600, marginTop:4 }}>
              <strong style={{color:C.green}}>Exceeded planned LF by {Math.abs(metrics.remaining||0).toLocaleString()} LF</strong> — scope grew beyond original plan
              {metrics.breakdownDays > 0 && <span> · <strong style={{color:C.red}}>{metrics.breakdownDays} breakdown {metrics.breakdownDays===1?'day':'days'}</strong> tracked</span>}
            </div>
          ) : metrics.projDays != null && (
            <div style={{ color:C.text, fontSize: isDesktop ? 13 : 10, fontWeight:600, marginTop:4 }}> {/* CURRENT_RATE_V1 */}
              At current rate — <strong style={{color:slipColor}}>{metrics.projDays} more rig days</strong> to complete
              · {(metrics.remaining||0).toLocaleString()} LF remaining
              {metrics.breakdownDays > 0 && <span> · <strong style={{color:C.red}}>{metrics.breakdownDays} breakdown {metrics.breakdownDays===1?'day':'days'}</strong> tracked</span>}
            </div>
          )}
          {metrics.totalDays > 0 && (
            <div style={{ color:C.text, fontSize: isDesktop ? 13 : 10, fontWeight:600, marginTop:4 }}>
              <strong style={{ color: metrics.delayDays>0 ? '#B45309' : C.muted }}>
                {metrics.delayDays} weather/delay {metrics.delayDays===1?'day':'days'}
              </strong> of {metrics.totalDays} actual {metrics.totalDays===1?'day':'days'} ·{' '}
              <strong style={{ color: metrics.delayDays>0 ? '#B45309' : C.muted }}>
                {Math.round(metrics.delayDays/metrics.totalDays*100)}%
              </strong> lost to delays
            </div>
          )}
          {!metrics.overPlan && metrics.adjustedCompleteDate && metrics.slippage !== 'on-track' && (
            <div style={{ marginTop:6, display:'flex', alignItems:'center', gap:7,
              fontSize: isDesktop ? 13 : 11, fontWeight:700,
              color: metrics.slippage === 'critical' ? '#991B1B' : '#854F0B',
              background: metrics.slippage === 'critical' ? '#FEE2E2' : '#FAEEDA',
              borderRadius:6, padding:'7px 10px' }}>
              <span>📅 Adjusted completion at this pace: {fmtD(metrics.adjustedCompleteDate)}
              {metrics.daysLate > 0 && <> — {metrics.daysLate} work {metrics.daysLate===1?'day':'days'} past target ({fmtD(metrics.actualProjComplete)})</>}</span>
            </div>
          )}
          {metrics.overPlan && metrics.planFinLF > 0 && metrics.actFinLF > 0 && metrics.actFinLF < metrics.planFinLF * 0.8 && (
            <div style={{ marginTop:6, display:'flex', alignItems:'center', gap:7,
              fontSize: isDesktop ? 13 : 11, fontWeight:700, color:'#854F0B', background:'#FAEEDA',
              borderRadius:6, padding:'7px 10px' }}>
              <span>⚙️ Daily rate below plan: {Math.round(metrics.actFinLF)} vs {Math.round(metrics.planFinLF)} LF/day planned</span>
            </div>
          )}
        </div>

      </div>

      {/* ══ BILLING ALERT (screen only — filters now inside summary card above) ══ */}
      {unbilledPulls.length > 0 && (
        <div data-print-hide="true" style={{ background:'#1D4ED8', borderRadius:6, padding:'8px 14px',
          marginBottom:8, display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:16 }}>⚡</span>
          <div style={{ flex:1 }}>
            <div style={{ color:'#fff', fontWeight:800, fontSize:13, letterSpacing:0.3 }}>
              {unbilledPulls.length} PULL{unbilledPulls.length>1?'S':''} PENDING INVOICE REVIEW
            </div>
            <div style={{ color:'rgba(255,255,255,0.85)', fontSize:10, marginTop:1 }}>
              {unbilledPulls.slice(0,5).map(e=>`Bore ${e.bore} · ${pullLFOf(e, _augerLog).toLocaleString()} LF · ${fmtD(e.date)}`).join('  |  ')}
              {unbilledPulls.length > 5 ? `  |  +${unbilledPulls.length-5} more` : ''}
            </div>
          </div>
        </div>
      )}

      {/* ══ ENTRIES TABLE — newest-on-top with WK alt-row shading ══ */}
      <div data-print-section style={{ background:C.card, border:`1px solid ${C.border}`,
        borderRadius:10, padding:'10px 12px', marginBottom:10,
        boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>

        {/* ── ENTRIES + ADD ENTRY (single aligned table) ── */}
        <div data-entries-scroller style={{ overflowX:'auto' }}>
          <div data-entries-table style={{ minWidth: isDesktop ? 1100 : 0 }}> {/* #DAILY_MOBILE_CARDS_FIT_V1 */}

            {entryError && (
              <div data-print-hide="true" style={{ background:'#FEF2F2', border:'1px solid #FECACA',
                color:'#B91C1C', fontSize:11, fontWeight:700, padding:'6px 10px', borderRadius:6,
                margin:'6px 0', letterSpacing:0.3 }}>
                ⚠ {entryError}
              </div>
            )}

            {/* ── DATALISTS for Add Entry combos (Bore # / SUP) ── */}
            {(() => {
              const _entries = activeLog?.entries || [];
              const _bores = [...new Set(_entries.map(e=>e.bore).filter(Boolean))].sort((a,b)=>String(a).localeCompare(String(b),undefined,{numeric:true}));
              const _sups = [...new Set([...supPicker.master, ...supPicker.orphans])];
              return (<>
                <datalist id="bore-datalist">{_bores.map(b=><option key={b} value={b} />)}</datalist>
                <datalist id="sup-datalist">{_sups.map(s=><option key={s} value={s} />)}</datalist>
              </>);
            })()}

            {/* ── BULK PASTE FROM EXCEL (migration) ── */}
            <div data-print-hide="true" style={{ marginBottom:8 }}>
              {!bulkOpen ? (
                <button onClick={()=>setBulkOpen(true)} style={{ fontSize:11, fontWeight:700, color:C.accent, background:'#FFF7F3', border:`1px dashed ${C.accent}`, borderRadius:6, padding:'5px 12px', cursor:'pointer' }}>⤓ Bulk paste from Excel</button>
              ) : (
                <div style={{ border:`1px solid ${C.border}`, borderRadius:8, padding:12, background:'#F8FAFC' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
                    <span style={{ fontSize:12, fontWeight:800, color:C.text }}>Bulk paste from Excel</span>
                    <span onClick={()=>{ setBulkOpen(false); setBulkRows([]); setBulkText(''); }} style={{ cursor:'pointer', color:C.muted, fontWeight:700, fontSize:18, lineHeight:1 }}>×</span>
                  </div>
                  <div style={{ fontSize:10.5, color:C.muted, marginBottom:6, lineHeight:1.4 }}>Copy a block of rows from the sheet. Column order: DATE · DAY · SUP · RIG · Bore# · LF Total · Stage · Soil · Drilled · Stage Total · Size · Pipe · Comment. (DAY is ignored — re-derived from the date.)</div>
                  <textarea value={bulkText} onChange={e=>setBulkText(e.target.value)} rows={4} placeholder="Paste rows here…" style={{ width:'100%', boxSizing:'border-box', fontSize:11, fontFamily:'monospace', padding:8, border:`1px solid ${C.border}`, borderRadius:6 }} />
                  <div style={{ display:'flex', gap:8, marginTop:6, alignItems:'center' }}>
                    <Btn onClick={doBulkPreview} small>Preview</Btn>
                    {bulkRows.length>0 && <Btn onClick={addBulkEntries} small>Add all {bulkRows.length} entries</Btn>}
                    {bulkText && <Btn variant="ghost" small onClick={()=>{ setBulkText(''); setBulkRows([]); }}>Clear</Btn>}
                    {bulkText && bulkRows.length===0 && <span style={{ fontSize:10, color:C.muted, fontStyle:'italic' }}>Click Preview to parse</span>}
                  </div>
                  {bulkRows.length>0 && (
                    <div style={{ marginTop:8, maxHeight:220, overflow:'auto', border:`1px solid ${C.border}`, borderRadius:6, background:'#fff' }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:10.5 }}>
                        <thead><tr style={{ background:'#F1F5F9', position:'sticky', top:0 }}>{['Date','SUP','Rig','Bore','BoreLF','Stage','Soil','Drilled','StgLF','Size','Pipe','Comment'].map(h=><th key={h} style={{ padding:'3px 5px', textAlign:'left', fontWeight:700, color:C.muted, whiteSpace:'nowrap' }}>{h}</th>)}</tr></thead>
                        <tbody>{bulkRows.map((r,i)=>(<tr key={i} style={{ borderTop:'1px solid #EEF1F5' }}>
                          <td style={{ padding:'2px 5px', whiteSpace:'nowrap' }}>{r.date}</td>
                          <td style={{ padding:'2px 5px' }}>{r.sup}</td>
                          <td style={{ padding:'2px 5px' }}>{r.rig}</td>
                          <td style={{ padding:'2px 5px' }}>{r.bore}</td>
                          <td style={{ padding:'2px 5px' }}>{r.boreLF===''||r.boreLF==null?'':Number(r.boreLF).toLocaleString()}</td>
                          <td style={{ padding:'2px 5px', fontWeight:700 }}>{r.stage}</td>
                          <td style={{ padding:'2px 5px' }}>{r.soil}</td>
                          <td style={{ padding:'2px 5px' }}>{r.drilledLF===''||r.drilledLF==null?'':Number(r.drilledLF).toLocaleString()}</td>
                          <td style={{ padding:'2px 5px' }}>{r.stageTotal===''||r.stageTotal==null?'':Number(r.stageTotal).toLocaleString()}</td>
                          <td style={{ padding:'2px 5px' }}>{r.pipeSize}</td>
                          <td style={{ padding:'2px 5px' }}>{r.finalPipe}</td>
                          <td style={{ padding:'2px 5px', maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{r.comment}</td>
                        </tr>))}</tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ── RECENT SUPs — tap to fill, or type any name in the SUP box ── */}
            {(() => {
              const { master, orphans, hasMaster } = supPicker;
              const _btn = (su, flagged) => { const on = newEntry.sup === su; return (
                <button key={(flagged?'o:':'m:')+su} onClick={()=>fillFromSup(su)}
                  title={flagged?'Not on the Revenue master list — likely a typo or a supervisor not yet set up in Revenue. Fix in the Revenue tab.':undefined}
                  style={{ fontSize:10, fontWeight:700, padding:'2px 9px', borderRadius:20,
                    border:`1px ${flagged?'dashed':'solid'} ${flagged?C.yellow:(on?C.accent:C.border)}`,
                    background:flagged?(on?C.yellow:'#FFFBEB'):(on?C.accent:'#F8FAFC'),
                    color:flagged?(on?'#fff':C.yellow):(on?'#fff':C.muted), cursor:'pointer' }}>{flagged?'⚠ '+su:su}</button>
              ); };
              const _legacy = !hasMaster && !orphans.length
                ? [...new Set((activeLog?.entries||[]).map(e=>e.sup).filter(Boolean))].sort() : null;
              if (_legacy && !_legacy.length) return null;
              return (
                <div data-print-hide="true" style={{ display:'flex', alignItems:'center', gap:5,
                  flexWrap:'wrap', padding:'4px 0 2px' }}>
                  <span style={{ fontSize:9, fontWeight:800, color:'#94A3B8',
                    textTransform:'uppercase', letterSpacing:0.5 }}>{hasMaster?'Supervisors':'Recent SUPs'}</span>
                  {(_legacy||master).map(su => _btn(su,false))}
                  {orphans.map(su => _btn(su,true))}
                  <span style={{ fontSize:9, color:C.muted, fontStyle:'italic' }}>or type any name below</span>
                </div>
              );
            })()}

            {/* ── LAST ACTIVITY BY RIG — read-only reference for the picked SUP (#10b) ── */}
            {(() => {
              const _sup = (newEntry.sup||'').toString().trim();
              if (!_sup) return null;
              const _es = (activeLog?.entries||[]).filter(e => (e.sup||'').toString().trim() === _sup);
              if (!_es.length) return (
                <div data-print-hide="true" style={{ fontSize:10, color:C.muted, fontStyle:'italic', padding:'2px 0 4px' }}>
                  No prior entries for {_sup} on this job yet.
                </div>
              );
              const _byRig = {};
              [..._es].sort((a,b)=>(b.date||'').localeCompare(a.date||'') || (b.id||0)-(a.id||0))
                .forEach(e => { const r=(e.rig||'—').toString(); if(!_byRig[r]) _byRig[r]=e; });
              const _rigs = Object.keys(_byRig);
              return (
                <div data-print-hide="true" style={{ background:'#F1F5FB', border:`1px solid ${C.border}`,
                  borderRadius:8, padding:'7px 10px', margin:'4px 0 2px' }}>
                  <div style={{ fontSize:9, fontWeight:800, color:C.accent, textTransform:'uppercase',
                    letterSpacing:0.5, marginBottom:5 }}>
                    Where {_sup} left off{_rigs.length>1 ? ` · ${_rigs.length} rigs` : ''}
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                    {_rigs.map(r => {
                      const e = _byRig[r];
                      const _pulled = e.stage==='Pull' || (_augerLog && e.stage==='PULL'); // #AUGER_PILL_PARITY_V1
                      const _done   = e.stage==='Complete';
                      return (
                        <div key={r} style={{ display:'flex', flexWrap:'wrap', alignItems:'center',
                          gap:8, fontSize:11, lineHeight:1.3 }}>
                          <span style={{ fontWeight:800, color:C.text, minWidth:52 }}>{r}</span>
                          <span style={{ color:C.muted }}>{fmtD(e.date)}</span>
                          <span style={{ color:C.muted }}>Bore <b style={{ color:C.blue }}>{e.bore||'—'}</b></span>
                          <span style={{ fontWeight:700, color: _done?C.green : _pulled?C.green : (e.stage==='Delay'||EVENT_STAGES.includes(e.stage))?C.yellow : C.text }}>
                            {e.stage||'—'}{_pulled?' ✓':''}
                          </span>
                          <span style={{ color:C.muted }}>Stg Tot <b style={{ color:C.text }}>{(e.stageTotal!=null&&e.stageTotal!=='')?Number(e.stageTotal).toLocaleString():'—'}</b></span>
                          <span style={{ color:C.muted }}>Pipe <b style={{ color:C.text }}>{e.pipeSize||'—'}</b></span>
                          {e.comment ? <span style={{ color:C.muted, fontStyle:'italic', flex:'1 1 100%',
                            overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>"{e.comment}"</span> : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

            {/* ── ADD ENTRY STRIP — aligned to entries table columns ── */}
            {!isDesktop && ( /* #DAILY_MOBILE_ADD_V1 — phone: one button → full add form (same as tapping WK on desktop) */
              <button data-print-hide="true" onClick={()=>{ /* #ADDENTRY_LASTBORE_V1 — tiebreak by id so same-day multi-bore days (e.g. Angel's 12/day) default to the actual last entry, not bore 1 */ const _es=(activeLog&&activeLog.entries)||[]; const _l=_es.length?_es.slice().sort((a,b)=>{ const _d=(b.date||'').localeCompare(a.date||''); return _d!==0?_d:((Number(b.id)||0)-(Number(a.id)||0)); })[0]:{}; setEditEntry({ ...blankEntry(), _isNew:true, sup:_l.sup||'', rig:_l.rig||'', soil:_l.soil||'', bore:_l.bore||'', boreLF:_l.boreLF||'', stageTotal:_l.stageTotal||'', finalPipe:_l.finalPipe||'' }); }}
                style={{ width:'100%', background:C.accent, color:'#fff', border:'none', borderRadius:8,
                  padding:'12px 0', fontSize:16, fontWeight:800, letterSpacing:0.5, cursor:'pointer', margin:'4px 0 6px' }}>
                + ADD ENTRY
              </button>
            )}
            <div data-print-hide="true" style={{ display: isDesktop ? 'grid' : 'none',
              gridTemplateColumns:'46px 78px 36px 76px 70px 38px 62px 78px 56px 64px 64px 42px 42px 1fr 44px 40px',
              gap:0, padding:'6px 0', alignItems:'center',
              background:'#F8FAFC', borderTop:`1px dashed ${C.border}`,
              borderBottom:`1px dashed ${C.border}` }}>

              {/* WK col — label */}
              <div onClick={()=>{ /* #ADDENTRY_LASTBORE_V1 — tiebreak by id so same-day multi-bore days (e.g. Angel's 12/day) default to the actual last entry, not bore 1 */ const _es=(activeLog&&activeLog.entries)||[]; const _l=_es.length?_es.slice().sort((a,b)=>{ const _d=(b.date||'').localeCompare(a.date||''); return _d!==0?_d:((Number(b.id)||0)-(Number(a.id)||0)); })[0]:{}; setEditEntry({ ...blankEntry(), _isNew:true, sup:_l.sup||'', rig:_l.rig||'', soil:_l.soil||'', bore:_l.bore||'', boreLF:_l.boreLF||'', stageTotal:_l.stageTotal||'', finalPipe:_l.finalPipe||'' }); }} title="Open full add form"
                style={{ fontSize:9, fontWeight:800, color:C.accent, textAlign:'center', cursor:'pointer',
                padding:'0 2px', textTransform:'uppercase', letterSpacing:0.3, lineHeight:1.1 }}>+ ADD<br/>ENTRY</div>

              {/* DATE */}
              <input type="date" value={newEntry.date}
                onChange={e=>setNewEntry(p=>({...p,date:e.target.value,day:getDayName(e.target.value)}))}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* DAY (auto) */}
              <div style={{ fontSize:11, textAlign:'center', color:C.muted, padding:'0 2px', fontWeight:500 }}>{newEntry.day||'—'}</div>

              {/* SUP */}
              <input value={newEntry.sup}
                onChange={e=>setNewEntry(p=>({...p,sup:e.target.value}))}
                onBlur={e=>fillFromSup(e.target.value)}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* RIG */}
              <PickSearch value={newEntry.rig} options={DAILY_RIGS} placeholder="Rig"
                onChange={v=>setNewEntry(p=>({...p,rig:v}))}
                style={{ fontSize:10, padding:'3px 1px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* BORE */}
              <input value={newEntry.bore}
                onChange={e=>setNewEntry(p=>({...p,bore:e.target.value}))}
                onBlur={e=>{
                  const b=(e.target.value||'').toString().trim();
                  if(!b) return;
                  const all=(activeLog?.entries||[]).filter(x=>(x.bore||'').toString().trim()===b);
                  if(!all.length) return;
                  const sorted=[...all].sort((a,c)=>(c.date||'').localeCompare(a.date||''));
                  const lastAny=sorted[0];
                  const lastReam=sorted.find(x=>x.stage==='Ream');
                  setNewEntry(p=>({
                    ...p,
                    boreLF: (p.boreLF===''||p.boreLF==null) && lastAny?.boreLF ? lastAny.boreLF : p.boreLF,
                    pipeSize: (p.pipeSize===''||p.pipeSize==null) && lastReam?.pipeSize ? lastReam.pipeSize : p.pipeSize
                  }));
                }}
                list="bore-datalist"
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* BORE LF */}
              <input type="number" value={newEntry.boreLF}
                onChange={e=>setNewEntry(p=>({...p,boreLF:e.target.value}))}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px', color:'#0F172A', fontWeight:600 }} />

              {/* STAGE */}
              <PickSearch value={newEntry.stage} options={ACTIVE_STAGES} placeholder="Stage"
                onChange={v=>{const nd=isNoDrill(v);setNewEntry(p=>({...p,stage:v,...(nd?{soil:'NIL',drilledLF:'NIL',stageTotal:'NIL',pipeSize:'NIL',finalPipe:'NIL'}:(isNoDrill(p.stage)?{soil:'',drilledLF:'',stageTotal:'',pipeSize:'',finalPipe:''}:{}))}));}}
                style={{ fontSize:10, padding:'3px 1px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* SOIL */}
              <PickSearch value={newEntry.soil} placeholder="Soil"
                disabled={isNoDrill(newEntry.stage)}
                options={isNoDrill(newEntry.stage) ? [...SOILS,'NIL'] : SOILS}
                onChange={v=>setNewEntry(p=>({...p,soil:v}))}
                style={{ fontSize:10, padding:'3px 1px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* DRILLED LF */}
              <input inputMode="numeric" value={newEntry.drilledLF}
                disabled={isNoDrill(newEntry.stage)}
                onChange={e=>setNewEntry(p=>({...p,drilledLF:e.target.value}))}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* STG LF (Stage Total) */}
              <input inputMode="numeric" value={newEntry.stageTotal}
                disabled={isNoDrill(newEntry.stage)}
                onChange={e=>setNewEntry(p=>({...p,stageTotal:e.target.value}))}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px' }} />

              {/* SIZE (Reamer) */}
              <input value={newEntry.pipeSize}
                disabled={isNoDrill(newEntry.stage)}
                onChange={e=>setNewEntry(p=>({...p,pipeSize:e.target.value}))}
                onBlur={e=>{const v=e.target.value.trim();if(v&&!v.includes('"')){const m=v.match(/^(\d+(?:\.\d+)?)(\s*.*)?$/);if(m)setNewEntry(p=>({...p,pipeSize:m[1]+'"'+(m[2]||'')}))}}}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px', color:'#0F172A', fontWeight:600 }} />

              {/* PIPE (Pull) */}
              <input value={newEntry.finalPipe||''}
                disabled={isNoDrill(newEntry.stage)}
                onChange={e=>setNewEntry(p=>({...p,finalPipe:e.target.value}))}
                onBlur={e=>{const v=e.target.value.trim();if(v&&!v.includes('"')){const m=v.match(/^(\d+(?:\.\d+)?)(\s*.*)?$/);if(m)setNewEntry(p=>({...p,finalPipe:m[1]+'"'+(m[2]||'')}))}}}
                style={{ fontSize:10, padding:'3px 2px', textAlign:'center', width:'100%', boxSizing:'border-box', margin:'0 2px', color:'#0F172A', fontWeight:600 }} />

              {/* COMMENTS — wide 1fr column (live char counter — CHAR_COUNTER_V1) */}
              <div style={{ position:'relative', margin:'0 2px' }}>
                <input value={newEntry.comment}
                  onChange={e=>setNewEntry(p=>({...p,comment:e.target.value}))}
                  onKeyDown={e=>e.key==='Enter'&&addEntry()}
                  style={{ fontSize:10, padding:'3px 30px 3px 4px', width:'100%', boxSizing:'border-box' }} />
                {newEntry.comment && newEntry.comment.length > 0 && (
                  <span style={{ position:'absolute', right:5, top:'50%', transform:'translateY(-50%)',
                    fontSize:9, fontWeight:700, pointerEvents:'none', fontVariantNumeric:'tabular-nums',
                    color: newEntry.comment.length >= 80 ? C.red
                      : newEntry.comment.length >= 60 ? '#B45309' : C.muted }}>
                    {newEntry.comment.length}
                  </span>
                )}
              </div>

              {/* BILL spacer */}
              <div></div>

              {/* + button */}
              <button onClick={addEntry}
                title="Add Entry (or press Enter in Comments)"
                style={{ background:C.accent, color:'#fff', border:'none', borderRadius:4,
                  padding:'4px 0', fontSize:16, fontWeight:800, cursor:'pointer',
                  width:'100%', lineHeight:1, margin:'0 2px' }}>+</button>
            </div>

            {filteredEntries.length === 0 ? (
              isDesktop ? (
                <>
                  {_ENTRY_HEADER}
                  <div style={{ color:C.muted, fontSize:12, textAlign:'center', padding:'20px 0' }}>
                    No entries yet — #WEAREDAKOTA · add the first day above
                  </div>
                </>
              ) : (
                <div style={{ color:C.muted, fontSize:12, textAlign:'center', padding:'20px 0' }}>
                  No entries yet — #WEAREDAKOTA · add the first day above
                </div>
              )
            ) : isDesktop ? (
              <>
                {_ENTRY_HEADER}
                {addedRig.added.length > 0 && (
                  <div data-print-hide="true" style={{ display:'flex', flexWrap:'wrap', alignItems:'center', gap:6, fontSize:11, color:C.muted, padding:'6px 4px' }}>
                    <span style={{ fontWeight:800, letterSpacing:0.4 }}>RIGS ON JOB:</span>
                    <span style={{ padding:'2px 8px', borderRadius:4, border:'1px solid #E2E8F0', background:'#fff', color:C.text, fontWeight:600 }}>Original · {addedRig.orig.map(k=>k.replace('|',' · ')).join(', ')}</span>
                    {addedRig.added.map(a => (
                      <span key={a.k} style={{ padding:'2px 8px', borderRadius:4, background:a.c.bg, borderLeft:`4px solid ${a.c.bar}`, color:a.c.tx, fontWeight:700 }}>+ {a.sup} · {a.rig} <span style={{ fontWeight:500 }}>from {fmtD(a.from)}</span></span>
                    ))}
                  </div>
                )}

                {/* Rows — rig-day groups: single entry = one clean line; multiple entries step into a tree */}
                {(() => {
                  const sorted = filteredEntries.slice().sort((a,b) => {
                    const d=(b.date||'').localeCompare(a.date||''); if(d) return d;
                    const su=String(a.sup||'').localeCompare(String(b.sup||'')); if(su) return su;
                    const ri=String(a.rig||'').localeCompare(String(b.rig||'')); if(ri) return ri;
                    return (Number(a.bore)||0)-(Number(b.bore)||0);
                  });
                  const groups=[]; const gx={};
                  sorted.forEach(e => { const k=`${e.date||''}|${e.sup||''}|${e.rig||''}`; if(!(k in gx)){gx[k]=groups.length; groups.push({k,date:e.date,sup:e.sup,rig:e.rig,day:e.day,rows:[]});} groups[gx[k]].rows.push(e); });
                  // #BORE_SORT_V1 — within each rig-day, order bores high→low (newest on top; id tiebreaker)
                  groups.forEach(g => g.rows.sort((a,b)=>(Number(b.bore)||0)-(Number(a.bore)||0)||(b.id||0)-(a.id||0)));
                  let lastWk=null;
                  return groups.map((g,gi) => {
                    const wk=isoWeekNum(g.date); const wkChange=wk!==lastWk; lastWk=wk;
                    const gpulls=g.rows.filter(r=>isBillPull(r, _augerLog));   // #AUGER_PULL_BILL_V1
                    const gLF=gpulls.reduce((s,r)=>s+pullLFOf(r, _augerLog),0);
                    const gSun=isSunday(g.date);
                    const gBores=new Set(g.rows.map(r=>String(r.bore||'').trim()).filter(Boolean)).size;
                    const single=g.rows.length===1;
                    const _prevDate = gi>0 ? groups[gi-1].date : null;
                    const _gapDays = (_prevDate && g.date) ? Math.round((new Date(_prevDate+'T12:00:00') - new Date(g.date+'T12:00:00'))/86400000) : 0;
                    const offJobBar = _gapDays > 14 ? (
                      <div data-print-row="entry" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                        background:'#FEF3C7', color:'#92400E', fontWeight:800, fontSize:11, letterSpacing:0.5,
                        padding:'5px 0', borderRadius:4, border:'1px dashed #D97706', margin:'8px 0 6px' }}>
                        ⏸ OFF JOB — {_gapDays} DAYS ({fmtD(g.date)} → {fmtD(_prevDate)})
                      </div>
                    ) : null;
                    const _ar = addedRig.of(g.rows[0]);   // #DAILY_ADDRIG_V1 — this rig-day's added-rig color (null = original rig)
                    const _idSt = _ar ? { background:_ar.bg, alignSelf:'stretch', display:'flex', alignItems:'center', justifyContent:'center' } : {};
                    const wrapStyle={ marginTop: gi>0?(wkChange?14:4):0, borderTop: wkChange&&gi>0?'3px solid #1E293B':(gi>0?'1px solid #EDF1F5':'none') };
                    const _row=(e,i,stepped)=>{
                      const isPull=isPullStage(e, _augerLog); const isDelay=e.stage==='Delay'||matchesDelay(e.comment);   // #AUGER_PULL_BILL_V1
                      const isBreakdown=matchesAny(e.comment,BREAKDOWN_KEYWORDS); const isDamage=matchesWord(e.comment,DAMAGE_KEYWORDS);
                      const isPothole=e.stage==='PH'; const isComplete=e.stage==='Complete'; const altShade=i%2===1;
                      const _cx=cxlOf(activeLog.duc, e.bore);   // #BORE_CXL_V1
                      return (
                        <div key={e.id||i} data-print-row="entry" onClick={(ev)=>openEdit(e,ev)} style={{ cursor:'pointer', display:'grid',
                          gridTemplateColumns:'46px 78px 36px 76px 70px 38px 62px 78px 56px 64px 64px 42px 42px 1fr 44px 40px', gap:0,
                          padding: isPull?'6px 0':'4px 0',
                          borderBottom: isPull?`2px solid ${e.billed?'#FB923C':C.accent}`:`1px solid #E5E9F0`,
                          background: isPull&&e.billed?'#FFF0E6':isPull?'#FFD4C2':isComplete?'#F0FDF4':isPothole?'#FEF3FF':altShade?'#FAFBFC':'#fff',
                          borderLeft:`4px solid ${_cx?'#DC2626':isComplete?C.green:isPull?(e.billed?'#FB923C':C.accent):isPothole?'#A855F7':isBreakdown?C.red:'transparent'}`,
                          fontWeight: isPull?600:400 }}>
                          {stepped ? (<><div style={_idSt}></div><div style={_idSt}></div><div style={_idSt}></div><div style={_idSt}></div><div style={_idSt}></div></>) : (<>
                            <div style={{ ..._idSt, fontSize:12, textAlign:'center', padding:'0 3px', fontWeight: gSun?800:600, color: gSun?'#1E3A8A':C.muted }}>{wkLabel(wk)}</div>
                            <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:500 }}>{fmtD(g.date)}</div>
                            <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight: gSun?800:400, color: gSun?'#1E3A8A':C.muted }}>{g.day}</div>
                            <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:500 }}>{g.sup}</div>
                            <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', color:_ar?_ar.tx:C.muted, fontWeight:_ar?800:400 }}>{g.rig}</div>
                          </>)}
                        <div style={{ fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:700, color:_cx?'#DC2626':'#1D4ED8' }}>{stepped && <span style={{ color:C.muted, fontWeight:400, fontSize:11 }}>└ </span>}{e.bore}{_cx && <div style={{ fontSize:9, fontWeight:900, color:'#fff', background:'#DC2626', borderRadius:4, padding:'0 3px', lineHeight:'13px' }}>CXL</div>}</div>
                        <div style={{ fontSize:13, textAlign:'center', color:C.muted, padding:'0 3px' }}>{fLF(e.boreLF)}</div>
                        <div style={{ textAlign:'center', padding:'0 3px' }}>
                          <span style={{
                            display:'inline-block', padding:'2px 6px', borderRadius:20, fontSize:12, fontWeight:700,
                            background: isComplete ? '#DCFCE7'
                              : isPull ? '#DCFCE7'
                              : e.stage==='Inner' ? '#DCFCE7'
                              : e.stage==='Delay' ? '#FEE2E2'
                              : isPothole ? '#F3E8FF'
                              : e.stage==='Pilot' ? '#EFF6FF'
                              : e.stage==='Ream' ? '#FEF3C7'
                              : e.stage==='Swab' ? '#F3E8FF'
                              : e.stage==='Casing' ? '#CCFBF1'
                              : '#F8FAFC',
                            color: isComplete ? C.green
                              : isPull ? C.green
                              : e.stage==='Inner' ? C.green
                              : e.stage==='Delay' ? '#B91C1C'
                              : isPothole ? '#6B21A8'
                              : e.stage==='Pilot' ? '#1E40AF'
                              : e.stage==='Ream' ? '#B45309'
                              : e.stage==='Swab' ? '#6B21A8'
                              : e.stage==='Casing' ? '#0F766E'
                              : C.muted,
                          }}>{isPull ? <span style={{letterSpacing:0.8}}>PULL</span> : e.stage==='Inner' ? <span style={{letterSpacing:0.8}}>INNER</span> : (e.stage||'—')}</span>
                        </div>
                        <div style={{ fontSize:13, textAlign:'center', color:C.muted, padding:'0 3px' }}>{e.soil}</div>
                        <div style={{ fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:700,
                          color: e.drilledLF > 0 ? C.blue : C.muted }}>
                          {e.drilledLF > 0 ? e.drilledLF.toLocaleString() : '—'}
                        </div>
                        <div style={{ fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:700,
                          color: e.stageTotal > 0 ? C.text : C.muted }}>
                          {e.stageTotal > 0 ? e.stageTotal.toLocaleString() : '—'}
                        </div>
                        <div style={{ fontSize:13, textAlign:'center', padding:'0 3px',
                          fontWeight: e.stage==='Ream' ? 700 : 400,
                          color: e.stage==='Ream' ? '#B45309' : C.muted }}>
                          {e.pipeSize||'—'}
                        </div>
                        <div style={{ fontSize:13, textAlign:'center', padding:'0 3px',
                          fontWeight: isPull ? 700 : 400,
                          color: isPull ? '#0F172A' : C.muted }}>
                          {e.finalPipe || (isPull ? e.pipeSize : '—') || '—'}
                        </div>
                        <div style={{ fontSize:13, padding:'2px 6px',
                          overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap',
                          background: isDelay ? '#BFDBFE' : 'transparent',
                          color: isDelay ? '#1E3A8A' : C.muted,
                          fontWeight: isDelay ? 700 : 400,
                          borderRadius: isDelay ? 4 : 0 }}>
                          {_cx && <span title={_cx.note} style={{ marginRight:5, fontSize:10, fontWeight:900, color:'#fff', background:'#DC2626', padding:'1px 6px', borderRadius:4 }}>⛔ BORE {String(e.bore).trim()} CANCELLED</span>}
                          {e.comment}
                          {isBreakdown && <span style={{ marginLeft:4, fontSize:10, fontWeight:700, color: C.red }}>⚠ BREAKDOWN</span>}
                          {isDamage && <span style={{ marginLeft:4, fontSize:9.5, fontWeight:800, color:'#991B1B', background:'#FEE2E2', padding:'1px 5px', borderRadius:4 }}>⚠ POSSIBLE DAMAGE</span>}
                        </div>
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:'0 4px' }}>
                          {isPull ? (
                            <label data-print-hide="true" style={{ display:'flex', alignItems:'center', gap:3, cursor:'pointer' }}>
                              <input type="checkbox" checked={!!e.billed} style={{ width:14, height:14, flexShrink:0 }}
                                onChange={ev => {
                                  const updated = entries.map(x => x.id===e.id ? {...x, billed:ev.target.checked, billedDate: ev.target.checked ? todayStr() : null} : x);
                                  setActiveLog(p => ({...p, entries: updated}));
                                }} />
                              <span style={{ fontSize:11, fontWeight:700, color: e.billed ? '#C2410C' : C.accent }}>
                                {e.billed ? '✓' : 'INV'}
                              </span>
                            </label>
                          ) : null}
                          {isPull && e.billed && <span style={{ display:'none' }} className="print-only">✓</span>}
                        </div>
                        <div style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                          <Btn onClick={()=>removeEntry(e.id)} variant="ghost" small>
                            <Trash2 size={12} color={C.muted}/>
                          </Btn>
                        </div>
                        </div>
                      );
                    };
                    if (single) return (<div key={g.k} style={wrapStyle}>{offJobBar}{_row(g.rows[0],0,false)}</div>);
                    return (
                      <div key={g.k} style={wrapStyle}>
                        {offJobBar}
                        {/* rig-day header (multi-entry only) — matches row styling; summary shows entries */}
                        <div data-print-row="entry" style={{ display:'grid',
                          gridTemplateColumns:'46px 78px 36px 76px 70px 1fr', gap:0, alignItems:'center',
                          background:'#F1F5F9', color:'#334155', padding:'4px 0', borderBottom:'1px solid #E2E8F0' }}>
                          <div style={{ ..._idSt, fontSize:12, textAlign:'center', padding:'0 3px', fontWeight: gSun?800:600, color: gSun?'#1E3A8A':C.muted }}>{wkLabel(wk)}</div>
                          <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:500 }}>{fmtD(g.date)}</div>
                          <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight: gSun?800:400, color: gSun?'#1E3A8A':C.muted }}>{g.day}</div>
                          <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', fontWeight:500 }}>{g.sup||'—'}</div>
                          <div style={{ ..._idSt, fontSize:13, textAlign:'center', padding:'0 3px', color:_ar?_ar.tx:C.muted, fontWeight:_ar?800:400 }}>{g.rig||'—'}</div>
                          <div style={{ fontSize:10.5, textAlign:'right', paddingRight:10, fontWeight:700, color:'#64748B', letterSpacing:0.3 }}>RIG DAY · {gBores} bore{gBores!==1?'s':''} · {g.rows.length} entries{gpulls.length?` · ${gpulls.length} pulled`:''}{gLF?` · ${gLF.toLocaleString()} LF`:''}</div>
                        </div>
                        {g.rows.map((e,i)=>_row(e,i,true))}
                      </div>
                    );
                  });
                })()}
              </>
            ) : (
              /* ─── #DAILY_PHONE_TABLE_V1 (2026-10-21) — Bill: "Fix Mobile view on Daily to look like web to ease use and view."
                 The big per-entry cards (MOBILE_CARDS_V1) are gone: the phone gets the web's table rows, trimmed to the columns
                 that fit a phone — Date/Day · SUP · Bore · Stage · Drilled · Stg LF · Size — with the comment under each row,
                 the same WK dividers, stage colors, Pull / Complete / PH tints and INV box. Tap a row to edit (same as web). ─── */
              <div data-print-hide="true">
                {(() => {
                  const COLS = '50px minmax(0,1fr) 30px 56px 52px 50px 36px';
                  const hd = { fontSize:9.5, fontWeight:800, color:C.muted, textAlign:'center', letterSpacing:0.4, padding:'0 2px' };
                  const cell = { fontSize:12.5, textAlign:'center', padding:'0 2px', minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' };
                  const pill = (e, isPull, isComplete, isPothole) => ({ display:'inline-block', padding:'1px 6px', borderRadius:20, fontSize:10.5, fontWeight:800, maxWidth:'100%', overflow:'hidden', textOverflow:'ellipsis',
                    background: isComplete||isPull||e.stage==='Inner' ? '#DCFCE7' : e.stage==='Delay' ? '#FEE2E2' : isPothole ? '#F3E8FF' : e.stage==='Pilot' ? '#EFF6FF' : e.stage==='Ream' ? '#FEF3C7' : e.stage==='Swab' ? '#F3E8FF' : e.stage==='Casing' ? '#CCFBF1' : '#F8FAFC',
                    color: isComplete||isPull||e.stage==='Inner' ? C.green : e.stage==='Delay' ? '#B91C1C' : isPothole ? '#6B21A8' : e.stage==='Pilot' ? '#1E40AF' : e.stage==='Ream' ? '#B45309' : e.stage==='Swab' ? '#6B21A8' : e.stage==='Casing' ? '#0F766E' : C.muted });
                  let lastWk = null;
                  return (<>
                    <div style={{ display:'grid', gridTemplateColumns:COLS, alignItems:'center', padding:'6px 0', background:'#F8FAFC', borderTop:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`, position:'sticky', top:0, zIndex:2 }}>
                      <div style={hd}>DATE</div><div style={hd}>SUP · RIG</div><div style={hd}>BORE</div><div style={hd}>STAGE</div><div style={hd}>DRILLED</div><div style={hd}>STG LF</div><div style={hd}>SIZE</div>
                    </div>
                    {filteredEntries.map((e, i) => {
                      const wk = isoWeekNum(e.date);
                      const wkChange = wk !== lastWk; lastWk = wk;
                      const isPull = isPullStage(e, _augerLog);   // #AUGER_PULL_BILL_V1
                      const isDelay = e.stage === 'Delay' || matchesDelay(e.comment);
                      const isBreakdown = matchesAny(e.comment, BREAKDOWN_KEYWORDS);
                      const isDamage = matchesWord(e.comment, DAMAGE_KEYWORDS);
                      const isPothole = e.stage === 'PH';
                      const isComplete = e.stage === 'Complete';
                      const gSun = isSunday(e.date);
                      const bg = isPull && e.billed ? '#FFF0E6' : isPull ? '#FFD4C2' : isComplete ? '#F0FDF4' : isPothole ? '#FEF3FF' : i % 2 ? '#FAFBFC' : '#fff';
                      const _cx = cxlOf(activeLog.duc, e.bore);   // #BORE_CXL_V1
                      const bar = _cx ? '#DC2626' : isComplete ? C.green : isPull ? (e.billed ? '#FB923C' : C.accent) : isPothole ? '#A855F7' : isBreakdown ? C.red : 'transparent';
                      return (
                        <div key={e.id||i}>
                          {wkChange && (
                            <div style={{ borderTop: i>0 ? '3px solid #1E293B' : 'none', marginTop: i>0 ? 8 : 0, padding:'4px 4px 2px', fontSize:10.5, fontWeight:900, color:'#1E293B', letterSpacing:0.6 }}>{wkLabel(wk)}</div>
                          )}
                          <div onClick={(ev)=>openEdit(e,ev)} style={{ cursor:'pointer', background:bg, borderLeft:`4px solid ${bar}`,
                            borderBottom: isPull ? `2px solid ${e.billed ? '#FB923C' : C.accent}` : '1px solid #E5E9F0', padding:'6px 0 5px', fontWeight: isPull ? 600 : 400 }}>
                            <div style={{ display:'grid', gridTemplateColumns:COLS, alignItems:'center' }}>
                              <div style={{ ...cell, lineHeight:1.15 }}>
                                <div style={{ fontWeight:700, fontSize:12.5 }}>{fmtD(e.date).slice(0,5)}</div>
                                <div style={{ fontSize:10.5, fontWeight: gSun ? 800 : 500, color: gSun ? '#1E3A8A' : C.muted }}>{e.day}</div>
                              </div>
                              <div style={{ ...cell, lineHeight:1.15 }}>
                                <div style={{ fontWeight:700, overflow:'hidden', textOverflow:'ellipsis' }}>{e.sup||'—'}</div>
                                <div style={{ fontSize:10.5, color:C.muted, overflow:'hidden', textOverflow:'ellipsis' }}>{e.rig||''}</div>
                              </div>
                              <div style={{ ...cell, fontWeight:800, color: _cx ? '#DC2626' : '#1D4ED8' }}>{e.bore||'—'}{_cx && <span style={{ marginLeft:3, fontSize:9, fontWeight:900, color:'#fff', background:'#DC2626', borderRadius:3, padding:'0 3px' }}>CXL</span>}</div>
                              <div style={cell}><span style={pill(e, isPull, isComplete, isPothole)}>{isPull ? 'PULL' : e.stage==='Inner' ? 'INNER' : (e.stage||'—')}</span></div>
                              <div style={{ ...cell, fontWeight:700, color: e.drilledLF>0 ? C.blue : C.muted }}>{e.drilledLF>0 ? e.drilledLF.toLocaleString() : '—'}</div>
                              <div style={{ ...cell, fontWeight:700, color: e.stageTotal>0 ? C.text : C.muted }}>{e.stageTotal>0 ? e.stageTotal.toLocaleString() : '—'}</div>
                              <div style={{ ...cell, fontWeight: e.stage==='Ream' ? 700 : 400, color: e.stage==='Ream' ? '#B45309' : C.muted }}>{e.pipeSize||'—'}</div>
                            </div>
                            {(e.comment || isPull || _cx) && (
                              <div style={{ display:'flex', alignItems:'flex-start', gap:6, padding:'3px 6px 0 8px' }}>
                                <div style={{ flex:1, minWidth:0, fontSize:12, lineHeight:1.3, color: isDelay ? '#1E3A8A' : C.muted, fontWeight: isDelay ? 700 : 400,
                                  background: isDelay ? '#BFDBFE' : 'transparent', borderRadius: isDelay ? 4 : 0, padding: isDelay ? '1px 5px' : 0 }}>
                                  {_cx && <span title={_cx.note} style={{ marginRight:5, fontSize:10, fontWeight:900, color:'#fff', background:'#DC2626', padding:'1px 6px', borderRadius:4 }}>⛔ BORE CANCELLED</span>}
                                  {e.comment}
                                  {isBreakdown && <span style={{ marginLeft:4, fontSize:10, fontWeight:700, color:C.red }}>⚠ BREAKDOWN</span>}
                                  {isDamage && <span style={{ marginLeft:4, fontSize:9.5, fontWeight:800, color:'#991B1B', background:'#FEE2E2', padding:'1px 5px', borderRadius:4 }}>⚠ POSSIBLE DAMAGE</span>}
                                </div>
                                {isPull && (
                                  <label onClick={ev=>ev.stopPropagation()} style={{ display:'flex', alignItems:'center', gap:4, cursor:'pointer', flexShrink:0 }}>
                                    <input type="checkbox" checked={!!e.billed} style={{ width:18, height:18, flex:'0 0 18px', minWidth:18, maxWidth:18, margin:0, padding:0 }}
                                      onChange={ev => {
                                        const updated = entries.map(x => x.id===e.id ? {...x, billed:ev.target.checked, billedDate: ev.target.checked ? todayStr() : null} : x);
                                        setActiveLog(p => ({...p, entries: updated}));
                                      }} />
                                    <span style={{ fontSize:11, fontWeight:800, color: e.billed ? '#C2410C' : C.accent }}>{e.billed ? '✓ INV' : 'INV'}</span>
                                  </label>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{ fontSize:10.5, color:C.muted, textAlign:'center', padding:'8px 0 2px' }}>Tap a row to edit or delete it.</div>
                  </>);
                })()}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* #23 PASS TRACKER — large rigs only */}
      {['100x140','220x300','220x500','330x500','at120','r4','r5'].includes(String(activeLog.rig||'').toLowerCase()) && (() => {
        const PASS_COLS = [['mobIn','MOB'],['pilot','PILOT'],['r12','R12'],['r18','R18'],['r24','R24'],['r30','R30'],['r36','R36'],['r42','R42'],['r48','R48'],['r54','R54'],['misc','MISC'],['swab','SWAB'],['pull','PULL'],['mobOut','MOB']];
        const plan = activeLog.passPlan || {};
        // #PASS_ACTUAL_LIVE_V1 — ACTUAL is counted live from the daily entries (no button); recounts whenever entries change.
        // #PASS_BY_BORE_V1 — same counter runs on each BORE + SUP slice so the estimators see which bore ate the days.
        const _allEs = activeLog.entries || [];
        const _lastDrill = _allEs.filter(e=>['Pilot','Ream','Casing','Swab','Pull'].includes(e.stage)).map(e=>e.date).filter(Boolean).sort().slice(-1)[0]||null;
        const countPasses = (es) => {
          const byStage = st => [...new Set(es.filter(e=>e.stage===st && e.date).map(e=>e.date))].length;
          const bucket = sz => {
            const n = parseFloat(String(sz||'').replace(/[^0-9.]/g,''));
            if (!n) return null;
            const B = [12,18,24,30,36,42,48,54];
            let best=B[0], bd=Math.abs(n-best);
            B.forEach(b=>{const d=Math.abs(n-b); if(d<bd){bd=d;best=b;}});
            return 'r'+best;
          };
          const a = { mobIn:0, pilot:byStage('Pilot'), r12:0,r18:0,r24:0,r30:0,r36:0,r42:0,r48:0,r54:0, misc:0, swab:byStage('Swab'), pull:byStage('Pull'), mobOut:0 };
          const bd = {};
          es.filter(e=>e.stage==='Ream' && e.date).forEach(e=>{ const b=bucket(e.pipeSize); if(b){ (bd[b]=bd[b]||new Set()).add(e.date); }});
          ['r12','r18','r24','r30','r36','r42','r48','r54'].forEach(k=>{ a[k]= bd[k]? bd[k].size : 0; });
          const mob = [...new Set(es.filter(e=>['MOB','SETUP'].includes(e.stage) && e.date).map(e=>e.date))].sort();
          const last = _lastDrill;   // job-level last drill day decides MOB in vs MOB out for every slice
          mob.forEach(d=>{ if(last && d>last) a.mobOut++; else a.mobIn++; });
          // MISC = distinct days with a blank/missing stage (data-hygiene catch)
          a.misc = [...new Set(es.filter(e=>e.date && !String(e.stage||'').trim()).map(e=>e.date))].length;
          return a;
        };
        const act = countPasses(_allEs);
        const _natB = (x,y) => { const na=parseFloat(x), nb=parseFloat(y); if(!isNaN(na)&&!isNaN(nb)&&na!==nb) return na-nb; return String(x).localeCompare(String(y)); };
        const _slices = {};
        _allEs.forEach(e=>{ if(!e.date) return; const bore=String(e.bore||'').trim()||'—'; const sup=String(e.sup||'').trim()||'—'; const k=bore+'|'+sup; (_slices[k]=_slices[k]||{bore,sup,first:e.date,es:[]}).es.push(e); if(e.date<_slices[k].first) _slices[k].first=e.date; });
        const boreRows = Object.values(_slices).sort((x,y)=>_natB(x.bore,y.bore) || x.first.localeCompare(y.first)).map(r=>({...r, a:countPasses(r.es)}));
        const showBoreRows = boreRows.length > 1;
        const sum  = o => Math.round(PASS_COLS.reduce((t,[k])=>t+(Number(o[k])||0),0)*10)/10;
        const setPlan = (k,v)=>setActiveLog(p=>({...p, passPlan:{...(p.passPlan||{}), [k]: v===''?'':Number(v)}}));
        const th = { border:`1px solid ${C.border}`, padding:'3px 4px', fontSize:9.5, fontWeight:700, color:C.text, textAlign:'center', background:'#F1F5F9', whiteSpace:'nowrap' };
        const rl = { border:`1px solid ${C.border}`, padding:'3px 8px', fontSize:10, fontWeight:800, color:C.muted, background:'#F8FAFC', whiteSpace:'nowrap', textAlign:'left' };
        const cd = { border:`1px solid ${C.border}`, padding:0, textAlign:'center' };
        const inp = { width:'100%', border:'none', textAlign:'center', fontSize:11, padding:'5px 2px', boxSizing:'border-box', background:'transparent', fontVariantNumeric:'tabular-nums' };
        return (
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:'10px 14px', marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
            <style>{`.ptr-num::-webkit-inner-spin-button,.ptr-num::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.ptr-num{-moz-appearance:textfield;appearance:textfield}`}</style>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8, gap:8, flexWrap:'wrap' }}>
              <div style={{ fontWeight:800, fontSize:13, color:C.accent }}>📊 PASS TRACKER — {activeLog.rig}</div>
              <span data-print-hide="true" style={{ fontSize:10, fontWeight:700, color:C.green }}>● Actual counts live from entries</span>
            </div>
            <div style={{ overflowX:'auto' }}>
              <table style={{ borderCollapse:'collapse', width:'100%', minWidth:780 }}>
                <thead><tr>
                  <th style={{...th, textAlign:'left'}}>{showBoreRows ? 'BORE #' : ''}</th>
                  {showBoreRows && <th style={{...th, textAlign:'left'}}>SUP</th>}
                  {PASS_COLS.map(([k,lbl])=><th key={k} style={th}>{lbl}</th>)}
                  <th style={{...th, background:'#FEF3C7'}}>TOT DAY(S)</th>
                </tr></thead>
                <tbody>
                  <tr>
                    <td style={rl} colSpan={showBoreRows?2:1}>PLAN</td>
                    {PASS_COLS.map(([k])=><td key={k} style={cd}><input type="number" className="ptr-num" value={plan[k] ?? ''} onChange={e=>setPlan(k,e.target.value)} style={inp} /></td>)}
                    <td style={{...cd, fontWeight:800, background:'#FEF9E7'}}>{sum(plan)}</td>
                  </tr>
                  {showBoreRows && boreRows.map(r => (
                    <tr key={r.bore+'|'+r.sup}>
                      <td style={{...rl, color:C.text, textAlign:'center'}}>{r.bore}</td>
                      <td style={{...rl, color:C.text}}>{r.sup}</td>
                      {PASS_COLS.map(([k])=><td key={k} style={cd}><div style={{ textAlign:'center', fontSize:10.5, padding:'4px 2px', color:C.text, fontVariantNumeric:'tabular-nums' }}>{r.a[k] || ''}</div></td>)}
                      <td style={{...cd, fontWeight:700, fontSize:10.5, background:'#FEF9E7'}}>{sum(r.a)}</td>
                    </tr>
                  ))}
                  <tr style={showBoreRows ? { borderTop:`2px solid ${C.text}` } : undefined}>
                    <td style={{...rl, ...(showBoreRows?{borderTop:`2px solid ${C.text}`}:{})}} colSpan={showBoreRows?2:1}>{showBoreRows ? 'ACTUAL (JOB)' : 'ACTUAL'}</td>
                    {PASS_COLS.map(([k])=><td key={k} style={{...cd, ...(showBoreRows?{borderTop:`2px solid ${C.text}`}:{})}}><div style={{ textAlign:'center', fontSize:11, padding:'5px 2px', fontWeight:showBoreRows?800:400, fontVariantNumeric:'tabular-nums' }}>{act[k] || ''}</div></td>)}
                    <td style={{...cd, fontWeight:800, background:'#FEF9E7', ...(showBoreRows?{borderTop:`2px solid ${C.text}`}:{})}}>{sum(act)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div data-print-hide="true" style={{ fontSize:10, color:C.muted, marginTop:6 }}>
              PLAN is editable and carries from the Job List. ACTUAL counts days per pass live from the daily entries (reamer day → nearest R column by the Size logged). To change a count, fix the entry.{showBoreRows ? ' BORE rows = each bore by SUP; ACTUAL (JOB) counts rig days once, so it can be less than the rows added up when two SUPs logged the same day.' : ''} #WeAreDakota
            </div>
          </div>
        );
      })()}

      {/* #25 PRODUCTION TABLE — #PROD_TABLE_V1 — SUP days per bore + pulled LF/day; auto-built from entries */}
      {(() => {
        const entries = activeLog.entries || [];
        const boreMap = {};
        entries.forEach(e => {
          const bore = String(e.bore||'').trim();
          if (!bore) return;
          const b = boreMap[bore] || (boreMap[bore] = { sups:{}, dates:new Set(), pulled:0 });
          if (e.date) b.dates.add(e.date);
          const sup = String(e.sup||'').trim();
          if (sup && e.date) (b.sups[sup] = b.sups[sup] || new Set()).add(e.date);
          if (e.stage==='Pull' || (_augerLog && (Number(e.drilledLF)||0) !== 0)) b.pulled += (Number(e.drilledLF)||0);   // #AUGER_PULL_BILL_V1 — same rule as the PDF production table
        });
        const bores = Object.keys(boreMap);
        if (!bores.length) return null;
        const natur = (a,b) => { const na=parseFloat(a), nb=parseFloat(b); if(!isNaN(na)&&!isNaN(nb)&&na!==nb) return na-nb; return String(a).localeCompare(String(b)); };
        bores.sort(natur);
        const r1 = (n)=>Math.round(n*10)/10;
        const detail = bores.map(bore => {
          const b = boreMap[bore];
          const days = b.dates.size;
          const pulled = Math.round(b.pulled);
          const se = Object.entries(b.sups).sort((x,y)=> y[1].size - x[1].size);
          const supFull = se.map(x=>x[0]).join(', ');
          const supLabel = se.length>1 ? `${se[0][0]} +${se.length-1}` : (se[0]?se[0][0]:'—');
          return { bore, supLabel, supFull, days, pulled, finlf: days? r1(pulled/days) : 0, cxl: cxlOf(activeLog.duc, bore) };   // #BORE_CXL_V1
        });
        const roll = {};
        bores.forEach(bore => {
          const b = boreMap[bore];
          const names = Object.keys(b.sups);
          const n = names.length || 1;
          names.forEach(s => { const r = roll[s] || (roll[s]={days:0,pulled:0}); r.days += b.dates.size/n; r.pulled += b.pulled/n; });
        });
        const supRows = Object.keys(roll).map(s => { const r=roll[s]; return { sup:s, days:r1(r.days), pulled:Math.round(r.pulled), finlf: r.days? r1(r.pulled/r.days):0 }; }).sort((a,b)=> b.finlf - a.finlf);
        const gDays = bores.reduce((t,bore)=>t+boreMap[bore].dates.size,0);
        const gPulled = Math.round(bores.reduce((t,bore)=>t+boreMap[bore].pulled,0));
        const gFin = gDays? r1(gPulled/gDays) : 0;
        const pth = { border:`1px solid ${C.border}`, padding:'2px 7px', fontSize:9.5, fontWeight:700, color:C.text, textAlign:'center', background:'#F1F5F9', whiteSpace:'nowrap' };
        const ptd = { border:`1px solid ${C.border}`, padding:'2px 7px', fontSize:10.5, textAlign:'center', whiteSpace:'nowrap', fontVariantNumeric:'tabular-nums' };
        const pname = { ...ptd, fontWeight:700 };
        const ptot = { ...ptd, fontWeight:800, background:'#FEF9E7' };
        const sub = { fontWeight:800, fontSize:10, color:C.muted, marginBottom:3, letterSpacing:0.3 };
        const CHUNK = 20;
        const chunks = [];
        for (let i = 0; i < detail.length; i += CHUNK) chunks.push(detail.slice(i, i + CHUNK));
        const _cap = (s) => { s = String(s||'').trim(); return s.length > 60 ? s.slice(0,60).trim() + '…' : s; };
        const hdrBits = [activeLog.customer, activeLog.city, _cap(activeLog.desc)].filter(Boolean).join('  ·  ');
        return (
          <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:10, padding:'10px 14px', marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.06)', breakInside:'avoid' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:12, flexWrap:'wrap', marginBottom:8 }}>
              <div style={{ fontWeight:800, fontSize:13, color:C.accent }}>🏗️ PRODUCTION</div>
              {hdrBits && <div style={{ fontSize:11, fontWeight:600, color:C.muted, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:'62%' }}>{hdrBits}</div>}
            </div>
            <div style={{ ...sub, marginTop:0 }}>BY SUPERVISOR · shared bores split evenly</div>
            <table style={{ borderCollapse:'collapse', marginBottom:12, breakInside:'avoid' }}>
              <thead><tr><th style={pth}>SUP</th><th style={pth}>DAYS</th><th style={pth}>PULLED LF</th><th style={pth}>FIN/LF</th></tr></thead>
              <tbody>
                {supRows.map(s => (
                  <tr key={s.sup}>
                    <td style={pname}>{s.sup}</td>
                    <td style={ptd}>{s.days}</td>
                    <td style={ptd}>{s.pulled? s.pulled.toLocaleString():''}</td>
                    <td style={ptd}>{s.finlf}</td>
                  </tr>
                ))}
                <tr>
                  <td style={ptot}>GRAND TOTAL</td>
                  <td style={ptot}>{gDays}</td>
                  <td style={ptot}>{gPulled.toLocaleString()}</td>
                  <td style={ptot}>{gFin}</td>
                </tr>
              </tbody>
            </table>
            <div style={sub}>BY BORE</div>
            <div style={{ display:'flex', gap:14, flexWrap:'wrap', alignItems:'flex-start' }}>
              {chunks.map((chunk, ci) => (
                <table key={ci} style={{ borderCollapse:'collapse', breakInside:'avoid' }}>
                  <thead><tr><th style={pth}>SUP</th><th style={pth}>BORE</th><th style={pth}>DAYS</th><th style={pth}>PULLED LF</th><th style={pth}>FIN/LF</th></tr></thead>
                  <tbody>
                    {chunk.map(d => { const _g = d.cxl ? { background:'#F1F5F9', color:'#64748B' } : {}; const _r = { ...ptd, color:'#DC2626', fontWeight:900, background:'#FEF2F2' };
                      return (
                      <tr key={d.bore} title={d.cxl ? `Bore ${d.bore} CANCELLED — ${d.cxl.note}` : undefined}>
                        <td style={{ ...pname, ..._g }} title={d.supFull}>{d.supLabel}</td>
                        <td style={{ ...ptd, ..._g }}>{d.bore}</td>
                        <td style={{ ...ptd, ..._g }}>{d.days}</td>
                        <td style={d.cxl ? _r : ptd}>{d.cxl ? 'CXL' : (d.pulled? d.pulled.toLocaleString() : '')}</td>
                        <td style={{ ...ptd, ..._g }}>{d.cxl ? '—' : (d.days? d.finlf : '—')}</td>
                      </tr>); })}
                  </tbody>
                </table>
              ))}
            </div>
            <table style={{ borderCollapse:'collapse', marginTop:6, breakInside:'avoid' }}>
              <tbody>
                <tr>
                  <td style={ptot} colSpan={2}>GRAND TOTAL</td>
                  <td style={ptot}>{gDays}</td>
                  <td style={ptot}>{gPulled.toLocaleString()}</td>
                  <td style={ptot}>{gFin}</td>
                </tr>
              </tbody>
            </table>
            {detail.some(d => d.cxl) && <div style={{ marginTop:6, fontSize:10.5, color:'#991B1B' }}>   {/* #BORE_CXL_V1 */}
              {detail.filter(d => d.cxl).map(d => <div key={d.bore}><strong>⛔ Bore {d.bore} CXL</strong> ({d.days} {d.days===1?'day':'days'}, {d.supLabel}) — {d.cxl.note}{d.cxl.by ? ` · flagged by ${d.cxl.by}` : ''}{d.cxl.at ? ` ${fmtD(String(d.cxl.at).slice(0,10))}` : ''}. Days stay in FIN/LF.</div>)}
            </div>}
            <div style={{ fontSize:9.5, color:C.muted, marginTop:6 }}>
              PULLED LF = Pull-stage footage · DAYS = every day on the bore · FIN/LF = pulled ÷ days · shared bores split evenly. #WeAreDakota
            </div>
          </div>
        );
      })()}

      {/* ── ATTACHMENTS ── */}
      <div data-print-hide="true" style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:10,
        padding:'10px 14px', marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.06)' }}>
        <AttachmentsSection module="dailylog" id={activeLog.duc}
          title="Log Attachments — Excel originals, PDFs, Photos, KMZ" />
      </div>
    </div>
  );
}
